// @ts-nocheck
import { GraphQLResolveInfo, SelectionSetNode, FieldNode, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@graphql-mesh/utils';

import type { GetMeshOptions } from '@graphql-mesh/runtime';
import type { YamlConfig } from '@graphql-mesh/types';
import { PubSub } from '@graphql-mesh/utils';
import { DefaultLogger } from '@graphql-mesh/utils';
import MeshCache from "@graphql-mesh/cache-localforage";
import { fetch as fetchFn } from '@whatwg-node/fetch';

import { MeshResolvedSource } from '@graphql-mesh/runtime';
import { MeshTransform, MeshPlugin } from '@graphql-mesh/types';
import GraphqlHandler from "@graphql-mesh/graphql"
import StitchingMerger from "@graphql-mesh/merger-stitching";
import { printWithCache } from '@graphql-mesh/utils';
import { createMeshHTTPHandler, MeshHTTPHandler } from '@graphql-mesh/http';
import { getMesh, ExecuteMeshFn, SubscribeMeshFn, MeshContext as BaseMeshContext, MeshInstance } from '@graphql-mesh/runtime';
import { MeshStore, FsStoreStorageAdapter } from '@graphql-mesh/store';
import { path as pathModule } from '@graphql-mesh/cross-helpers';
import { ImportFn } from '@graphql-mesh/types';
import type { GuildSubgraphTypes } from './sources/guild-subgraph/types';
import type { DaoSubgraphTypes } from './sources/dao-subgraph/types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };



/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
};

export type Query = {
  proposal?: Maybe<Proposal>;
  proposals: Array<Proposal>;
  proposalStateLog?: Maybe<ProposalStateLog>;
  proposalStateLogs: Array<ProposalStateLog>;
  option?: Maybe<Option>;
  options: Array<Option>;
  action?: Maybe<Action>;
  actions: Array<Action>;
  vote?: Maybe<Vote>;
  votes: Array<Vote>;
  member?: Maybe<Member>;
  members: Array<Member>;
  guild?: Maybe<Guild>;
  guilds: Array<Guild>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  guildPermission?: Maybe<GuildPermission>;
  guildPermissions: Array<GuildPermission>;
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dao?: Maybe<DAO>;
  daos: Array<DAO>;
  scheme?: Maybe<Scheme>;
  schemes: Array<Scheme>;
  votingMachine?: Maybe<VotingMachine>;
  votingMachines: Array<VotingMachine>;
  reputationToken?: Maybe<ReputationToken>;
  reputationTokens: Array<ReputationToken>;
  snapshot?: Maybe<Snapshot>;
  snapshots: Array<Snapshot>;
  voterSnapshot?: Maybe<VoterSnapshot>;
  voterSnapshots: Array<VoterSnapshot>;
  permission?: Maybe<Permission>;
  permissions: Array<Permission>;
  stateLog?: Maybe<StateLog>;
  stateLogs: Array<StateLog>;
  votingMachineProposalStateLog?: Maybe<VotingMachineProposalStateLog>;
  votingMachineProposalStateLogs: Array<VotingMachineProposalStateLog>;
  voteLog?: Maybe<VoteLog>;
  voteLogs: Array<VoteLog>;
  stake?: Maybe<Stake>;
  stakes: Array<Stake>;
  redeem?: Maybe<Redeem>;
  redeems: Array<Redeem>;
};


export type QueryproposalArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryproposalsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Proposal_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Proposal_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryproposalStateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryproposalStateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ProposalStateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryoptionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryoptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Option_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Option_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryactionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryactionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Action_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Action_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvoteArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvotesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Vote_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Vote_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerymemberArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerymembersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Member_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Member_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryguildArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryguildsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Guild_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Guild_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerytokenArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerytokensArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Token_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryguildPermissionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryguildPermissionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GuildPermission_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<GuildPermission_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_metaArgs = {
  block?: InputMaybe<Block_height>;
};


export type QuerydaoArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerydaosArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DAO_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DAO_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryschemeArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryschemesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scheme_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Scheme_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvotingMachineArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvotingMachinesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VotingMachine_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VotingMachine_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryreputationTokenArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryreputationTokensArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReputationToken_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ReputationToken_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerysnapshotArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerysnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Snapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Snapshot_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvoterSnapshotArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvoterSnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoterSnapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoterSnapshot_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerypermissionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerypermissionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Permission_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Permission_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerystateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerystateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<StateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvotingMachineProposalStateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvotingMachineProposalStateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VotingMachineProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VotingMachineProposalStateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvoteLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryvoteLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoteLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoteLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerystakeArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerystakesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Stake_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Stake_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryredeemArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryredeemsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Redeem_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Redeem_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};

export type Subscription = {
  proposal?: Maybe<Proposal>;
  proposals: Array<Proposal>;
  proposalStateLog?: Maybe<ProposalStateLog>;
  proposalStateLogs: Array<ProposalStateLog>;
  option?: Maybe<Option>;
  options: Array<Option>;
  action?: Maybe<Action>;
  actions: Array<Action>;
  vote?: Maybe<Vote>;
  votes: Array<Vote>;
  member?: Maybe<Member>;
  members: Array<Member>;
  guild?: Maybe<Guild>;
  guilds: Array<Guild>;
  token?: Maybe<Token>;
  tokens: Array<Token>;
  guildPermission?: Maybe<GuildPermission>;
  guildPermissions: Array<GuildPermission>;
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  dao?: Maybe<DAO>;
  daos: Array<DAO>;
  scheme?: Maybe<Scheme>;
  schemes: Array<Scheme>;
  votingMachine?: Maybe<VotingMachine>;
  votingMachines: Array<VotingMachine>;
  reputationToken?: Maybe<ReputationToken>;
  reputationTokens: Array<ReputationToken>;
  snapshot?: Maybe<Snapshot>;
  snapshots: Array<Snapshot>;
  voterSnapshot?: Maybe<VoterSnapshot>;
  voterSnapshots: Array<VoterSnapshot>;
  permission?: Maybe<Permission>;
  permissions: Array<Permission>;
  stateLog?: Maybe<StateLog>;
  stateLogs: Array<StateLog>;
  votingMachineProposalStateLog?: Maybe<VotingMachineProposalStateLog>;
  votingMachineProposalStateLogs: Array<VotingMachineProposalStateLog>;
  voteLog?: Maybe<VoteLog>;
  voteLogs: Array<VoteLog>;
  stake?: Maybe<Stake>;
  stakes: Array<Stake>;
  redeem?: Maybe<Redeem>;
  redeems: Array<Redeem>;
};


export type SubscriptionproposalArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionproposalsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Proposal_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Proposal_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionproposalStateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionproposalStateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ProposalStateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionoptionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionoptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Option_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Option_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionactionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionactionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Action_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Action_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvoteArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvotesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Vote_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Vote_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionmemberArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionmembersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Member_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Member_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionguildArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionguildsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Guild_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Guild_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiontokenArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiontokensArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Token_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Token_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionguildPermissionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionguildPermissionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GuildPermission_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<GuildPermission_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Subscription_metaArgs = {
  block?: InputMaybe<Block_height>;
};


export type SubscriptiondaoArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiondaosArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DAO_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DAO_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionschemeArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionschemesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scheme_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Scheme_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvotingMachineArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvotingMachinesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VotingMachine_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VotingMachine_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionreputationTokenArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionreputationTokensArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ReputationToken_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ReputationToken_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionsnapshotArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionsnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Snapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Snapshot_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvoterSnapshotArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvoterSnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoterSnapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoterSnapshot_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionpermissionArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionpermissionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Permission_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Permission_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionstateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionstateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<StateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvotingMachineProposalStateLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvotingMachineProposalStateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VotingMachineProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VotingMachineProposalStateLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvoteLogArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionvoteLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoteLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoteLog_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionstakeArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionstakesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Stake_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Stake_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionredeemArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionredeemsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Redeem_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Redeem_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};

export type Action = {
  id: Scalars['ID'];
  optionId: Option;
  to: Scalars['String'];
  data: Scalars['String'];
  value: Scalars['BigInt'];
  from: Scalars['String'];
};

export type Action_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  optionId?: InputMaybe<Scalars['String']>;
  optionId_not?: InputMaybe<Scalars['String']>;
  optionId_gt?: InputMaybe<Scalars['String']>;
  optionId_lt?: InputMaybe<Scalars['String']>;
  optionId_gte?: InputMaybe<Scalars['String']>;
  optionId_lte?: InputMaybe<Scalars['String']>;
  optionId_in?: InputMaybe<Array<Scalars['String']>>;
  optionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  optionId_contains?: InputMaybe<Scalars['String']>;
  optionId_contains_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_contains?: InputMaybe<Scalars['String']>;
  optionId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  optionId_starts_with?: InputMaybe<Scalars['String']>;
  optionId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_starts_with?: InputMaybe<Scalars['String']>;
  optionId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_ends_with?: InputMaybe<Scalars['String']>;
  optionId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_ends_with?: InputMaybe<Scalars['String']>;
  optionId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_?: InputMaybe<Option_filter>;
  to?: InputMaybe<Scalars['String']>;
  to_not?: InputMaybe<Scalars['String']>;
  to_gt?: InputMaybe<Scalars['String']>;
  to_lt?: InputMaybe<Scalars['String']>;
  to_gte?: InputMaybe<Scalars['String']>;
  to_lte?: InputMaybe<Scalars['String']>;
  to_in?: InputMaybe<Array<Scalars['String']>>;
  to_not_in?: InputMaybe<Array<Scalars['String']>>;
  to_contains?: InputMaybe<Scalars['String']>;
  to_contains_nocase?: InputMaybe<Scalars['String']>;
  to_not_contains?: InputMaybe<Scalars['String']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']>;
  to_starts_with?: InputMaybe<Scalars['String']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_starts_with?: InputMaybe<Scalars['String']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_ends_with?: InputMaybe<Scalars['String']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_ends_with?: InputMaybe<Scalars['String']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Scalars['String']>;
  data_not?: InputMaybe<Scalars['String']>;
  data_gt?: InputMaybe<Scalars['String']>;
  data_lt?: InputMaybe<Scalars['String']>;
  data_gte?: InputMaybe<Scalars['String']>;
  data_lte?: InputMaybe<Scalars['String']>;
  data_in?: InputMaybe<Array<Scalars['String']>>;
  data_not_in?: InputMaybe<Array<Scalars['String']>>;
  data_contains?: InputMaybe<Scalars['String']>;
  data_contains_nocase?: InputMaybe<Scalars['String']>;
  data_not_contains?: InputMaybe<Scalars['String']>;
  data_not_contains_nocase?: InputMaybe<Scalars['String']>;
  data_starts_with?: InputMaybe<Scalars['String']>;
  data_starts_with_nocase?: InputMaybe<Scalars['String']>;
  data_not_starts_with?: InputMaybe<Scalars['String']>;
  data_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  data_ends_with?: InputMaybe<Scalars['String']>;
  data_ends_with_nocase?: InputMaybe<Scalars['String']>;
  data_not_ends_with?: InputMaybe<Scalars['String']>;
  data_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['BigInt']>;
  value_not?: InputMaybe<Scalars['BigInt']>;
  value_gt?: InputMaybe<Scalars['BigInt']>;
  value_lt?: InputMaybe<Scalars['BigInt']>;
  value_gte?: InputMaybe<Scalars['BigInt']>;
  value_lte?: InputMaybe<Scalars['BigInt']>;
  value_in?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  from?: InputMaybe<Scalars['String']>;
  from_not?: InputMaybe<Scalars['String']>;
  from_gt?: InputMaybe<Scalars['String']>;
  from_lt?: InputMaybe<Scalars['String']>;
  from_gte?: InputMaybe<Scalars['String']>;
  from_lte?: InputMaybe<Scalars['String']>;
  from_in?: InputMaybe<Array<Scalars['String']>>;
  from_not_in?: InputMaybe<Array<Scalars['String']>>;
  from_contains?: InputMaybe<Scalars['String']>;
  from_contains_nocase?: InputMaybe<Scalars['String']>;
  from_not_contains?: InputMaybe<Scalars['String']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']>;
  from_starts_with?: InputMaybe<Scalars['String']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_starts_with?: InputMaybe<Scalars['String']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_ends_with?: InputMaybe<Scalars['String']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_ends_with?: InputMaybe<Scalars['String']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Action_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Action_filter>>>;
};

export type Action_orderBy =
  | 'id'
  | 'optionId'
  | 'optionId__id'
  | 'optionId__label'
  | 'optionId__voteAmount'
  | 'to'
  | 'data'
  | 'value'
  | 'from';

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type Block_height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

export type Guild = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  token?: Maybe<Token>;
  permissionRegistry?: Maybe<Scalars['String']>;
  proposalTime?: Maybe<Scalars['BigInt']>;
  lockTime?: Maybe<Scalars['BigInt']>;
  timeForExecution?: Maybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation?: Maybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution?: Maybe<Scalars['BigInt']>;
  votingPowerForProposalCreation?: Maybe<Scalars['BigInt']>;
  votingPowerForProposalExecution?: Maybe<Scalars['BigInt']>;
  voteGas?: Maybe<Scalars['BigInt']>;
  maxGasPrice?: Maybe<Scalars['BigInt']>;
  maxActiveProposals?: Maybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation?: Maybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation?: Maybe<Scalars['BigInt']>;
  type?: Maybe<GuildType>;
  permissions: Array<GuildPermission>;
  proposals?: Maybe<Array<Proposal>>;
  members?: Maybe<Array<Member>>;
  isActive?: Maybe<Scalars['Boolean']>;
  bytecodeHash?: Maybe<Scalars['String']>;
};


export type GuildpermissionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GuildPermission_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<GuildPermission_filter>;
};


export type GuildproposalsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Proposal_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Proposal_filter>;
};


export type GuildmembersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Member_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Member_filter>;
};

export type GuildPermission = {
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
  functionSignature: Scalars['Bytes'];
  isToken: Scalars['Boolean'];
  valueAllowed: Scalars['BigInt'];
  fromTime: Scalars['BigInt'];
  allowed: Scalars['Boolean'];
  guild?: Maybe<Guild>;
};

export type GuildPermission_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  from?: InputMaybe<Scalars['String']>;
  from_not?: InputMaybe<Scalars['String']>;
  from_gt?: InputMaybe<Scalars['String']>;
  from_lt?: InputMaybe<Scalars['String']>;
  from_gte?: InputMaybe<Scalars['String']>;
  from_lte?: InputMaybe<Scalars['String']>;
  from_in?: InputMaybe<Array<Scalars['String']>>;
  from_not_in?: InputMaybe<Array<Scalars['String']>>;
  from_contains?: InputMaybe<Scalars['String']>;
  from_contains_nocase?: InputMaybe<Scalars['String']>;
  from_not_contains?: InputMaybe<Scalars['String']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']>;
  from_starts_with?: InputMaybe<Scalars['String']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_starts_with?: InputMaybe<Scalars['String']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_ends_with?: InputMaybe<Scalars['String']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_ends_with?: InputMaybe<Scalars['String']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  to_not?: InputMaybe<Scalars['String']>;
  to_gt?: InputMaybe<Scalars['String']>;
  to_lt?: InputMaybe<Scalars['String']>;
  to_gte?: InputMaybe<Scalars['String']>;
  to_lte?: InputMaybe<Scalars['String']>;
  to_in?: InputMaybe<Array<Scalars['String']>>;
  to_not_in?: InputMaybe<Array<Scalars['String']>>;
  to_contains?: InputMaybe<Scalars['String']>;
  to_contains_nocase?: InputMaybe<Scalars['String']>;
  to_not_contains?: InputMaybe<Scalars['String']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']>;
  to_starts_with?: InputMaybe<Scalars['String']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_starts_with?: InputMaybe<Scalars['String']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_ends_with?: InputMaybe<Scalars['String']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_ends_with?: InputMaybe<Scalars['String']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  functionSignature?: InputMaybe<Scalars['Bytes']>;
  functionSignature_not?: InputMaybe<Scalars['Bytes']>;
  functionSignature_gt?: InputMaybe<Scalars['Bytes']>;
  functionSignature_lt?: InputMaybe<Scalars['Bytes']>;
  functionSignature_gte?: InputMaybe<Scalars['Bytes']>;
  functionSignature_lte?: InputMaybe<Scalars['Bytes']>;
  functionSignature_in?: InputMaybe<Array<Scalars['Bytes']>>;
  functionSignature_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  functionSignature_contains?: InputMaybe<Scalars['Bytes']>;
  functionSignature_not_contains?: InputMaybe<Scalars['Bytes']>;
  isToken?: InputMaybe<Scalars['Boolean']>;
  isToken_not?: InputMaybe<Scalars['Boolean']>;
  isToken_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isToken_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  valueAllowed?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_not?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_gt?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_lt?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_gte?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_lte?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  valueAllowed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fromTime?: InputMaybe<Scalars['BigInt']>;
  fromTime_not?: InputMaybe<Scalars['BigInt']>;
  fromTime_gt?: InputMaybe<Scalars['BigInt']>;
  fromTime_lt?: InputMaybe<Scalars['BigInt']>;
  fromTime_gte?: InputMaybe<Scalars['BigInt']>;
  fromTime_lte?: InputMaybe<Scalars['BigInt']>;
  fromTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fromTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  allowed?: InputMaybe<Scalars['Boolean']>;
  allowed_not?: InputMaybe<Scalars['Boolean']>;
  allowed_in?: InputMaybe<Array<Scalars['Boolean']>>;
  allowed_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  guild?: InputMaybe<Scalars['String']>;
  guild_not?: InputMaybe<Scalars['String']>;
  guild_gt?: InputMaybe<Scalars['String']>;
  guild_lt?: InputMaybe<Scalars['String']>;
  guild_gte?: InputMaybe<Scalars['String']>;
  guild_lte?: InputMaybe<Scalars['String']>;
  guild_in?: InputMaybe<Array<Scalars['String']>>;
  guild_not_in?: InputMaybe<Array<Scalars['String']>>;
  guild_contains?: InputMaybe<Scalars['String']>;
  guild_contains_nocase?: InputMaybe<Scalars['String']>;
  guild_not_contains?: InputMaybe<Scalars['String']>;
  guild_not_contains_nocase?: InputMaybe<Scalars['String']>;
  guild_starts_with?: InputMaybe<Scalars['String']>;
  guild_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guild_not_starts_with?: InputMaybe<Scalars['String']>;
  guild_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guild_ends_with?: InputMaybe<Scalars['String']>;
  guild_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guild_not_ends_with?: InputMaybe<Scalars['String']>;
  guild_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guild_?: InputMaybe<Guild_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<GuildPermission_filter>>>;
  or?: InputMaybe<Array<InputMaybe<GuildPermission_filter>>>;
};

export type GuildPermission_orderBy =
  | 'id'
  | 'from'
  | 'to'
  | 'functionSignature'
  | 'isToken'
  | 'valueAllowed'
  | 'fromTime'
  | 'allowed'
  | 'guild'
  | 'guild__id'
  | 'guild__name'
  | 'guild__permissionRegistry'
  | 'guild__proposalTime'
  | 'guild__lockTime'
  | 'guild__timeForExecution'
  | 'guild__votingPowerPercentageForProposalCreation'
  | 'guild__votingPowerPercentageForProposalExecution'
  | 'guild__votingPowerForProposalCreation'
  | 'guild__votingPowerForProposalExecution'
  | 'guild__voteGas'
  | 'guild__maxGasPrice'
  | 'guild__maxActiveProposals'
  | 'guild__minimumMembersForProposalCreation'
  | 'guild__minimumTokensLockedForProposalCreation'
  | 'guild__type'
  | 'guild__isActive'
  | 'guild__bytecodeHash';

export type GuildType =
  | 'ERC20Guild'
  | 'DXDGuild'
  | 'SnapshotRepERC20Guild'
  | 'SnapshotERC20Guild';

export type Guild_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  token_not?: InputMaybe<Scalars['String']>;
  token_gt?: InputMaybe<Scalars['String']>;
  token_lt?: InputMaybe<Scalars['String']>;
  token_gte?: InputMaybe<Scalars['String']>;
  token_lte?: InputMaybe<Scalars['String']>;
  token_in?: InputMaybe<Array<Scalars['String']>>;
  token_not_in?: InputMaybe<Array<Scalars['String']>>;
  token_contains?: InputMaybe<Scalars['String']>;
  token_contains_nocase?: InputMaybe<Scalars['String']>;
  token_not_contains?: InputMaybe<Scalars['String']>;
  token_not_contains_nocase?: InputMaybe<Scalars['String']>;
  token_starts_with?: InputMaybe<Scalars['String']>;
  token_starts_with_nocase?: InputMaybe<Scalars['String']>;
  token_not_starts_with?: InputMaybe<Scalars['String']>;
  token_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  token_ends_with?: InputMaybe<Scalars['String']>;
  token_ends_with_nocase?: InputMaybe<Scalars['String']>;
  token_not_ends_with?: InputMaybe<Scalars['String']>;
  token_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  token_?: InputMaybe<Token_filter>;
  permissionRegistry?: InputMaybe<Scalars['String']>;
  permissionRegistry_not?: InputMaybe<Scalars['String']>;
  permissionRegistry_gt?: InputMaybe<Scalars['String']>;
  permissionRegistry_lt?: InputMaybe<Scalars['String']>;
  permissionRegistry_gte?: InputMaybe<Scalars['String']>;
  permissionRegistry_lte?: InputMaybe<Scalars['String']>;
  permissionRegistry_in?: InputMaybe<Array<Scalars['String']>>;
  permissionRegistry_not_in?: InputMaybe<Array<Scalars['String']>>;
  permissionRegistry_contains?: InputMaybe<Scalars['String']>;
  permissionRegistry_contains_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_contains?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_contains_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_starts_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_starts_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_starts_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_ends_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_ends_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_ends_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalTime?: InputMaybe<Scalars['BigInt']>;
  proposalTime_not?: InputMaybe<Scalars['BigInt']>;
  proposalTime_gt?: InputMaybe<Scalars['BigInt']>;
  proposalTime_lt?: InputMaybe<Scalars['BigInt']>;
  proposalTime_gte?: InputMaybe<Scalars['BigInt']>;
  proposalTime_lte?: InputMaybe<Scalars['BigInt']>;
  proposalTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  proposalTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lockTime?: InputMaybe<Scalars['BigInt']>;
  lockTime_not?: InputMaybe<Scalars['BigInt']>;
  lockTime_gt?: InputMaybe<Scalars['BigInt']>;
  lockTime_lt?: InputMaybe<Scalars['BigInt']>;
  lockTime_gte?: InputMaybe<Scalars['BigInt']>;
  lockTime_lte?: InputMaybe<Scalars['BigInt']>;
  lockTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  lockTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timeForExecution?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_not?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_gt?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_lt?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_gte?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_lte?: InputMaybe<Scalars['BigInt']>;
  timeForExecution_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timeForExecution_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerPercentageForProposalCreation?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_not?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_gt?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_lt?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_gte?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_lte?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalCreation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerPercentageForProposalCreation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerPercentageForProposalExecution?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_not?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_gt?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_lt?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_gte?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_lte?: InputMaybe<Scalars['BigInt']>;
  votingPowerPercentageForProposalExecution_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerPercentageForProposalExecution_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerForProposalCreation?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_not?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_gt?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_lt?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_gte?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_lte?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalCreation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerForProposalCreation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerForProposalExecution?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_not?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_gt?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_lt?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_gte?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_lte?: InputMaybe<Scalars['BigInt']>;
  votingPowerForProposalExecution_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPowerForProposalExecution_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGas?: InputMaybe<Scalars['BigInt']>;
  voteGas_not?: InputMaybe<Scalars['BigInt']>;
  voteGas_gt?: InputMaybe<Scalars['BigInt']>;
  voteGas_lt?: InputMaybe<Scalars['BigInt']>;
  voteGas_gte?: InputMaybe<Scalars['BigInt']>;
  voteGas_lte?: InputMaybe<Scalars['BigInt']>;
  voteGas_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGas_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxGasPrice?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_not?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_gt?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_lt?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_gte?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_lte?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxGasPrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxActiveProposals?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_not?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_gt?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_lt?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_gte?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_lte?: InputMaybe<Scalars['BigInt']>;
  maxActiveProposals_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxActiveProposals_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumMembersForProposalCreation?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_not?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_gt?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_lt?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_gte?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_lte?: InputMaybe<Scalars['BigInt']>;
  minimumMembersForProposalCreation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumMembersForProposalCreation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumTokensLockedForProposalCreation?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_not?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_gt?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_lt?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_gte?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_lte?: InputMaybe<Scalars['BigInt']>;
  minimumTokensLockedForProposalCreation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  minimumTokensLockedForProposalCreation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  type?: InputMaybe<GuildType>;
  type_not?: InputMaybe<GuildType>;
  type_in?: InputMaybe<Array<GuildType>>;
  type_not_in?: InputMaybe<Array<GuildType>>;
  permissions_?: InputMaybe<GuildPermission_filter>;
  proposals_?: InputMaybe<Proposal_filter>;
  members_?: InputMaybe<Member_filter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isActive_not?: InputMaybe<Scalars['Boolean']>;
  isActive_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isActive_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  bytecodeHash?: InputMaybe<Scalars['String']>;
  bytecodeHash_not?: InputMaybe<Scalars['String']>;
  bytecodeHash_gt?: InputMaybe<Scalars['String']>;
  bytecodeHash_lt?: InputMaybe<Scalars['String']>;
  bytecodeHash_gte?: InputMaybe<Scalars['String']>;
  bytecodeHash_lte?: InputMaybe<Scalars['String']>;
  bytecodeHash_in?: InputMaybe<Array<Scalars['String']>>;
  bytecodeHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  bytecodeHash_contains?: InputMaybe<Scalars['String']>;
  bytecodeHash_contains_nocase?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_contains?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  bytecodeHash_starts_with?: InputMaybe<Scalars['String']>;
  bytecodeHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_starts_with?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  bytecodeHash_ends_with?: InputMaybe<Scalars['String']>;
  bytecodeHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_ends_with?: InputMaybe<Scalars['String']>;
  bytecodeHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Guild_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Guild_filter>>>;
};

export type Guild_orderBy =
  | 'id'
  | 'name'
  | 'token'
  | 'token__id'
  | 'token__type'
  | 'token__name'
  | 'token__symbol'
  | 'token__decimals'
  | 'token__guildAddress'
  | 'permissionRegistry'
  | 'proposalTime'
  | 'lockTime'
  | 'timeForExecution'
  | 'votingPowerPercentageForProposalCreation'
  | 'votingPowerPercentageForProposalExecution'
  | 'votingPowerForProposalCreation'
  | 'votingPowerForProposalExecution'
  | 'voteGas'
  | 'maxGasPrice'
  | 'maxActiveProposals'
  | 'minimumMembersForProposalCreation'
  | 'minimumTokensLockedForProposalCreation'
  | 'type'
  | 'permissions'
  | 'proposals'
  | 'members'
  | 'isActive'
  | 'bytecodeHash';

export type Member = {
  id: Scalars['ID'];
  guildId: Guild;
  address: Scalars['String'];
  tokensLocked: Scalars['BigInt'];
  reputationToken?: Maybe<ReputationToken>;
  reputationTokenAmount: Scalars['BigInt'];
  votes?: Maybe<Array<Vote>>;
  snapshots?: Maybe<Array<VoterSnapshot>>;
};


export type MembervotesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Vote_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Vote_filter>;
};


export type MembersnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoterSnapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoterSnapshot_filter>;
};

export type Member_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  guildId?: InputMaybe<Scalars['String']>;
  guildId_not?: InputMaybe<Scalars['String']>;
  guildId_gt?: InputMaybe<Scalars['String']>;
  guildId_lt?: InputMaybe<Scalars['String']>;
  guildId_gte?: InputMaybe<Scalars['String']>;
  guildId_lte?: InputMaybe<Scalars['String']>;
  guildId_in?: InputMaybe<Array<Scalars['String']>>;
  guildId_not_in?: InputMaybe<Array<Scalars['String']>>;
  guildId_contains?: InputMaybe<Scalars['String']>;
  guildId_contains_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_contains?: InputMaybe<Scalars['String']>;
  guildId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  guildId_starts_with?: InputMaybe<Scalars['String']>;
  guildId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_starts_with?: InputMaybe<Scalars['String']>;
  guildId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_ends_with?: InputMaybe<Scalars['String']>;
  guildId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_ends_with?: InputMaybe<Scalars['String']>;
  guildId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_?: InputMaybe<Guild_filter>;
  address?: InputMaybe<Scalars['String']>;
  address_not?: InputMaybe<Scalars['String']>;
  address_gt?: InputMaybe<Scalars['String']>;
  address_lt?: InputMaybe<Scalars['String']>;
  address_gte?: InputMaybe<Scalars['String']>;
  address_lte?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<Scalars['String']>>;
  address_not_in?: InputMaybe<Array<Scalars['String']>>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_contains_nocase?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_contains_nocase?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with_nocase?: InputMaybe<Scalars['String']>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_ends_with_nocase?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  tokensLocked?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_not?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_gt?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_lt?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_gte?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_lte?: InputMaybe<Scalars['BigInt']>;
  tokensLocked_in?: InputMaybe<Array<Scalars['BigInt']>>;
  tokensLocked_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Member_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Member_filter>>>;
  reputationToken?: InputMaybe<Scalars['String']>;
  reputationToken_not?: InputMaybe<Scalars['String']>;
  reputationToken_gt?: InputMaybe<Scalars['String']>;
  reputationToken_lt?: InputMaybe<Scalars['String']>;
  reputationToken_gte?: InputMaybe<Scalars['String']>;
  reputationToken_lte?: InputMaybe<Scalars['String']>;
  reputationToken_in?: InputMaybe<Array<Scalars['String']>>;
  reputationToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  reputationToken_contains?: InputMaybe<Scalars['String']>;
  reputationToken_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_contains?: InputMaybe<Scalars['String']>;
  reputationToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_starts_with?: InputMaybe<Scalars['String']>;
  reputationToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_starts_with?: InputMaybe<Scalars['String']>;
  reputationToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_ends_with?: InputMaybe<Scalars['String']>;
  reputationToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_ends_with?: InputMaybe<Scalars['String']>;
  reputationToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_?: InputMaybe<ReputationToken_filter>;
  reputationTokenAmount?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_not?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_gt?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_lt?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_gte?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_lte?: InputMaybe<Scalars['BigInt']>;
  reputationTokenAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reputationTokenAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votes_?: InputMaybe<Vote_filter>;
  snapshots_?: InputMaybe<VoterSnapshot_filter>;
};

export type Member_orderBy =
  | 'id'
  | 'guildId'
  | 'guildId__id'
  | 'guildId__name'
  | 'guildId__permissionRegistry'
  | 'guildId__proposalTime'
  | 'guildId__lockTime'
  | 'guildId__timeForExecution'
  | 'guildId__votingPowerPercentageForProposalCreation'
  | 'guildId__votingPowerPercentageForProposalExecution'
  | 'guildId__votingPowerForProposalCreation'
  | 'guildId__votingPowerForProposalExecution'
  | 'guildId__voteGas'
  | 'guildId__maxGasPrice'
  | 'guildId__maxActiveProposals'
  | 'guildId__minimumMembersForProposalCreation'
  | 'guildId__minimumTokensLockedForProposalCreation'
  | 'guildId__type'
  | 'guildId__isActive'
  | 'guildId__bytecodeHash'
  | 'address'
  | 'tokensLocked'
  | 'reputationToken'
  | 'reputationToken__id'
  | 'reputationToken__address'
  | 'reputationToken__name'
  | 'reputationToken__symbol'
  | 'reputationToken__controllerAddress'
  | 'reputationToken__amount'
  | 'reputationToken__currentSnapshotId'
  | 'reputationTokenAmount'
  | 'votes'
  | 'snapshots';

export type Option = {
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  proposalId: Proposal;
  actions?: Maybe<Array<Action>>;
  voteAmount?: Maybe<Scalars['BigInt']>;
  votes?: Maybe<Array<Vote>>;
};


export type OptionactionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Action_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Action_filter>;
};


export type OptionvotesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Vote_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Vote_filter>;
};

export type Option_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  label?: InputMaybe<Scalars['String']>;
  label_not?: InputMaybe<Scalars['String']>;
  label_gt?: InputMaybe<Scalars['String']>;
  label_lt?: InputMaybe<Scalars['String']>;
  label_gte?: InputMaybe<Scalars['String']>;
  label_lte?: InputMaybe<Scalars['String']>;
  label_in?: InputMaybe<Array<Scalars['String']>>;
  label_not_in?: InputMaybe<Array<Scalars['String']>>;
  label_contains?: InputMaybe<Scalars['String']>;
  label_contains_nocase?: InputMaybe<Scalars['String']>;
  label_not_contains?: InputMaybe<Scalars['String']>;
  label_not_contains_nocase?: InputMaybe<Scalars['String']>;
  label_starts_with?: InputMaybe<Scalars['String']>;
  label_starts_with_nocase?: InputMaybe<Scalars['String']>;
  label_not_starts_with?: InputMaybe<Scalars['String']>;
  label_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  label_ends_with?: InputMaybe<Scalars['String']>;
  label_ends_with_nocase?: InputMaybe<Scalars['String']>;
  label_not_ends_with?: InputMaybe<Scalars['String']>;
  label_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId?: InputMaybe<Scalars['String']>;
  proposalId_not?: InputMaybe<Scalars['String']>;
  proposalId_gt?: InputMaybe<Scalars['String']>;
  proposalId_lt?: InputMaybe<Scalars['String']>;
  proposalId_gte?: InputMaybe<Scalars['String']>;
  proposalId_lte?: InputMaybe<Scalars['String']>;
  proposalId_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_contains?: InputMaybe<Scalars['String']>;
  proposalId_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_contains?: InputMaybe<Scalars['String']>;
  proposalId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_?: InputMaybe<Proposal_filter>;
  actions_?: InputMaybe<Action_filter>;
  voteAmount?: InputMaybe<Scalars['BigInt']>;
  voteAmount_not?: InputMaybe<Scalars['BigInt']>;
  voteAmount_gt?: InputMaybe<Scalars['BigInt']>;
  voteAmount_lt?: InputMaybe<Scalars['BigInt']>;
  voteAmount_gte?: InputMaybe<Scalars['BigInt']>;
  voteAmount_lte?: InputMaybe<Scalars['BigInt']>;
  voteAmount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteAmount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votes_?: InputMaybe<Vote_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Option_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Option_filter>>>;
};

export type Option_orderBy =
  | 'id'
  | 'label'
  | 'proposalId'
  | 'proposalId__id'
  | 'proposalId__creator'
  | 'proposalId__startTime'
  | 'proposalId__endTime'
  | 'proposalId__title'
  | 'proposalId__contentHash'
  | 'proposalId__contractState'
  | 'proposalId__snapshotId'
  | 'proposalId__metadata'
  | 'proposalId__description'
  | 'proposalId__executionTransactionHash'
  | 'actions'
  | 'voteAmount'
  | 'votes';

/** Defines the order direction, either ascending or descending */
export type OrderDirection =
  | 'asc'
  | 'desc';

export type Proposal = {
  id: Scalars['ID'];
  creator: Scalars['String'];
  startTime: Scalars['BigInt'];
  endTime: Scalars['BigInt'];
  to?: Maybe<Array<Scalars['String']>>;
  data?: Maybe<Array<Scalars['String']>>;
  value?: Maybe<Array<Scalars['BigInt']>>;
  title?: Maybe<Scalars['String']>;
  contentHash: Scalars['String'];
  contractState: Scalars['BigInt'];
  guildId: Guild;
  totalVotes?: Maybe<Array<Scalars['BigInt']>>;
  votes?: Maybe<Array<Vote>>;
  options?: Maybe<Array<Option>>;
  snapshotId?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  executionTransactionHash?: Maybe<Scalars['String']>;
  statesLog?: Maybe<Array<ProposalStateLog>>;
  scheme: Scheme;
  callData?: Maybe<Array<Scalars['String']>>;
  totalOptions?: Maybe<Scalars['BigInt']>;
  state?: Maybe<ProposalState>;
  descriptionHash?: Maybe<Scalars['String']>;
  submittedTime?: Maybe<Scalars['BigInt']>;
  snapshot?: Maybe<Scalars['String']>;
  schemeId?: Maybe<Scalars['String']>;
  callbacks?: Maybe<Scalars['String']>;
  votingMachineProposalState?: Maybe<VotingMachineProposalState>;
  votingMachineExecutionState?: Maybe<VotingMachineExecutionState>;
  winningVote?: Maybe<Scalars['BigInt']>;
  proposer?: Maybe<Scalars['String']>;
  currentBoostedVotePeriodLimit?: Maybe<Scalars['BigInt']>;
  paramsHash?: Maybe<Scalars['String']>;
  daoBounty?: Maybe<Scalars['BigInt']>;
  boostedPhaseTime?: Maybe<Scalars['BigInt']>;
  preBoostedPhaseTime?: Maybe<Scalars['BigInt']>;
  daoRedeemedWinnings?: Maybe<Scalars['Boolean']>;
  stakes?: Maybe<Array<Stake>>;
  stateLogs?: Maybe<Array<StateLog>>;
  votingMachineProposalStateLogs?: Maybe<Array<VotingMachineProposalStateLog>>;
};


export type ProposalvotesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Vote_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Vote_filter>;
};


export type ProposaloptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Option_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Option_filter>;
};


export type ProposalstatesLogArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ProposalStateLog_filter>;
};


export type ProposalstakesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Stake_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Stake_filter>;
};


export type ProposalstateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<StateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<StateLog_filter>;
};


export type ProposalvotingMachineProposalStateLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VotingMachineProposalStateLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VotingMachineProposalStateLog_filter>;
};

export type ProposalStateLog = {
  id: Scalars['ID'];
  proposalId: Proposal;
  state: Scalars['BigInt'];
  timestamp: Scalars['BigInt'];
  transactionHash: Scalars['String'];
};

export type ProposalStateLog_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  proposalId?: InputMaybe<Scalars['String']>;
  proposalId_not?: InputMaybe<Scalars['String']>;
  proposalId_gt?: InputMaybe<Scalars['String']>;
  proposalId_lt?: InputMaybe<Scalars['String']>;
  proposalId_gte?: InputMaybe<Scalars['String']>;
  proposalId_lte?: InputMaybe<Scalars['String']>;
  proposalId_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_contains?: InputMaybe<Scalars['String']>;
  proposalId_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_contains?: InputMaybe<Scalars['String']>;
  proposalId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_?: InputMaybe<Proposal_filter>;
  state?: InputMaybe<Scalars['BigInt']>;
  state_not?: InputMaybe<Scalars['BigInt']>;
  state_gt?: InputMaybe<Scalars['BigInt']>;
  state_lt?: InputMaybe<Scalars['BigInt']>;
  state_gte?: InputMaybe<Scalars['BigInt']>;
  state_lte?: InputMaybe<Scalars['BigInt']>;
  state_in?: InputMaybe<Array<Scalars['BigInt']>>;
  state_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['String']>;
  transactionHash_not?: InputMaybe<Scalars['String']>;
  transactionHash_gt?: InputMaybe<Scalars['String']>;
  transactionHash_lt?: InputMaybe<Scalars['String']>;
  transactionHash_gte?: InputMaybe<Scalars['String']>;
  transactionHash_lte?: InputMaybe<Scalars['String']>;
  transactionHash_in?: InputMaybe<Array<Scalars['String']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  transactionHash_contains?: InputMaybe<Scalars['String']>;
  transactionHash_contains_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_contains?: InputMaybe<Scalars['String']>;
  transactionHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_starts_with?: InputMaybe<Scalars['String']>;
  transactionHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_starts_with?: InputMaybe<Scalars['String']>;
  transactionHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_ends_with?: InputMaybe<Scalars['String']>;
  transactionHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_ends_with?: InputMaybe<Scalars['String']>;
  transactionHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ProposalStateLog_filter>>>;
  or?: InputMaybe<Array<InputMaybe<ProposalStateLog_filter>>>;
};

export type ProposalStateLog_orderBy =
  | 'id'
  | 'proposalId'
  | 'proposalId__id'
  | 'proposalId__creator'
  | 'proposalId__startTime'
  | 'proposalId__endTime'
  | 'proposalId__title'
  | 'proposalId__contentHash'
  | 'proposalId__contractState'
  | 'proposalId__snapshotId'
  | 'proposalId__metadata'
  | 'proposalId__description'
  | 'proposalId__executionTransactionHash'
  | 'state'
  | 'timestamp'
  | 'transactionHash';

export type Proposal_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  creator?: InputMaybe<Scalars['String']>;
  creator_not?: InputMaybe<Scalars['String']>;
  creator_gt?: InputMaybe<Scalars['String']>;
  creator_lt?: InputMaybe<Scalars['String']>;
  creator_gte?: InputMaybe<Scalars['String']>;
  creator_lte?: InputMaybe<Scalars['String']>;
  creator_in?: InputMaybe<Array<Scalars['String']>>;
  creator_not_in?: InputMaybe<Array<Scalars['String']>>;
  creator_contains?: InputMaybe<Scalars['String']>;
  creator_contains_nocase?: InputMaybe<Scalars['String']>;
  creator_not_contains?: InputMaybe<Scalars['String']>;
  creator_not_contains_nocase?: InputMaybe<Scalars['String']>;
  creator_starts_with?: InputMaybe<Scalars['String']>;
  creator_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creator_not_starts_with?: InputMaybe<Scalars['String']>;
  creator_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  creator_ends_with?: InputMaybe<Scalars['String']>;
  creator_ends_with_nocase?: InputMaybe<Scalars['String']>;
  creator_not_ends_with?: InputMaybe<Scalars['String']>;
  creator_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['BigInt']>;
  startTime_not?: InputMaybe<Scalars['BigInt']>;
  startTime_gt?: InputMaybe<Scalars['BigInt']>;
  startTime_lt?: InputMaybe<Scalars['BigInt']>;
  startTime_gte?: InputMaybe<Scalars['BigInt']>;
  startTime_lte?: InputMaybe<Scalars['BigInt']>;
  startTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  startTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  endTime?: InputMaybe<Scalars['BigInt']>;
  endTime_not?: InputMaybe<Scalars['BigInt']>;
  endTime_gt?: InputMaybe<Scalars['BigInt']>;
  endTime_lt?: InputMaybe<Scalars['BigInt']>;
  endTime_gte?: InputMaybe<Scalars['BigInt']>;
  endTime_lte?: InputMaybe<Scalars['BigInt']>;
  endTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  endTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  to?: InputMaybe<Array<Scalars['String']>>;
  to_not?: InputMaybe<Array<Scalars['String']>>;
  to_contains?: InputMaybe<Array<Scalars['String']>>;
  to_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  to_not_contains?: InputMaybe<Array<Scalars['String']>>;
  to_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  data?: InputMaybe<Array<Scalars['String']>>;
  data_not?: InputMaybe<Array<Scalars['String']>>;
  data_contains?: InputMaybe<Array<Scalars['String']>>;
  data_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  data_not_contains?: InputMaybe<Array<Scalars['String']>>;
  data_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not?: InputMaybe<Array<Scalars['BigInt']>>;
  value_contains?: InputMaybe<Array<Scalars['BigInt']>>;
  value_contains_nocase?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not_contains?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']>>;
  title?: InputMaybe<Scalars['String']>;
  title_not?: InputMaybe<Scalars['String']>;
  title_gt?: InputMaybe<Scalars['String']>;
  title_lt?: InputMaybe<Scalars['String']>;
  title_gte?: InputMaybe<Scalars['String']>;
  title_lte?: InputMaybe<Scalars['String']>;
  title_in?: InputMaybe<Array<Scalars['String']>>;
  title_not_in?: InputMaybe<Array<Scalars['String']>>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_contains_nocase?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_contains_nocase?: InputMaybe<Scalars['String']>;
  title_starts_with?: InputMaybe<Scalars['String']>;
  title_starts_with_nocase?: InputMaybe<Scalars['String']>;
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  title_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  title_ends_with?: InputMaybe<Scalars['String']>;
  title_ends_with_nocase?: InputMaybe<Scalars['String']>;
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  title_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contentHash?: InputMaybe<Scalars['String']>;
  contentHash_not?: InputMaybe<Scalars['String']>;
  contentHash_gt?: InputMaybe<Scalars['String']>;
  contentHash_lt?: InputMaybe<Scalars['String']>;
  contentHash_gte?: InputMaybe<Scalars['String']>;
  contentHash_lte?: InputMaybe<Scalars['String']>;
  contentHash_in?: InputMaybe<Array<Scalars['String']>>;
  contentHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  contentHash_contains?: InputMaybe<Scalars['String']>;
  contentHash_contains_nocase?: InputMaybe<Scalars['String']>;
  contentHash_not_contains?: InputMaybe<Scalars['String']>;
  contentHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  contentHash_starts_with?: InputMaybe<Scalars['String']>;
  contentHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  contentHash_not_starts_with?: InputMaybe<Scalars['String']>;
  contentHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  contentHash_ends_with?: InputMaybe<Scalars['String']>;
  contentHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contentHash_not_ends_with?: InputMaybe<Scalars['String']>;
  contentHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  contractState?: InputMaybe<Scalars['BigInt']>;
  contractState_not?: InputMaybe<Scalars['BigInt']>;
  contractState_gt?: InputMaybe<Scalars['BigInt']>;
  contractState_lt?: InputMaybe<Scalars['BigInt']>;
  contractState_gte?: InputMaybe<Scalars['BigInt']>;
  contractState_lte?: InputMaybe<Scalars['BigInt']>;
  contractState_in?: InputMaybe<Array<Scalars['BigInt']>>;
  contractState_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  guildId?: InputMaybe<Scalars['String']>;
  guildId_not?: InputMaybe<Scalars['String']>;
  guildId_gt?: InputMaybe<Scalars['String']>;
  guildId_lt?: InputMaybe<Scalars['String']>;
  guildId_gte?: InputMaybe<Scalars['String']>;
  guildId_lte?: InputMaybe<Scalars['String']>;
  guildId_in?: InputMaybe<Array<Scalars['String']>>;
  guildId_not_in?: InputMaybe<Array<Scalars['String']>>;
  guildId_contains?: InputMaybe<Scalars['String']>;
  guildId_contains_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_contains?: InputMaybe<Scalars['String']>;
  guildId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  guildId_starts_with?: InputMaybe<Scalars['String']>;
  guildId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_starts_with?: InputMaybe<Scalars['String']>;
  guildId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_ends_with?: InputMaybe<Scalars['String']>;
  guildId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_not_ends_with?: InputMaybe<Scalars['String']>;
  guildId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guildId_?: InputMaybe<Guild_filter>;
  totalVotes?: InputMaybe<Array<Scalars['BigInt']>>;
  totalVotes_not?: InputMaybe<Array<Scalars['BigInt']>>;
  totalVotes_contains?: InputMaybe<Array<Scalars['BigInt']>>;
  totalVotes_contains_nocase?: InputMaybe<Array<Scalars['BigInt']>>;
  totalVotes_not_contains?: InputMaybe<Array<Scalars['BigInt']>>;
  totalVotes_not_contains_nocase?: InputMaybe<Array<Scalars['BigInt']>>;
  votes_?: InputMaybe<Vote_filter>;
  options_?: InputMaybe<Option_filter>;
  snapshotId?: InputMaybe<Scalars['BigInt']>;
  snapshotId_not?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  snapshotId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  metadata?: InputMaybe<Scalars['String']>;
  metadata_not?: InputMaybe<Scalars['String']>;
  metadata_gt?: InputMaybe<Scalars['String']>;
  metadata_lt?: InputMaybe<Scalars['String']>;
  metadata_gte?: InputMaybe<Scalars['String']>;
  metadata_lte?: InputMaybe<Scalars['String']>;
  metadata_in?: InputMaybe<Array<Scalars['String']>>;
  metadata_not_in?: InputMaybe<Array<Scalars['String']>>;
  metadata_contains?: InputMaybe<Scalars['String']>;
  metadata_contains_nocase?: InputMaybe<Scalars['String']>;
  metadata_not_contains?: InputMaybe<Scalars['String']>;
  metadata_not_contains_nocase?: InputMaybe<Scalars['String']>;
  metadata_starts_with?: InputMaybe<Scalars['String']>;
  metadata_starts_with_nocase?: InputMaybe<Scalars['String']>;
  metadata_not_starts_with?: InputMaybe<Scalars['String']>;
  metadata_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  metadata_ends_with?: InputMaybe<Scalars['String']>;
  metadata_ends_with_nocase?: InputMaybe<Scalars['String']>;
  metadata_not_ends_with?: InputMaybe<Scalars['String']>;
  metadata_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  description_not?: InputMaybe<Scalars['String']>;
  description_gt?: InputMaybe<Scalars['String']>;
  description_lt?: InputMaybe<Scalars['String']>;
  description_gte?: InputMaybe<Scalars['String']>;
  description_lte?: InputMaybe<Scalars['String']>;
  description_in?: InputMaybe<Array<Scalars['String']>>;
  description_not_in?: InputMaybe<Array<Scalars['String']>>;
  description_contains?: InputMaybe<Scalars['String']>;
  description_contains_nocase?: InputMaybe<Scalars['String']>;
  description_not_contains?: InputMaybe<Scalars['String']>;
  description_not_contains_nocase?: InputMaybe<Scalars['String']>;
  description_starts_with?: InputMaybe<Scalars['String']>;
  description_starts_with_nocase?: InputMaybe<Scalars['String']>;
  description_not_starts_with?: InputMaybe<Scalars['String']>;
  description_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  description_ends_with?: InputMaybe<Scalars['String']>;
  description_ends_with_nocase?: InputMaybe<Scalars['String']>;
  description_not_ends_with?: InputMaybe<Scalars['String']>;
  description_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not?: InputMaybe<Scalars['String']>;
  executionTransactionHash_gt?: InputMaybe<Scalars['String']>;
  executionTransactionHash_lt?: InputMaybe<Scalars['String']>;
  executionTransactionHash_gte?: InputMaybe<Scalars['String']>;
  executionTransactionHash_lte?: InputMaybe<Scalars['String']>;
  executionTransactionHash_in?: InputMaybe<Array<Scalars['String']>>;
  executionTransactionHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  executionTransactionHash_contains?: InputMaybe<Scalars['String']>;
  executionTransactionHash_contains_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_contains?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash_starts_with?: InputMaybe<Scalars['String']>;
  executionTransactionHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_starts_with?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash_ends_with?: InputMaybe<Scalars['String']>;
  executionTransactionHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_ends_with?: InputMaybe<Scalars['String']>;
  executionTransactionHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  statesLog_?: InputMaybe<ProposalStateLog_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Proposal_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Proposal_filter>>>;
  scheme?: InputMaybe<Scalars['String']>;
  scheme_not?: InputMaybe<Scalars['String']>;
  scheme_gt?: InputMaybe<Scalars['String']>;
  scheme_lt?: InputMaybe<Scalars['String']>;
  scheme_gte?: InputMaybe<Scalars['String']>;
  scheme_lte?: InputMaybe<Scalars['String']>;
  scheme_in?: InputMaybe<Array<Scalars['String']>>;
  scheme_not_in?: InputMaybe<Array<Scalars['String']>>;
  scheme_contains?: InputMaybe<Scalars['String']>;
  scheme_contains_nocase?: InputMaybe<Scalars['String']>;
  scheme_not_contains?: InputMaybe<Scalars['String']>;
  scheme_not_contains_nocase?: InputMaybe<Scalars['String']>;
  scheme_starts_with?: InputMaybe<Scalars['String']>;
  scheme_starts_with_nocase?: InputMaybe<Scalars['String']>;
  scheme_not_starts_with?: InputMaybe<Scalars['String']>;
  scheme_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  scheme_ends_with?: InputMaybe<Scalars['String']>;
  scheme_ends_with_nocase?: InputMaybe<Scalars['String']>;
  scheme_not_ends_with?: InputMaybe<Scalars['String']>;
  scheme_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  scheme_?: InputMaybe<Scheme_filter>;
  callData?: InputMaybe<Array<Scalars['String']>>;
  callData_not?: InputMaybe<Array<Scalars['String']>>;
  callData_contains?: InputMaybe<Array<Scalars['String']>>;
  callData_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  callData_not_contains?: InputMaybe<Array<Scalars['String']>>;
  callData_not_contains_nocase?: InputMaybe<Array<Scalars['String']>>;
  totalOptions?: InputMaybe<Scalars['BigInt']>;
  totalOptions_not?: InputMaybe<Scalars['BigInt']>;
  totalOptions_gt?: InputMaybe<Scalars['BigInt']>;
  totalOptions_lt?: InputMaybe<Scalars['BigInt']>;
  totalOptions_gte?: InputMaybe<Scalars['BigInt']>;
  totalOptions_lte?: InputMaybe<Scalars['BigInt']>;
  totalOptions_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalOptions_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  state?: InputMaybe<ProposalState>;
  state_not?: InputMaybe<ProposalState>;
  state_in?: InputMaybe<Array<ProposalState>>;
  state_not_in?: InputMaybe<Array<ProposalState>>;
  descriptionHash?: InputMaybe<Scalars['String']>;
  descriptionHash_not?: InputMaybe<Scalars['String']>;
  descriptionHash_gt?: InputMaybe<Scalars['String']>;
  descriptionHash_lt?: InputMaybe<Scalars['String']>;
  descriptionHash_gte?: InputMaybe<Scalars['String']>;
  descriptionHash_lte?: InputMaybe<Scalars['String']>;
  descriptionHash_in?: InputMaybe<Array<Scalars['String']>>;
  descriptionHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  descriptionHash_contains?: InputMaybe<Scalars['String']>;
  descriptionHash_contains_nocase?: InputMaybe<Scalars['String']>;
  descriptionHash_not_contains?: InputMaybe<Scalars['String']>;
  descriptionHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  descriptionHash_starts_with?: InputMaybe<Scalars['String']>;
  descriptionHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  descriptionHash_not_starts_with?: InputMaybe<Scalars['String']>;
  descriptionHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  descriptionHash_ends_with?: InputMaybe<Scalars['String']>;
  descriptionHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  descriptionHash_not_ends_with?: InputMaybe<Scalars['String']>;
  descriptionHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  submittedTime?: InputMaybe<Scalars['BigInt']>;
  submittedTime_not?: InputMaybe<Scalars['BigInt']>;
  submittedTime_gt?: InputMaybe<Scalars['BigInt']>;
  submittedTime_lt?: InputMaybe<Scalars['BigInt']>;
  submittedTime_gte?: InputMaybe<Scalars['BigInt']>;
  submittedTime_lte?: InputMaybe<Scalars['BigInt']>;
  submittedTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  submittedTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  snapshot?: InputMaybe<Scalars['String']>;
  snapshot_not?: InputMaybe<Scalars['String']>;
  snapshot_gt?: InputMaybe<Scalars['String']>;
  snapshot_lt?: InputMaybe<Scalars['String']>;
  snapshot_gte?: InputMaybe<Scalars['String']>;
  snapshot_lte?: InputMaybe<Scalars['String']>;
  snapshot_in?: InputMaybe<Array<Scalars['String']>>;
  snapshot_not_in?: InputMaybe<Array<Scalars['String']>>;
  snapshot_contains?: InputMaybe<Scalars['String']>;
  snapshot_contains_nocase?: InputMaybe<Scalars['String']>;
  snapshot_not_contains?: InputMaybe<Scalars['String']>;
  snapshot_not_contains_nocase?: InputMaybe<Scalars['String']>;
  snapshot_starts_with?: InputMaybe<Scalars['String']>;
  snapshot_starts_with_nocase?: InputMaybe<Scalars['String']>;
  snapshot_not_starts_with?: InputMaybe<Scalars['String']>;
  snapshot_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  snapshot_ends_with?: InputMaybe<Scalars['String']>;
  snapshot_ends_with_nocase?: InputMaybe<Scalars['String']>;
  snapshot_not_ends_with?: InputMaybe<Scalars['String']>;
  snapshot_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  schemeId?: InputMaybe<Scalars['String']>;
  schemeId_not?: InputMaybe<Scalars['String']>;
  schemeId_gt?: InputMaybe<Scalars['String']>;
  schemeId_lt?: InputMaybe<Scalars['String']>;
  schemeId_gte?: InputMaybe<Scalars['String']>;
  schemeId_lte?: InputMaybe<Scalars['String']>;
  schemeId_in?: InputMaybe<Array<Scalars['String']>>;
  schemeId_not_in?: InputMaybe<Array<Scalars['String']>>;
  schemeId_contains?: InputMaybe<Scalars['String']>;
  schemeId_contains_nocase?: InputMaybe<Scalars['String']>;
  schemeId_not_contains?: InputMaybe<Scalars['String']>;
  schemeId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  schemeId_starts_with?: InputMaybe<Scalars['String']>;
  schemeId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  schemeId_not_starts_with?: InputMaybe<Scalars['String']>;
  schemeId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  schemeId_ends_with?: InputMaybe<Scalars['String']>;
  schemeId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  schemeId_not_ends_with?: InputMaybe<Scalars['String']>;
  schemeId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  callbacks?: InputMaybe<Scalars['String']>;
  callbacks_not?: InputMaybe<Scalars['String']>;
  callbacks_gt?: InputMaybe<Scalars['String']>;
  callbacks_lt?: InputMaybe<Scalars['String']>;
  callbacks_gte?: InputMaybe<Scalars['String']>;
  callbacks_lte?: InputMaybe<Scalars['String']>;
  callbacks_in?: InputMaybe<Array<Scalars['String']>>;
  callbacks_not_in?: InputMaybe<Array<Scalars['String']>>;
  callbacks_contains?: InputMaybe<Scalars['String']>;
  callbacks_contains_nocase?: InputMaybe<Scalars['String']>;
  callbacks_not_contains?: InputMaybe<Scalars['String']>;
  callbacks_not_contains_nocase?: InputMaybe<Scalars['String']>;
  callbacks_starts_with?: InputMaybe<Scalars['String']>;
  callbacks_starts_with_nocase?: InputMaybe<Scalars['String']>;
  callbacks_not_starts_with?: InputMaybe<Scalars['String']>;
  callbacks_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  callbacks_ends_with?: InputMaybe<Scalars['String']>;
  callbacks_ends_with_nocase?: InputMaybe<Scalars['String']>;
  callbacks_not_ends_with?: InputMaybe<Scalars['String']>;
  callbacks_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  votingMachineProposalState?: InputMaybe<VotingMachineProposalState>;
  votingMachineProposalState_not?: InputMaybe<VotingMachineProposalState>;
  votingMachineProposalState_in?: InputMaybe<Array<VotingMachineProposalState>>;
  votingMachineProposalState_not_in?: InputMaybe<Array<VotingMachineProposalState>>;
  votingMachineExecutionState?: InputMaybe<VotingMachineExecutionState>;
  votingMachineExecutionState_not?: InputMaybe<VotingMachineExecutionState>;
  votingMachineExecutionState_in?: InputMaybe<Array<VotingMachineExecutionState>>;
  votingMachineExecutionState_not_in?: InputMaybe<Array<VotingMachineExecutionState>>;
  winningVote?: InputMaybe<Scalars['BigInt']>;
  winningVote_not?: InputMaybe<Scalars['BigInt']>;
  winningVote_gt?: InputMaybe<Scalars['BigInt']>;
  winningVote_lt?: InputMaybe<Scalars['BigInt']>;
  winningVote_gte?: InputMaybe<Scalars['BigInt']>;
  winningVote_lte?: InputMaybe<Scalars['BigInt']>;
  winningVote_in?: InputMaybe<Array<Scalars['BigInt']>>;
  winningVote_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  proposer?: InputMaybe<Scalars['String']>;
  proposer_not?: InputMaybe<Scalars['String']>;
  proposer_gt?: InputMaybe<Scalars['String']>;
  proposer_lt?: InputMaybe<Scalars['String']>;
  proposer_gte?: InputMaybe<Scalars['String']>;
  proposer_lte?: InputMaybe<Scalars['String']>;
  proposer_in?: InputMaybe<Array<Scalars['String']>>;
  proposer_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposer_contains?: InputMaybe<Scalars['String']>;
  proposer_contains_nocase?: InputMaybe<Scalars['String']>;
  proposer_not_contains?: InputMaybe<Scalars['String']>;
  proposer_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposer_starts_with?: InputMaybe<Scalars['String']>;
  proposer_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposer_not_starts_with?: InputMaybe<Scalars['String']>;
  proposer_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposer_ends_with?: InputMaybe<Scalars['String']>;
  proposer_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposer_not_ends_with?: InputMaybe<Scalars['String']>;
  proposer_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  currentBoostedVotePeriodLimit?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_not?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_gt?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_lt?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_gte?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_lte?: InputMaybe<Scalars['BigInt']>;
  currentBoostedVotePeriodLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  currentBoostedVotePeriodLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  paramsHash?: InputMaybe<Scalars['String']>;
  paramsHash_not?: InputMaybe<Scalars['String']>;
  paramsHash_gt?: InputMaybe<Scalars['String']>;
  paramsHash_lt?: InputMaybe<Scalars['String']>;
  paramsHash_gte?: InputMaybe<Scalars['String']>;
  paramsHash_lte?: InputMaybe<Scalars['String']>;
  paramsHash_in?: InputMaybe<Array<Scalars['String']>>;
  paramsHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  paramsHash_contains?: InputMaybe<Scalars['String']>;
  paramsHash_contains_nocase?: InputMaybe<Scalars['String']>;
  paramsHash_not_contains?: InputMaybe<Scalars['String']>;
  paramsHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  paramsHash_starts_with?: InputMaybe<Scalars['String']>;
  paramsHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  paramsHash_not_starts_with?: InputMaybe<Scalars['String']>;
  paramsHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  paramsHash_ends_with?: InputMaybe<Scalars['String']>;
  paramsHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  paramsHash_not_ends_with?: InputMaybe<Scalars['String']>;
  paramsHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  daoBounty?: InputMaybe<Scalars['BigInt']>;
  daoBounty_not?: InputMaybe<Scalars['BigInt']>;
  daoBounty_gt?: InputMaybe<Scalars['BigInt']>;
  daoBounty_lt?: InputMaybe<Scalars['BigInt']>;
  daoBounty_gte?: InputMaybe<Scalars['BigInt']>;
  daoBounty_lte?: InputMaybe<Scalars['BigInt']>;
  daoBounty_in?: InputMaybe<Array<Scalars['BigInt']>>;
  daoBounty_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedPhaseTime?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_not?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_gt?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_lt?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_gte?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_lte?: InputMaybe<Scalars['BigInt']>;
  boostedPhaseTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedPhaseTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  preBoostedPhaseTime?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_not?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_gt?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_lt?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_gte?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_lte?: InputMaybe<Scalars['BigInt']>;
  preBoostedPhaseTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  preBoostedPhaseTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  daoRedeemedWinnings?: InputMaybe<Scalars['Boolean']>;
  daoRedeemedWinnings_not?: InputMaybe<Scalars['Boolean']>;
  daoRedeemedWinnings_in?: InputMaybe<Array<Scalars['Boolean']>>;
  daoRedeemedWinnings_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  stakes_?: InputMaybe<Stake_filter>;
  stateLogs_?: InputMaybe<StateLog_filter>;
  votingMachineProposalStateLogs_?: InputMaybe<VotingMachineProposalStateLog_filter>;
};

export type Proposal_orderBy =
  | 'id'
  | 'creator'
  | 'startTime'
  | 'endTime'
  | 'to'
  | 'data'
  | 'value'
  | 'title'
  | 'contentHash'
  | 'contractState'
  | 'guildId'
  | 'guildId__id'
  | 'guildId__name'
  | 'guildId__permissionRegistry'
  | 'guildId__proposalTime'
  | 'guildId__lockTime'
  | 'guildId__timeForExecution'
  | 'guildId__votingPowerPercentageForProposalCreation'
  | 'guildId__votingPowerPercentageForProposalExecution'
  | 'guildId__votingPowerForProposalCreation'
  | 'guildId__votingPowerForProposalExecution'
  | 'guildId__voteGas'
  | 'guildId__maxGasPrice'
  | 'guildId__maxActiveProposals'
  | 'guildId__minimumMembersForProposalCreation'
  | 'guildId__minimumTokensLockedForProposalCreation'
  | 'guildId__type'
  | 'guildId__isActive'
  | 'guildId__bytecodeHash'
  | 'totalVotes'
  | 'votes'
  | 'options'
  | 'snapshotId'
  | 'metadata'
  | 'description'
  | 'executionTransactionHash'
  | 'statesLog'
  | 'scheme'
  | 'scheme__id'
  | 'scheme__name'
  | 'scheme__type'
  | 'scheme__controller'
  | 'scheme__permissionRegistry'
  | 'scheme__maxRepPercentageChange'
  | 'scheme__paramsHash'
  | 'scheme__isRegistered'
  | 'scheme__canManageSchemes'
  | 'scheme__canMakeAvatarCalls'
  | 'scheme__canChangeReputation'
  | 'scheme__stakingTokenBalance'
  | 'scheme__voteGasBalance'
  | 'scheme__voteGas'
  | 'scheme__maxGasPrice'
  | 'scheme__averagesDownstakesOfBoosted'
  | 'scheme__orgBoostedProposalsCnt'
  | 'callData'
  | 'totalOptions'
  | 'state'
  | 'descriptionHash'
  | 'submittedTime'
  | 'snapshot'
  | 'schemeId'
  | 'callbacks'
  | 'votingMachineProposalState'
  | 'votingMachineExecutionState'
  | 'winningVote'
  | 'proposer'
  | 'currentBoostedVotePeriodLimit'
  | 'paramsHash'
  | 'daoBounty'
  | 'boostedPhaseTime'
  | 'preBoostedPhaseTime'
  | 'daoRedeemedWinnings'
  | 'stakes'
  | 'stateLogs'
  | 'votingMachineProposalStateLogs';

export type Token = {
  id: Scalars['ID'];
  type: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  decimals: Scalars['Int'];
  guildAddress: Scalars['String'];
};

export type Token_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  type?: InputMaybe<Scalars['String']>;
  type_not?: InputMaybe<Scalars['String']>;
  type_gt?: InputMaybe<Scalars['String']>;
  type_lt?: InputMaybe<Scalars['String']>;
  type_gte?: InputMaybe<Scalars['String']>;
  type_lte?: InputMaybe<Scalars['String']>;
  type_in?: InputMaybe<Array<Scalars['String']>>;
  type_not_in?: InputMaybe<Array<Scalars['String']>>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_contains_nocase?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']>;
  type_starts_with?: InputMaybe<Scalars['String']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']>;
  type_not_starts_with?: InputMaybe<Scalars['String']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  type_ends_with?: InputMaybe<Scalars['String']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']>;
  type_not_ends_with?: InputMaybe<Scalars['String']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_gt?: InputMaybe<Scalars['String']>;
  symbol_lt?: InputMaybe<Scalars['String']>;
  symbol_gte?: InputMaybe<Scalars['String']>;
  symbol_lte?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  decimals?: InputMaybe<Scalars['Int']>;
  decimals_not?: InputMaybe<Scalars['Int']>;
  decimals_gt?: InputMaybe<Scalars['Int']>;
  decimals_lt?: InputMaybe<Scalars['Int']>;
  decimals_gte?: InputMaybe<Scalars['Int']>;
  decimals_lte?: InputMaybe<Scalars['Int']>;
  decimals_in?: InputMaybe<Array<Scalars['Int']>>;
  decimals_not_in?: InputMaybe<Array<Scalars['Int']>>;
  guildAddress?: InputMaybe<Scalars['String']>;
  guildAddress_not?: InputMaybe<Scalars['String']>;
  guildAddress_gt?: InputMaybe<Scalars['String']>;
  guildAddress_lt?: InputMaybe<Scalars['String']>;
  guildAddress_gte?: InputMaybe<Scalars['String']>;
  guildAddress_lte?: InputMaybe<Scalars['String']>;
  guildAddress_in?: InputMaybe<Array<Scalars['String']>>;
  guildAddress_not_in?: InputMaybe<Array<Scalars['String']>>;
  guildAddress_contains?: InputMaybe<Scalars['String']>;
  guildAddress_contains_nocase?: InputMaybe<Scalars['String']>;
  guildAddress_not_contains?: InputMaybe<Scalars['String']>;
  guildAddress_not_contains_nocase?: InputMaybe<Scalars['String']>;
  guildAddress_starts_with?: InputMaybe<Scalars['String']>;
  guildAddress_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildAddress_not_starts_with?: InputMaybe<Scalars['String']>;
  guildAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  guildAddress_ends_with?: InputMaybe<Scalars['String']>;
  guildAddress_ends_with_nocase?: InputMaybe<Scalars['String']>;
  guildAddress_not_ends_with?: InputMaybe<Scalars['String']>;
  guildAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Token_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Token_filter>>>;
};

export type Token_orderBy =
  | 'id'
  | 'type'
  | 'name'
  | 'symbol'
  | 'decimals'
  | 'guildAddress';

export type Vote = {
  id: Scalars['ID'];
  proposalId: Proposal;
  option: Scalars['BigInt'];
  optionId: Option;
  optionLabel?: Maybe<Scalars['String']>;
  voter: Scalars['String'];
  votingPower: Scalars['BigInt'];
  transactionHash: Scalars['String'];
  proposal: Proposal;
  voterAddress: Scalars['String'];
  member?: Maybe<Member>;
  reputation: Scalars['BigInt'];
  voteLogs?: Maybe<Array<VoteLog>>;
};


export type VotevoteLogsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<VoteLog_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<VoteLog_filter>;
};

export type Vote_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  proposalId?: InputMaybe<Scalars['String']>;
  proposalId_not?: InputMaybe<Scalars['String']>;
  proposalId_gt?: InputMaybe<Scalars['String']>;
  proposalId_lt?: InputMaybe<Scalars['String']>;
  proposalId_gte?: InputMaybe<Scalars['String']>;
  proposalId_lte?: InputMaybe<Scalars['String']>;
  proposalId_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposalId_contains?: InputMaybe<Scalars['String']>;
  proposalId_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_contains?: InputMaybe<Scalars['String']>;
  proposalId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposalId_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with?: InputMaybe<Scalars['String']>;
  proposalId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with?: InputMaybe<Scalars['String']>;
  proposalId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposalId_?: InputMaybe<Proposal_filter>;
  option?: InputMaybe<Scalars['BigInt']>;
  option_not?: InputMaybe<Scalars['BigInt']>;
  option_gt?: InputMaybe<Scalars['BigInt']>;
  option_lt?: InputMaybe<Scalars['BigInt']>;
  option_gte?: InputMaybe<Scalars['BigInt']>;
  option_lte?: InputMaybe<Scalars['BigInt']>;
  option_in?: InputMaybe<Array<Scalars['BigInt']>>;
  option_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  optionId?: InputMaybe<Scalars['String']>;
  optionId_not?: InputMaybe<Scalars['String']>;
  optionId_gt?: InputMaybe<Scalars['String']>;
  optionId_lt?: InputMaybe<Scalars['String']>;
  optionId_gte?: InputMaybe<Scalars['String']>;
  optionId_lte?: InputMaybe<Scalars['String']>;
  optionId_in?: InputMaybe<Array<Scalars['String']>>;
  optionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  optionId_contains?: InputMaybe<Scalars['String']>;
  optionId_contains_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_contains?: InputMaybe<Scalars['String']>;
  optionId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  optionId_starts_with?: InputMaybe<Scalars['String']>;
  optionId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_starts_with?: InputMaybe<Scalars['String']>;
  optionId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_ends_with?: InputMaybe<Scalars['String']>;
  optionId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_not_ends_with?: InputMaybe<Scalars['String']>;
  optionId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  optionId_?: InputMaybe<Option_filter>;
  optionLabel?: InputMaybe<Scalars['String']>;
  optionLabel_not?: InputMaybe<Scalars['String']>;
  optionLabel_gt?: InputMaybe<Scalars['String']>;
  optionLabel_lt?: InputMaybe<Scalars['String']>;
  optionLabel_gte?: InputMaybe<Scalars['String']>;
  optionLabel_lte?: InputMaybe<Scalars['String']>;
  optionLabel_in?: InputMaybe<Array<Scalars['String']>>;
  optionLabel_not_in?: InputMaybe<Array<Scalars['String']>>;
  optionLabel_contains?: InputMaybe<Scalars['String']>;
  optionLabel_contains_nocase?: InputMaybe<Scalars['String']>;
  optionLabel_not_contains?: InputMaybe<Scalars['String']>;
  optionLabel_not_contains_nocase?: InputMaybe<Scalars['String']>;
  optionLabel_starts_with?: InputMaybe<Scalars['String']>;
  optionLabel_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionLabel_not_starts_with?: InputMaybe<Scalars['String']>;
  optionLabel_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  optionLabel_ends_with?: InputMaybe<Scalars['String']>;
  optionLabel_ends_with_nocase?: InputMaybe<Scalars['String']>;
  optionLabel_not_ends_with?: InputMaybe<Scalars['String']>;
  optionLabel_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  voter?: InputMaybe<Scalars['String']>;
  voter_not?: InputMaybe<Scalars['String']>;
  voter_gt?: InputMaybe<Scalars['String']>;
  voter_lt?: InputMaybe<Scalars['String']>;
  voter_gte?: InputMaybe<Scalars['String']>;
  voter_lte?: InputMaybe<Scalars['String']>;
  voter_in?: InputMaybe<Array<Scalars['String']>>;
  voter_not_in?: InputMaybe<Array<Scalars['String']>>;
  voter_contains?: InputMaybe<Scalars['String']>;
  voter_contains_nocase?: InputMaybe<Scalars['String']>;
  voter_not_contains?: InputMaybe<Scalars['String']>;
  voter_not_contains_nocase?: InputMaybe<Scalars['String']>;
  voter_starts_with?: InputMaybe<Scalars['String']>;
  voter_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voter_not_starts_with?: InputMaybe<Scalars['String']>;
  voter_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voter_ends_with?: InputMaybe<Scalars['String']>;
  voter_ends_with_nocase?: InputMaybe<Scalars['String']>;
  voter_not_ends_with?: InputMaybe<Scalars['String']>;
  voter_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  votingPower?: InputMaybe<Scalars['BigInt']>;
  votingPower_not?: InputMaybe<Scalars['BigInt']>;
  votingPower_gt?: InputMaybe<Scalars['BigInt']>;
  votingPower_lt?: InputMaybe<Scalars['BigInt']>;
  votingPower_gte?: InputMaybe<Scalars['BigInt']>;
  votingPower_lte?: InputMaybe<Scalars['BigInt']>;
  votingPower_in?: InputMaybe<Array<Scalars['BigInt']>>;
  votingPower_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['String']>;
  transactionHash_not?: InputMaybe<Scalars['String']>;
  transactionHash_gt?: InputMaybe<Scalars['String']>;
  transactionHash_lt?: InputMaybe<Scalars['String']>;
  transactionHash_gte?: InputMaybe<Scalars['String']>;
  transactionHash_lte?: InputMaybe<Scalars['String']>;
  transactionHash_in?: InputMaybe<Array<Scalars['String']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['String']>>;
  transactionHash_contains?: InputMaybe<Scalars['String']>;
  transactionHash_contains_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_contains?: InputMaybe<Scalars['String']>;
  transactionHash_not_contains_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_starts_with?: InputMaybe<Scalars['String']>;
  transactionHash_starts_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_starts_with?: InputMaybe<Scalars['String']>;
  transactionHash_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_ends_with?: InputMaybe<Scalars['String']>;
  transactionHash_ends_with_nocase?: InputMaybe<Scalars['String']>;
  transactionHash_not_ends_with?: InputMaybe<Scalars['String']>;
  transactionHash_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Vote_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Vote_filter>>>;
  proposal?: InputMaybe<Scalars['String']>;
  proposal_not?: InputMaybe<Scalars['String']>;
  proposal_gt?: InputMaybe<Scalars['String']>;
  proposal_lt?: InputMaybe<Scalars['String']>;
  proposal_gte?: InputMaybe<Scalars['String']>;
  proposal_lte?: InputMaybe<Scalars['String']>;
  proposal_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_contains?: InputMaybe<Scalars['String']>;
  proposal_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_contains?: InputMaybe<Scalars['String']>;
  proposal_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_starts_with?: InputMaybe<Scalars['String']>;
  proposal_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_ends_with?: InputMaybe<Scalars['String']>;
  proposal_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_?: InputMaybe<Proposal_filter>;
  voterAddress?: InputMaybe<Scalars['String']>;
  voterAddress_not?: InputMaybe<Scalars['String']>;
  voterAddress_gt?: InputMaybe<Scalars['String']>;
  voterAddress_lt?: InputMaybe<Scalars['String']>;
  voterAddress_gte?: InputMaybe<Scalars['String']>;
  voterAddress_lte?: InputMaybe<Scalars['String']>;
  voterAddress_in?: InputMaybe<Array<Scalars['String']>>;
  voterAddress_not_in?: InputMaybe<Array<Scalars['String']>>;
  voterAddress_contains?: InputMaybe<Scalars['String']>;
  voterAddress_contains_nocase?: InputMaybe<Scalars['String']>;
  voterAddress_not_contains?: InputMaybe<Scalars['String']>;
  voterAddress_not_contains_nocase?: InputMaybe<Scalars['String']>;
  voterAddress_starts_with?: InputMaybe<Scalars['String']>;
  voterAddress_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voterAddress_not_starts_with?: InputMaybe<Scalars['String']>;
  voterAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voterAddress_ends_with?: InputMaybe<Scalars['String']>;
  voterAddress_ends_with_nocase?: InputMaybe<Scalars['String']>;
  voterAddress_not_ends_with?: InputMaybe<Scalars['String']>;
  voterAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  member?: InputMaybe<Scalars['String']>;
  member_not?: InputMaybe<Scalars['String']>;
  member_gt?: InputMaybe<Scalars['String']>;
  member_lt?: InputMaybe<Scalars['String']>;
  member_gte?: InputMaybe<Scalars['String']>;
  member_lte?: InputMaybe<Scalars['String']>;
  member_in?: InputMaybe<Array<Scalars['String']>>;
  member_not_in?: InputMaybe<Array<Scalars['String']>>;
  member_contains?: InputMaybe<Scalars['String']>;
  member_contains_nocase?: InputMaybe<Scalars['String']>;
  member_not_contains?: InputMaybe<Scalars['String']>;
  member_not_contains_nocase?: InputMaybe<Scalars['String']>;
  member_starts_with?: InputMaybe<Scalars['String']>;
  member_starts_with_nocase?: InputMaybe<Scalars['String']>;
  member_not_starts_with?: InputMaybe<Scalars['String']>;
  member_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  member_ends_with?: InputMaybe<Scalars['String']>;
  member_ends_with_nocase?: InputMaybe<Scalars['String']>;
  member_not_ends_with?: InputMaybe<Scalars['String']>;
  member_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  member_?: InputMaybe<Member_filter>;
  reputation?: InputMaybe<Scalars['BigInt']>;
  reputation_not?: InputMaybe<Scalars['BigInt']>;
  reputation_gt?: InputMaybe<Scalars['BigInt']>;
  reputation_lt?: InputMaybe<Scalars['BigInt']>;
  reputation_gte?: InputMaybe<Scalars['BigInt']>;
  reputation_lte?: InputMaybe<Scalars['BigInt']>;
  reputation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reputation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteLogs_?: InputMaybe<VoteLog_filter>;
};

export type Vote_orderBy =
  | 'id'
  | 'proposalId'
  | 'proposalId__id'
  | 'proposalId__creator'
  | 'proposalId__startTime'
  | 'proposalId__endTime'
  | 'proposalId__title'
  | 'proposalId__contentHash'
  | 'proposalId__contractState'
  | 'proposalId__snapshotId'
  | 'proposalId__metadata'
  | 'proposalId__description'
  | 'proposalId__executionTransactionHash'
  | 'option'
  | 'optionId'
  | 'optionId__id'
  | 'optionId__label'
  | 'optionId__voteAmount'
  | 'optionLabel'
  | 'voter'
  | 'votingPower'
  | 'transactionHash'
  | 'proposal'
  | 'proposal__id'
  | 'proposal__totalOptions'
  | 'proposal__state'
  | 'proposal__title'
  | 'proposal__descriptionHash'
  | 'proposal__submittedTime'
  | 'proposal__snapshot'
  | 'proposal__schemeId'
  | 'proposal__callbacks'
  | 'proposal__votingMachineProposalState'
  | 'proposal__votingMachineExecutionState'
  | 'proposal__winningVote'
  | 'proposal__proposer'
  | 'proposal__currentBoostedVotePeriodLimit'
  | 'proposal__paramsHash'
  | 'proposal__daoBounty'
  | 'proposal__boostedPhaseTime'
  | 'proposal__preBoostedPhaseTime'
  | 'proposal__daoRedeemedWinnings'
  | 'voterAddress'
  | 'member'
  | 'member__id'
  | 'member__address'
  | 'member__reputationTokenAmount'
  | 'reputation'
  | 'voteLogs';

export type _Block_ = {
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export type _SubgraphErrorPolicy_ =
  /** Data will be returned even if the subgraph has indexing errors */
  | 'allow'
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  | 'deny';

export type DAO = {
  id: Scalars['ID'];
  reputationToken: ReputationToken;
  controllerAddress: Scalars['String'];
  schemes?: Maybe<Array<Scheme>>;
};


export type DAOschemesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scheme_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Scheme_filter>;
};

export type DAO_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  reputationToken?: InputMaybe<Scalars['String']>;
  reputationToken_not?: InputMaybe<Scalars['String']>;
  reputationToken_gt?: InputMaybe<Scalars['String']>;
  reputationToken_lt?: InputMaybe<Scalars['String']>;
  reputationToken_gte?: InputMaybe<Scalars['String']>;
  reputationToken_lte?: InputMaybe<Scalars['String']>;
  reputationToken_in?: InputMaybe<Array<Scalars['String']>>;
  reputationToken_not_in?: InputMaybe<Array<Scalars['String']>>;
  reputationToken_contains?: InputMaybe<Scalars['String']>;
  reputationToken_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_contains?: InputMaybe<Scalars['String']>;
  reputationToken_not_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_starts_with?: InputMaybe<Scalars['String']>;
  reputationToken_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_starts_with?: InputMaybe<Scalars['String']>;
  reputationToken_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_ends_with?: InputMaybe<Scalars['String']>;
  reputationToken_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_not_ends_with?: InputMaybe<Scalars['String']>;
  reputationToken_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationToken_?: InputMaybe<ReputationToken_filter>;
  controllerAddress?: InputMaybe<Scalars['String']>;
  controllerAddress_not?: InputMaybe<Scalars['String']>;
  controllerAddress_gt?: InputMaybe<Scalars['String']>;
  controllerAddress_lt?: InputMaybe<Scalars['String']>;
  controllerAddress_gte?: InputMaybe<Scalars['String']>;
  controllerAddress_lte?: InputMaybe<Scalars['String']>;
  controllerAddress_in?: InputMaybe<Array<Scalars['String']>>;
  controllerAddress_not_in?: InputMaybe<Array<Scalars['String']>>;
  controllerAddress_contains?: InputMaybe<Scalars['String']>;
  controllerAddress_contains_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_contains?: InputMaybe<Scalars['String']>;
  controllerAddress_not_contains_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_starts_with?: InputMaybe<Scalars['String']>;
  controllerAddress_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_starts_with?: InputMaybe<Scalars['String']>;
  controllerAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_ends_with?: InputMaybe<Scalars['String']>;
  controllerAddress_ends_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_ends_with?: InputMaybe<Scalars['String']>;
  controllerAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  schemes_?: InputMaybe<Scheme_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DAO_filter>>>;
  or?: InputMaybe<Array<InputMaybe<DAO_filter>>>;
};

export type DAO_orderBy =
  | 'id'
  | 'reputationToken'
  | 'reputationToken__id'
  | 'reputationToken__address'
  | 'reputationToken__name'
  | 'reputationToken__symbol'
  | 'reputationToken__controllerAddress'
  | 'reputationToken__amount'
  | 'reputationToken__currentSnapshotId'
  | 'controllerAddress'
  | 'schemes';

export type Permission = {
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
  functionSignature: Scalars['String'];
  isToken: Scalars['Boolean'];
  valueAllowed: Scalars['BigInt'];
  fromTime: Scalars['BigInt'];
  allowed: Scalars['Boolean'];
};

export type Permission_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  from?: InputMaybe<Scalars['String']>;
  from_not?: InputMaybe<Scalars['String']>;
  from_gt?: InputMaybe<Scalars['String']>;
  from_lt?: InputMaybe<Scalars['String']>;
  from_gte?: InputMaybe<Scalars['String']>;
  from_lte?: InputMaybe<Scalars['String']>;
  from_in?: InputMaybe<Array<Scalars['String']>>;
  from_not_in?: InputMaybe<Array<Scalars['String']>>;
  from_contains?: InputMaybe<Scalars['String']>;
  from_contains_nocase?: InputMaybe<Scalars['String']>;
  from_not_contains?: InputMaybe<Scalars['String']>;
  from_not_contains_nocase?: InputMaybe<Scalars['String']>;
  from_starts_with?: InputMaybe<Scalars['String']>;
  from_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_starts_with?: InputMaybe<Scalars['String']>;
  from_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  from_ends_with?: InputMaybe<Scalars['String']>;
  from_ends_with_nocase?: InputMaybe<Scalars['String']>;
  from_not_ends_with?: InputMaybe<Scalars['String']>;
  from_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  to_not?: InputMaybe<Scalars['String']>;
  to_gt?: InputMaybe<Scalars['String']>;
  to_lt?: InputMaybe<Scalars['String']>;
  to_gte?: InputMaybe<Scalars['String']>;
  to_lte?: InputMaybe<Scalars['String']>;
  to_in?: InputMaybe<Array<Scalars['String']>>;
  to_not_in?: InputMaybe<Array<Scalars['String']>>;
  to_contains?: InputMaybe<Scalars['String']>;
  to_contains_nocase?: InputMaybe<Scalars['String']>;
  to_not_contains?: InputMaybe<Scalars['String']>;
  to_not_contains_nocase?: InputMaybe<Scalars['String']>;
  to_starts_with?: InputMaybe<Scalars['String']>;
  to_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_starts_with?: InputMaybe<Scalars['String']>;
  to_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  to_ends_with?: InputMaybe<Scalars['String']>;
  to_ends_with_nocase?: InputMaybe<Scalars['String']>;
  to_not_ends_with?: InputMaybe<Scalars['String']>;
  to_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  functionSignature?: InputMaybe<Scalars['String']>;
  functionSignature_not?: InputMaybe<Scalars['String']>;
  functionSignature_gt?: InputMaybe<Scalars['String']>;
  functionSignature_lt?: InputMaybe<Scalars['String']>;
  functionSignature_gte?: InputMaybe<Scalars['String']>;
  functionSignature_lte?: InputMaybe<Scalars['String']>;
  functionSignature_in?: InputMaybe<Array<Scalars['String']>>;
  functionSignature_not_in?: InputMaybe<Array<Scalars['String']>>;
  functionSignature_contains?: InputMaybe<Scalars['String']>;
  functionSignature_contains_nocase?: InputMaybe<Scalars['String']>;
  functionSignature_not_contains?: InputMaybe<Scalars['String']>;
  functionSignature_not_contains_nocase?: InputMaybe<Scalars['String']>;
  functionSignature_starts_with?: InputMaybe<Scalars['String']>;
  functionSignature_starts_with_nocase?: InputMaybe<Scalars['String']>;
  functionSignature_not_starts_with?: InputMaybe<Scalars['String']>;
  functionSignature_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  functionSignature_ends_with?: InputMaybe<Scalars['String']>;
  functionSignature_ends_with_nocase?: InputMaybe<Scalars['String']>;
  functionSignature_not_ends_with?: InputMaybe<Scalars['String']>;
  functionSignature_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  isToken?: InputMaybe<Scalars['Boolean']>;
  isToken_not?: InputMaybe<Scalars['Boolean']>;
  isToken_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isToken_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  valueAllowed?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_not?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_gt?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_lt?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_gte?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_lte?: InputMaybe<Scalars['BigInt']>;
  valueAllowed_in?: InputMaybe<Array<Scalars['BigInt']>>;
  valueAllowed_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fromTime?: InputMaybe<Scalars['BigInt']>;
  fromTime_not?: InputMaybe<Scalars['BigInt']>;
  fromTime_gt?: InputMaybe<Scalars['BigInt']>;
  fromTime_lt?: InputMaybe<Scalars['BigInt']>;
  fromTime_gte?: InputMaybe<Scalars['BigInt']>;
  fromTime_lte?: InputMaybe<Scalars['BigInt']>;
  fromTime_in?: InputMaybe<Array<Scalars['BigInt']>>;
  fromTime_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  allowed?: InputMaybe<Scalars['Boolean']>;
  allowed_not?: InputMaybe<Scalars['Boolean']>;
  allowed_in?: InputMaybe<Array<Scalars['Boolean']>>;
  allowed_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Permission_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Permission_filter>>>;
};

export type Permission_orderBy =
  | 'id'
  | 'from'
  | 'to'
  | 'functionSignature'
  | 'isToken'
  | 'valueAllowed'
  | 'fromTime'
  | 'allowed';

export type ProposalState =
  | 'None'
  | 'Submitted'
  | 'Rejected'
  | 'Passed';

export type Redeem = {
  id: Scalars['ID'];
  proposal: Proposal;
  avatar: Scalars['String'];
  redeemer: Scalars['String'];
  amount: Scalars['BigInt'];
  timestamp: Scalars['BigInt'];
  txId: Scalars['String'];
};

export type Redeem_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  proposal?: InputMaybe<Scalars['String']>;
  proposal_not?: InputMaybe<Scalars['String']>;
  proposal_gt?: InputMaybe<Scalars['String']>;
  proposal_lt?: InputMaybe<Scalars['String']>;
  proposal_gte?: InputMaybe<Scalars['String']>;
  proposal_lte?: InputMaybe<Scalars['String']>;
  proposal_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_contains?: InputMaybe<Scalars['String']>;
  proposal_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_contains?: InputMaybe<Scalars['String']>;
  proposal_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_starts_with?: InputMaybe<Scalars['String']>;
  proposal_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_ends_with?: InputMaybe<Scalars['String']>;
  proposal_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_?: InputMaybe<Proposal_filter>;
  avatar?: InputMaybe<Scalars['String']>;
  avatar_not?: InputMaybe<Scalars['String']>;
  avatar_gt?: InputMaybe<Scalars['String']>;
  avatar_lt?: InputMaybe<Scalars['String']>;
  avatar_gte?: InputMaybe<Scalars['String']>;
  avatar_lte?: InputMaybe<Scalars['String']>;
  avatar_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_contains?: InputMaybe<Scalars['String']>;
  avatar_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_contains?: InputMaybe<Scalars['String']>;
  avatar_not_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_starts_with?: InputMaybe<Scalars['String']>;
  avatar_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_ends_with?: InputMaybe<Scalars['String']>;
  avatar_ends_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  redeemer?: InputMaybe<Scalars['String']>;
  redeemer_not?: InputMaybe<Scalars['String']>;
  redeemer_gt?: InputMaybe<Scalars['String']>;
  redeemer_lt?: InputMaybe<Scalars['String']>;
  redeemer_gte?: InputMaybe<Scalars['String']>;
  redeemer_lte?: InputMaybe<Scalars['String']>;
  redeemer_in?: InputMaybe<Array<Scalars['String']>>;
  redeemer_not_in?: InputMaybe<Array<Scalars['String']>>;
  redeemer_contains?: InputMaybe<Scalars['String']>;
  redeemer_contains_nocase?: InputMaybe<Scalars['String']>;
  redeemer_not_contains?: InputMaybe<Scalars['String']>;
  redeemer_not_contains_nocase?: InputMaybe<Scalars['String']>;
  redeemer_starts_with?: InputMaybe<Scalars['String']>;
  redeemer_starts_with_nocase?: InputMaybe<Scalars['String']>;
  redeemer_not_starts_with?: InputMaybe<Scalars['String']>;
  redeemer_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  redeemer_ends_with?: InputMaybe<Scalars['String']>;
  redeemer_ends_with_nocase?: InputMaybe<Scalars['String']>;
  redeemer_not_ends_with?: InputMaybe<Scalars['String']>;
  redeemer_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  txId?: InputMaybe<Scalars['String']>;
  txId_not?: InputMaybe<Scalars['String']>;
  txId_gt?: InputMaybe<Scalars['String']>;
  txId_lt?: InputMaybe<Scalars['String']>;
  txId_gte?: InputMaybe<Scalars['String']>;
  txId_lte?: InputMaybe<Scalars['String']>;
  txId_in?: InputMaybe<Array<Scalars['String']>>;
  txId_not_in?: InputMaybe<Array<Scalars['String']>>;
  txId_contains?: InputMaybe<Scalars['String']>;
  txId_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_not_contains?: InputMaybe<Scalars['String']>;
  txId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_starts_with?: InputMaybe<Scalars['String']>;
  txId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_starts_with?: InputMaybe<Scalars['String']>;
  txId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_ends_with?: InputMaybe<Scalars['String']>;
  txId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_ends_with?: InputMaybe<Scalars['String']>;
  txId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Redeem_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Redeem_filter>>>;
};

export type Redeem_orderBy =
  | 'id'
  | 'proposal'
  | 'proposal__id'
  | 'proposal__totalOptions'
  | 'proposal__state'
  | 'proposal__title'
  | 'proposal__descriptionHash'
  | 'proposal__submittedTime'
  | 'proposal__snapshot'
  | 'proposal__schemeId'
  | 'proposal__callbacks'
  | 'proposal__votingMachineProposalState'
  | 'proposal__votingMachineExecutionState'
  | 'proposal__winningVote'
  | 'proposal__proposer'
  | 'proposal__currentBoostedVotePeriodLimit'
  | 'proposal__paramsHash'
  | 'proposal__daoBounty'
  | 'proposal__boostedPhaseTime'
  | 'proposal__preBoostedPhaseTime'
  | 'proposal__daoRedeemedWinnings'
  | 'avatar'
  | 'redeemer'
  | 'amount'
  | 'timestamp'
  | 'txId';

export type ReputationToken = {
  id: Scalars['ID'];
  address: Scalars['String'];
  members?: Maybe<Array<Member>>;
  name: Scalars['String'];
  symbol: Scalars['String'];
  controllerAddress: Scalars['String'];
  amount: Scalars['BigInt'];
  snapshots?: Maybe<Array<Snapshot>>;
  currentSnapshotId: Scalars['BigInt'];
};


export type ReputationTokenmembersArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Member_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Member_filter>;
};


export type ReputationTokensnapshotsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Snapshot_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Snapshot_filter>;
};

export type ReputationToken_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  address?: InputMaybe<Scalars['String']>;
  address_not?: InputMaybe<Scalars['String']>;
  address_gt?: InputMaybe<Scalars['String']>;
  address_lt?: InputMaybe<Scalars['String']>;
  address_gte?: InputMaybe<Scalars['String']>;
  address_lte?: InputMaybe<Scalars['String']>;
  address_in?: InputMaybe<Array<Scalars['String']>>;
  address_not_in?: InputMaybe<Array<Scalars['String']>>;
  address_contains?: InputMaybe<Scalars['String']>;
  address_contains_nocase?: InputMaybe<Scalars['String']>;
  address_not_contains?: InputMaybe<Scalars['String']>;
  address_not_contains_nocase?: InputMaybe<Scalars['String']>;
  address_starts_with?: InputMaybe<Scalars['String']>;
  address_starts_with_nocase?: InputMaybe<Scalars['String']>;
  address_not_starts_with?: InputMaybe<Scalars['String']>;
  address_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  address_ends_with?: InputMaybe<Scalars['String']>;
  address_ends_with_nocase?: InputMaybe<Scalars['String']>;
  address_not_ends_with?: InputMaybe<Scalars['String']>;
  address_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  members_?: InputMaybe<Member_filter>;
  name?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol?: InputMaybe<Scalars['String']>;
  symbol_not?: InputMaybe<Scalars['String']>;
  symbol_gt?: InputMaybe<Scalars['String']>;
  symbol_lt?: InputMaybe<Scalars['String']>;
  symbol_gte?: InputMaybe<Scalars['String']>;
  symbol_lte?: InputMaybe<Scalars['String']>;
  symbol_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_not_in?: InputMaybe<Array<Scalars['String']>>;
  symbol_contains?: InputMaybe<Scalars['String']>;
  symbol_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_contains?: InputMaybe<Scalars['String']>;
  symbol_not_contains_nocase?: InputMaybe<Scalars['String']>;
  symbol_starts_with?: InputMaybe<Scalars['String']>;
  symbol_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with?: InputMaybe<Scalars['String']>;
  symbol_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_ends_with?: InputMaybe<Scalars['String']>;
  symbol_ends_with_nocase?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with?: InputMaybe<Scalars['String']>;
  symbol_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress?: InputMaybe<Scalars['String']>;
  controllerAddress_not?: InputMaybe<Scalars['String']>;
  controllerAddress_gt?: InputMaybe<Scalars['String']>;
  controllerAddress_lt?: InputMaybe<Scalars['String']>;
  controllerAddress_gte?: InputMaybe<Scalars['String']>;
  controllerAddress_lte?: InputMaybe<Scalars['String']>;
  controllerAddress_in?: InputMaybe<Array<Scalars['String']>>;
  controllerAddress_not_in?: InputMaybe<Array<Scalars['String']>>;
  controllerAddress_contains?: InputMaybe<Scalars['String']>;
  controllerAddress_contains_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_contains?: InputMaybe<Scalars['String']>;
  controllerAddress_not_contains_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_starts_with?: InputMaybe<Scalars['String']>;
  controllerAddress_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_starts_with?: InputMaybe<Scalars['String']>;
  controllerAddress_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_ends_with?: InputMaybe<Scalars['String']>;
  controllerAddress_ends_with_nocase?: InputMaybe<Scalars['String']>;
  controllerAddress_not_ends_with?: InputMaybe<Scalars['String']>;
  controllerAddress_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  snapshots_?: InputMaybe<Snapshot_filter>;
  currentSnapshotId?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_not?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_gt?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_lt?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_gte?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_lte?: InputMaybe<Scalars['BigInt']>;
  currentSnapshotId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  currentSnapshotId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ReputationToken_filter>>>;
  or?: InputMaybe<Array<InputMaybe<ReputationToken_filter>>>;
};

export type ReputationToken_orderBy =
  | 'id'
  | 'address'
  | 'members'
  | 'name'
  | 'symbol'
  | 'controllerAddress'
  | 'amount'
  | 'snapshots'
  | 'currentSnapshotId';

export type Scheme = {
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  avatar: DAO;
  votingMachine: VotingMachine;
  controller: Scalars['String'];
  permissionRegistry: Scalars['String'];
  maxRepPercentageChange: Scalars['BigInt'];
  paramsHash?: Maybe<Scalars['Bytes']>;
  isRegistered?: Maybe<Scalars['Boolean']>;
  canManageSchemes?: Maybe<Scalars['Boolean']>;
  canMakeAvatarCalls?: Maybe<Scalars['Boolean']>;
  canChangeReputation?: Maybe<Scalars['Boolean']>;
  stakingTokenBalance?: Maybe<Scalars['BigInt']>;
  voteGasBalance?: Maybe<Scalars['BigInt']>;
  voteGas?: Maybe<Scalars['BigInt']>;
  maxGasPrice?: Maybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted?: Maybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt?: Maybe<Scalars['BigInt']>;
  proposals?: Maybe<Array<Proposal>>;
};


export type SchemeproposalsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Proposal_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Proposal_filter>;
};

export type Scheme_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_contains_nocase?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_contains_nocase?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_ends_with_nocase?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  type_not?: InputMaybe<Scalars['String']>;
  type_gt?: InputMaybe<Scalars['String']>;
  type_lt?: InputMaybe<Scalars['String']>;
  type_gte?: InputMaybe<Scalars['String']>;
  type_lte?: InputMaybe<Scalars['String']>;
  type_in?: InputMaybe<Array<Scalars['String']>>;
  type_not_in?: InputMaybe<Array<Scalars['String']>>;
  type_contains?: InputMaybe<Scalars['String']>;
  type_contains_nocase?: InputMaybe<Scalars['String']>;
  type_not_contains?: InputMaybe<Scalars['String']>;
  type_not_contains_nocase?: InputMaybe<Scalars['String']>;
  type_starts_with?: InputMaybe<Scalars['String']>;
  type_starts_with_nocase?: InputMaybe<Scalars['String']>;
  type_not_starts_with?: InputMaybe<Scalars['String']>;
  type_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  type_ends_with?: InputMaybe<Scalars['String']>;
  type_ends_with_nocase?: InputMaybe<Scalars['String']>;
  type_not_ends_with?: InputMaybe<Scalars['String']>;
  type_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['String']>;
  avatar_not?: InputMaybe<Scalars['String']>;
  avatar_gt?: InputMaybe<Scalars['String']>;
  avatar_lt?: InputMaybe<Scalars['String']>;
  avatar_gte?: InputMaybe<Scalars['String']>;
  avatar_lte?: InputMaybe<Scalars['String']>;
  avatar_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_contains?: InputMaybe<Scalars['String']>;
  avatar_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_contains?: InputMaybe<Scalars['String']>;
  avatar_not_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_starts_with?: InputMaybe<Scalars['String']>;
  avatar_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_ends_with?: InputMaybe<Scalars['String']>;
  avatar_ends_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_?: InputMaybe<DAO_filter>;
  votingMachine?: InputMaybe<Scalars['String']>;
  votingMachine_not?: InputMaybe<Scalars['String']>;
  votingMachine_gt?: InputMaybe<Scalars['String']>;
  votingMachine_lt?: InputMaybe<Scalars['String']>;
  votingMachine_gte?: InputMaybe<Scalars['String']>;
  votingMachine_lte?: InputMaybe<Scalars['String']>;
  votingMachine_in?: InputMaybe<Array<Scalars['String']>>;
  votingMachine_not_in?: InputMaybe<Array<Scalars['String']>>;
  votingMachine_contains?: InputMaybe<Scalars['String']>;
  votingMachine_contains_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_not_contains?: InputMaybe<Scalars['String']>;
  votingMachine_not_contains_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_starts_with?: InputMaybe<Scalars['String']>;
  votingMachine_starts_with_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_not_starts_with?: InputMaybe<Scalars['String']>;
  votingMachine_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_ends_with?: InputMaybe<Scalars['String']>;
  votingMachine_ends_with_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_not_ends_with?: InputMaybe<Scalars['String']>;
  votingMachine_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  votingMachine_?: InputMaybe<VotingMachine_filter>;
  controller?: InputMaybe<Scalars['String']>;
  controller_not?: InputMaybe<Scalars['String']>;
  controller_gt?: InputMaybe<Scalars['String']>;
  controller_lt?: InputMaybe<Scalars['String']>;
  controller_gte?: InputMaybe<Scalars['String']>;
  controller_lte?: InputMaybe<Scalars['String']>;
  controller_in?: InputMaybe<Array<Scalars['String']>>;
  controller_not_in?: InputMaybe<Array<Scalars['String']>>;
  controller_contains?: InputMaybe<Scalars['String']>;
  controller_contains_nocase?: InputMaybe<Scalars['String']>;
  controller_not_contains?: InputMaybe<Scalars['String']>;
  controller_not_contains_nocase?: InputMaybe<Scalars['String']>;
  controller_starts_with?: InputMaybe<Scalars['String']>;
  controller_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controller_not_starts_with?: InputMaybe<Scalars['String']>;
  controller_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  controller_ends_with?: InputMaybe<Scalars['String']>;
  controller_ends_with_nocase?: InputMaybe<Scalars['String']>;
  controller_not_ends_with?: InputMaybe<Scalars['String']>;
  controller_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry?: InputMaybe<Scalars['String']>;
  permissionRegistry_not?: InputMaybe<Scalars['String']>;
  permissionRegistry_gt?: InputMaybe<Scalars['String']>;
  permissionRegistry_lt?: InputMaybe<Scalars['String']>;
  permissionRegistry_gte?: InputMaybe<Scalars['String']>;
  permissionRegistry_lte?: InputMaybe<Scalars['String']>;
  permissionRegistry_in?: InputMaybe<Array<Scalars['String']>>;
  permissionRegistry_not_in?: InputMaybe<Array<Scalars['String']>>;
  permissionRegistry_contains?: InputMaybe<Scalars['String']>;
  permissionRegistry_contains_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_contains?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_contains_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_starts_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_starts_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_starts_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_ends_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_ends_with_nocase?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_ends_with?: InputMaybe<Scalars['String']>;
  permissionRegistry_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  maxRepPercentageChange?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_not?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_gt?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_lt?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_gte?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_lte?: InputMaybe<Scalars['BigInt']>;
  maxRepPercentageChange_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxRepPercentageChange_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  paramsHash?: InputMaybe<Scalars['Bytes']>;
  paramsHash_not?: InputMaybe<Scalars['Bytes']>;
  paramsHash_gt?: InputMaybe<Scalars['Bytes']>;
  paramsHash_lt?: InputMaybe<Scalars['Bytes']>;
  paramsHash_gte?: InputMaybe<Scalars['Bytes']>;
  paramsHash_lte?: InputMaybe<Scalars['Bytes']>;
  paramsHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  paramsHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  paramsHash_contains?: InputMaybe<Scalars['Bytes']>;
  paramsHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  isRegistered?: InputMaybe<Scalars['Boolean']>;
  isRegistered_not?: InputMaybe<Scalars['Boolean']>;
  isRegistered_in?: InputMaybe<Array<Scalars['Boolean']>>;
  isRegistered_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canManageSchemes?: InputMaybe<Scalars['Boolean']>;
  canManageSchemes_not?: InputMaybe<Scalars['Boolean']>;
  canManageSchemes_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canManageSchemes_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canMakeAvatarCalls?: InputMaybe<Scalars['Boolean']>;
  canMakeAvatarCalls_not?: InputMaybe<Scalars['Boolean']>;
  canMakeAvatarCalls_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canMakeAvatarCalls_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canChangeReputation?: InputMaybe<Scalars['Boolean']>;
  canChangeReputation_not?: InputMaybe<Scalars['Boolean']>;
  canChangeReputation_in?: InputMaybe<Array<Scalars['Boolean']>>;
  canChangeReputation_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  stakingTokenBalance?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_not?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_gt?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_lt?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_gte?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_lte?: InputMaybe<Scalars['BigInt']>;
  stakingTokenBalance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  stakingTokenBalance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGasBalance?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_not?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_gt?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_lt?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_gte?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_lte?: InputMaybe<Scalars['BigInt']>;
  voteGasBalance_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGasBalance_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGas?: InputMaybe<Scalars['BigInt']>;
  voteGas_not?: InputMaybe<Scalars['BigInt']>;
  voteGas_gt?: InputMaybe<Scalars['BigInt']>;
  voteGas_lt?: InputMaybe<Scalars['BigInt']>;
  voteGas_gte?: InputMaybe<Scalars['BigInt']>;
  voteGas_lte?: InputMaybe<Scalars['BigInt']>;
  voteGas_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voteGas_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxGasPrice?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_not?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_gt?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_lt?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_gte?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_lte?: InputMaybe<Scalars['BigInt']>;
  maxGasPrice_in?: InputMaybe<Array<Scalars['BigInt']>>;
  maxGasPrice_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  averagesDownstakesOfBoosted?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_not?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_gt?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_lt?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_gte?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_lte?: InputMaybe<Scalars['BigInt']>;
  averagesDownstakesOfBoosted_in?: InputMaybe<Array<Scalars['BigInt']>>;
  averagesDownstakesOfBoosted_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  orgBoostedProposalsCnt?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_not?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_gt?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_lt?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_gte?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_lte?: InputMaybe<Scalars['BigInt']>;
  orgBoostedProposalsCnt_in?: InputMaybe<Array<Scalars['BigInt']>>;
  orgBoostedProposalsCnt_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  proposals_?: InputMaybe<Proposal_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Scheme_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Scheme_filter>>>;
};

export type Scheme_orderBy =
  | 'id'
  | 'name'
  | 'type'
  | 'avatar'
  | 'avatar__id'
  | 'avatar__controllerAddress'
  | 'votingMachine'
  | 'votingMachine__id'
  | 'votingMachine__queuedVoteRequiredPercentage'
  | 'votingMachine__queuedVotePeriodLimit'
  | 'votingMachine__boostedVotePeriodLimit'
  | 'votingMachine__preBoostedVotePeriodLimit'
  | 'votingMachine__thresholdConst'
  | 'votingMachine__limitExponentValue'
  | 'votingMachine__quietEndingPeriod'
  | 'votingMachine__daoBounty'
  | 'votingMachine__boostedVoteRequiredPercentage'
  | 'controller'
  | 'permissionRegistry'
  | 'maxRepPercentageChange'
  | 'paramsHash'
  | 'isRegistered'
  | 'canManageSchemes'
  | 'canMakeAvatarCalls'
  | 'canChangeReputation'
  | 'stakingTokenBalance'
  | 'voteGasBalance'
  | 'voteGas'
  | 'maxGasPrice'
  | 'averagesDownstakesOfBoosted'
  | 'orgBoostedProposalsCnt'
  | 'proposals';

export type Snapshot = {
  id: Scalars['ID'];
  snapshotId: Scalars['BigInt'];
  value: Scalars['BigInt'];
  reputationTokenSnapshot: ReputationToken;
};

export type Snapshot_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  snapshotId?: InputMaybe<Scalars['BigInt']>;
  snapshotId_not?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  snapshotId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  value?: InputMaybe<Scalars['BigInt']>;
  value_not?: InputMaybe<Scalars['BigInt']>;
  value_gt?: InputMaybe<Scalars['BigInt']>;
  value_lt?: InputMaybe<Scalars['BigInt']>;
  value_gte?: InputMaybe<Scalars['BigInt']>;
  value_lte?: InputMaybe<Scalars['BigInt']>;
  value_in?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reputationTokenSnapshot?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_gt?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_lt?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_gte?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_lte?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_in?: InputMaybe<Array<Scalars['String']>>;
  reputationTokenSnapshot_not_in?: InputMaybe<Array<Scalars['String']>>;
  reputationTokenSnapshot_contains?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_contains?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_contains_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_starts_with?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_starts_with?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_ends_with?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_ends_with?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  reputationTokenSnapshot_?: InputMaybe<ReputationToken_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Snapshot_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Snapshot_filter>>>;
};

export type Snapshot_orderBy =
  | 'id'
  | 'snapshotId'
  | 'value'
  | 'reputationTokenSnapshot'
  | 'reputationTokenSnapshot__id'
  | 'reputationTokenSnapshot__address'
  | 'reputationTokenSnapshot__name'
  | 'reputationTokenSnapshot__symbol'
  | 'reputationTokenSnapshot__controllerAddress'
  | 'reputationTokenSnapshot__amount'
  | 'reputationTokenSnapshot__currentSnapshotId';

export type Stake = {
  id: Scalars['ID'];
  proposal: Proposal;
  avatar: Scalars['String'];
  staker: Scalars['String'];
  option: Scalars['BigInt'];
  amount: Scalars['BigInt'];
  timestamp: Scalars['BigInt'];
  txId: Scalars['String'];
};

export type Stake_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  proposal?: InputMaybe<Scalars['String']>;
  proposal_not?: InputMaybe<Scalars['String']>;
  proposal_gt?: InputMaybe<Scalars['String']>;
  proposal_lt?: InputMaybe<Scalars['String']>;
  proposal_gte?: InputMaybe<Scalars['String']>;
  proposal_lte?: InputMaybe<Scalars['String']>;
  proposal_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_contains?: InputMaybe<Scalars['String']>;
  proposal_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_contains?: InputMaybe<Scalars['String']>;
  proposal_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_starts_with?: InputMaybe<Scalars['String']>;
  proposal_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_ends_with?: InputMaybe<Scalars['String']>;
  proposal_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_?: InputMaybe<Proposal_filter>;
  avatar?: InputMaybe<Scalars['String']>;
  avatar_not?: InputMaybe<Scalars['String']>;
  avatar_gt?: InputMaybe<Scalars['String']>;
  avatar_lt?: InputMaybe<Scalars['String']>;
  avatar_gte?: InputMaybe<Scalars['String']>;
  avatar_lte?: InputMaybe<Scalars['String']>;
  avatar_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_not_in?: InputMaybe<Array<Scalars['String']>>;
  avatar_contains?: InputMaybe<Scalars['String']>;
  avatar_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_contains?: InputMaybe<Scalars['String']>;
  avatar_not_contains_nocase?: InputMaybe<Scalars['String']>;
  avatar_starts_with?: InputMaybe<Scalars['String']>;
  avatar_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with?: InputMaybe<Scalars['String']>;
  avatar_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_ends_with?: InputMaybe<Scalars['String']>;
  avatar_ends_with_nocase?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with?: InputMaybe<Scalars['String']>;
  avatar_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  staker?: InputMaybe<Scalars['String']>;
  staker_not?: InputMaybe<Scalars['String']>;
  staker_gt?: InputMaybe<Scalars['String']>;
  staker_lt?: InputMaybe<Scalars['String']>;
  staker_gte?: InputMaybe<Scalars['String']>;
  staker_lte?: InputMaybe<Scalars['String']>;
  staker_in?: InputMaybe<Array<Scalars['String']>>;
  staker_not_in?: InputMaybe<Array<Scalars['String']>>;
  staker_contains?: InputMaybe<Scalars['String']>;
  staker_contains_nocase?: InputMaybe<Scalars['String']>;
  staker_not_contains?: InputMaybe<Scalars['String']>;
  staker_not_contains_nocase?: InputMaybe<Scalars['String']>;
  staker_starts_with?: InputMaybe<Scalars['String']>;
  staker_starts_with_nocase?: InputMaybe<Scalars['String']>;
  staker_not_starts_with?: InputMaybe<Scalars['String']>;
  staker_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  staker_ends_with?: InputMaybe<Scalars['String']>;
  staker_ends_with_nocase?: InputMaybe<Scalars['String']>;
  staker_not_ends_with?: InputMaybe<Scalars['String']>;
  staker_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  option?: InputMaybe<Scalars['BigInt']>;
  option_not?: InputMaybe<Scalars['BigInt']>;
  option_gt?: InputMaybe<Scalars['BigInt']>;
  option_lt?: InputMaybe<Scalars['BigInt']>;
  option_gte?: InputMaybe<Scalars['BigInt']>;
  option_lte?: InputMaybe<Scalars['BigInt']>;
  option_in?: InputMaybe<Array<Scalars['BigInt']>>;
  option_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  txId?: InputMaybe<Scalars['String']>;
  txId_not?: InputMaybe<Scalars['String']>;
  txId_gt?: InputMaybe<Scalars['String']>;
  txId_lt?: InputMaybe<Scalars['String']>;
  txId_gte?: InputMaybe<Scalars['String']>;
  txId_lte?: InputMaybe<Scalars['String']>;
  txId_in?: InputMaybe<Array<Scalars['String']>>;
  txId_not_in?: InputMaybe<Array<Scalars['String']>>;
  txId_contains?: InputMaybe<Scalars['String']>;
  txId_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_not_contains?: InputMaybe<Scalars['String']>;
  txId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_starts_with?: InputMaybe<Scalars['String']>;
  txId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_starts_with?: InputMaybe<Scalars['String']>;
  txId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_ends_with?: InputMaybe<Scalars['String']>;
  txId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_ends_with?: InputMaybe<Scalars['String']>;
  txId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<Stake_filter>>>;
  or?: InputMaybe<Array<InputMaybe<Stake_filter>>>;
};

export type Stake_orderBy =
  | 'id'
  | 'proposal'
  | 'proposal__id'
  | 'proposal__totalOptions'
  | 'proposal__state'
  | 'proposal__title'
  | 'proposal__descriptionHash'
  | 'proposal__submittedTime'
  | 'proposal__snapshot'
  | 'proposal__schemeId'
  | 'proposal__callbacks'
  | 'proposal__votingMachineProposalState'
  | 'proposal__votingMachineExecutionState'
  | 'proposal__winningVote'
  | 'proposal__proposer'
  | 'proposal__currentBoostedVotePeriodLimit'
  | 'proposal__paramsHash'
  | 'proposal__daoBounty'
  | 'proposal__boostedPhaseTime'
  | 'proposal__preBoostedPhaseTime'
  | 'proposal__daoRedeemedWinnings'
  | 'avatar'
  | 'staker'
  | 'option'
  | 'amount'
  | 'timestamp'
  | 'txId';

export type StateLog = {
  id: Scalars['ID'];
  timestamp: Scalars['BigInt'];
  txId: Scalars['String'];
  state: ProposalState;
  proposal: Proposal;
};

export type StateLog_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  txId?: InputMaybe<Scalars['String']>;
  txId_not?: InputMaybe<Scalars['String']>;
  txId_gt?: InputMaybe<Scalars['String']>;
  txId_lt?: InputMaybe<Scalars['String']>;
  txId_gte?: InputMaybe<Scalars['String']>;
  txId_lte?: InputMaybe<Scalars['String']>;
  txId_in?: InputMaybe<Array<Scalars['String']>>;
  txId_not_in?: InputMaybe<Array<Scalars['String']>>;
  txId_contains?: InputMaybe<Scalars['String']>;
  txId_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_not_contains?: InputMaybe<Scalars['String']>;
  txId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_starts_with?: InputMaybe<Scalars['String']>;
  txId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_starts_with?: InputMaybe<Scalars['String']>;
  txId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_ends_with?: InputMaybe<Scalars['String']>;
  txId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_ends_with?: InputMaybe<Scalars['String']>;
  txId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ProposalState>;
  state_not?: InputMaybe<ProposalState>;
  state_in?: InputMaybe<Array<ProposalState>>;
  state_not_in?: InputMaybe<Array<ProposalState>>;
  proposal?: InputMaybe<Scalars['String']>;
  proposal_not?: InputMaybe<Scalars['String']>;
  proposal_gt?: InputMaybe<Scalars['String']>;
  proposal_lt?: InputMaybe<Scalars['String']>;
  proposal_gte?: InputMaybe<Scalars['String']>;
  proposal_lte?: InputMaybe<Scalars['String']>;
  proposal_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_contains?: InputMaybe<Scalars['String']>;
  proposal_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_contains?: InputMaybe<Scalars['String']>;
  proposal_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_starts_with?: InputMaybe<Scalars['String']>;
  proposal_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_ends_with?: InputMaybe<Scalars['String']>;
  proposal_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_?: InputMaybe<Proposal_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<StateLog_filter>>>;
  or?: InputMaybe<Array<InputMaybe<StateLog_filter>>>;
};

export type StateLog_orderBy =
  | 'id'
  | 'timestamp'
  | 'txId'
  | 'state'
  | 'proposal'
  | 'proposal__id'
  | 'proposal__totalOptions'
  | 'proposal__state'
  | 'proposal__title'
  | 'proposal__descriptionHash'
  | 'proposal__submittedTime'
  | 'proposal__snapshot'
  | 'proposal__schemeId'
  | 'proposal__callbacks'
  | 'proposal__votingMachineProposalState'
  | 'proposal__votingMachineExecutionState'
  | 'proposal__winningVote'
  | 'proposal__proposer'
  | 'proposal__currentBoostedVotePeriodLimit'
  | 'proposal__paramsHash'
  | 'proposal__daoBounty'
  | 'proposal__boostedPhaseTime'
  | 'proposal__preBoostedPhaseTime'
  | 'proposal__daoRedeemedWinnings';

export type VoteLog = {
  id: Scalars['ID'];
  reputation: Scalars['BigInt'];
  timestamp: Scalars['BigInt'];
  txId: Scalars['String'];
  vote: Vote;
};

export type VoteLog_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  reputation?: InputMaybe<Scalars['BigInt']>;
  reputation_not?: InputMaybe<Scalars['BigInt']>;
  reputation_gt?: InputMaybe<Scalars['BigInt']>;
  reputation_lt?: InputMaybe<Scalars['BigInt']>;
  reputation_gte?: InputMaybe<Scalars['BigInt']>;
  reputation_lte?: InputMaybe<Scalars['BigInt']>;
  reputation_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reputation_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  txId?: InputMaybe<Scalars['String']>;
  txId_not?: InputMaybe<Scalars['String']>;
  txId_gt?: InputMaybe<Scalars['String']>;
  txId_lt?: InputMaybe<Scalars['String']>;
  txId_gte?: InputMaybe<Scalars['String']>;
  txId_lte?: InputMaybe<Scalars['String']>;
  txId_in?: InputMaybe<Array<Scalars['String']>>;
  txId_not_in?: InputMaybe<Array<Scalars['String']>>;
  txId_contains?: InputMaybe<Scalars['String']>;
  txId_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_not_contains?: InputMaybe<Scalars['String']>;
  txId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_starts_with?: InputMaybe<Scalars['String']>;
  txId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_starts_with?: InputMaybe<Scalars['String']>;
  txId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_ends_with?: InputMaybe<Scalars['String']>;
  txId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_ends_with?: InputMaybe<Scalars['String']>;
  txId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vote?: InputMaybe<Scalars['String']>;
  vote_not?: InputMaybe<Scalars['String']>;
  vote_gt?: InputMaybe<Scalars['String']>;
  vote_lt?: InputMaybe<Scalars['String']>;
  vote_gte?: InputMaybe<Scalars['String']>;
  vote_lte?: InputMaybe<Scalars['String']>;
  vote_in?: InputMaybe<Array<Scalars['String']>>;
  vote_not_in?: InputMaybe<Array<Scalars['String']>>;
  vote_contains?: InputMaybe<Scalars['String']>;
  vote_contains_nocase?: InputMaybe<Scalars['String']>;
  vote_not_contains?: InputMaybe<Scalars['String']>;
  vote_not_contains_nocase?: InputMaybe<Scalars['String']>;
  vote_starts_with?: InputMaybe<Scalars['String']>;
  vote_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vote_not_starts_with?: InputMaybe<Scalars['String']>;
  vote_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  vote_ends_with?: InputMaybe<Scalars['String']>;
  vote_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vote_not_ends_with?: InputMaybe<Scalars['String']>;
  vote_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  vote_?: InputMaybe<Vote_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VoteLog_filter>>>;
  or?: InputMaybe<Array<InputMaybe<VoteLog_filter>>>;
};

export type VoteLog_orderBy =
  | 'id'
  | 'reputation'
  | 'timestamp'
  | 'txId'
  | 'vote'
  | 'vote__id'
  | 'vote__voterAddress'
  | 'vote__option'
  | 'vote__reputation';

export type VoterSnapshot = {
  id: Scalars['ID'];
  snapshotId: Scalars['BigInt'];
  value: Scalars['BigInt'];
  voter: Member;
};

export type VoterSnapshot_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  snapshotId?: InputMaybe<Scalars['BigInt']>;
  snapshotId_not?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lt?: InputMaybe<Scalars['BigInt']>;
  snapshotId_gte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_lte?: InputMaybe<Scalars['BigInt']>;
  snapshotId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  snapshotId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  value?: InputMaybe<Scalars['BigInt']>;
  value_not?: InputMaybe<Scalars['BigInt']>;
  value_gt?: InputMaybe<Scalars['BigInt']>;
  value_lt?: InputMaybe<Scalars['BigInt']>;
  value_gte?: InputMaybe<Scalars['BigInt']>;
  value_lte?: InputMaybe<Scalars['BigInt']>;
  value_in?: InputMaybe<Array<Scalars['BigInt']>>;
  value_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  voter?: InputMaybe<Scalars['String']>;
  voter_not?: InputMaybe<Scalars['String']>;
  voter_gt?: InputMaybe<Scalars['String']>;
  voter_lt?: InputMaybe<Scalars['String']>;
  voter_gte?: InputMaybe<Scalars['String']>;
  voter_lte?: InputMaybe<Scalars['String']>;
  voter_in?: InputMaybe<Array<Scalars['String']>>;
  voter_not_in?: InputMaybe<Array<Scalars['String']>>;
  voter_contains?: InputMaybe<Scalars['String']>;
  voter_contains_nocase?: InputMaybe<Scalars['String']>;
  voter_not_contains?: InputMaybe<Scalars['String']>;
  voter_not_contains_nocase?: InputMaybe<Scalars['String']>;
  voter_starts_with?: InputMaybe<Scalars['String']>;
  voter_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voter_not_starts_with?: InputMaybe<Scalars['String']>;
  voter_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  voter_ends_with?: InputMaybe<Scalars['String']>;
  voter_ends_with_nocase?: InputMaybe<Scalars['String']>;
  voter_not_ends_with?: InputMaybe<Scalars['String']>;
  voter_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  voter_?: InputMaybe<Member_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VoterSnapshot_filter>>>;
  or?: InputMaybe<Array<InputMaybe<VoterSnapshot_filter>>>;
};

export type VoterSnapshot_orderBy =
  | 'id'
  | 'snapshotId'
  | 'value'
  | 'voter'
  | 'voter__id'
  | 'voter__address'
  | 'voter__reputationTokenAmount';

export type VotingMachine = {
  id: Scalars['ID'];
  queuedVoteRequiredPercentage?: Maybe<Scalars['BigInt']>;
  queuedVotePeriodLimit?: Maybe<Scalars['BigInt']>;
  boostedVotePeriodLimit?: Maybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit?: Maybe<Scalars['BigInt']>;
  thresholdConst?: Maybe<Scalars['BigInt']>;
  limitExponentValue?: Maybe<Scalars['BigInt']>;
  quietEndingPeriod?: Maybe<Scalars['BigInt']>;
  daoBounty?: Maybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage?: Maybe<Scalars['BigInt']>;
  schemes?: Maybe<Array<Scheme>>;
};


export type VotingMachineschemesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scheme_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<Scheme_filter>;
};

export type VotingMachineExecutionState =
  | 'None'
  | 'Failed'
  | 'QueueBarCrossed'
  | 'QueueTimeOut'
  | 'PreBoostedBarCrossed'
  | 'BoostedTimeOut'
  | 'BoostedBarCrossed';

export type VotingMachineProposalState =
  | 'None'
  | 'Expired'
  | 'ExecutedInQueue'
  | 'ExecutedInBoost'
  | 'Queued'
  | 'PreBoosted'
  | 'Boosted'
  | 'QuietEndingPeriod';

export type VotingMachineProposalStateLog = {
  id: Scalars['ID'];
  timestamp: Scalars['BigInt'];
  txId: Scalars['String'];
  state: VotingMachineProposalState;
  proposal: Proposal;
};

export type VotingMachineProposalStateLog_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  timestamp?: InputMaybe<Scalars['BigInt']>;
  timestamp_not?: InputMaybe<Scalars['BigInt']>;
  timestamp_gt?: InputMaybe<Scalars['BigInt']>;
  timestamp_lt?: InputMaybe<Scalars['BigInt']>;
  timestamp_gte?: InputMaybe<Scalars['BigInt']>;
  timestamp_lte?: InputMaybe<Scalars['BigInt']>;
  timestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  timestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  txId?: InputMaybe<Scalars['String']>;
  txId_not?: InputMaybe<Scalars['String']>;
  txId_gt?: InputMaybe<Scalars['String']>;
  txId_lt?: InputMaybe<Scalars['String']>;
  txId_gte?: InputMaybe<Scalars['String']>;
  txId_lte?: InputMaybe<Scalars['String']>;
  txId_in?: InputMaybe<Array<Scalars['String']>>;
  txId_not_in?: InputMaybe<Array<Scalars['String']>>;
  txId_contains?: InputMaybe<Scalars['String']>;
  txId_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_not_contains?: InputMaybe<Scalars['String']>;
  txId_not_contains_nocase?: InputMaybe<Scalars['String']>;
  txId_starts_with?: InputMaybe<Scalars['String']>;
  txId_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_starts_with?: InputMaybe<Scalars['String']>;
  txId_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  txId_ends_with?: InputMaybe<Scalars['String']>;
  txId_ends_with_nocase?: InputMaybe<Scalars['String']>;
  txId_not_ends_with?: InputMaybe<Scalars['String']>;
  txId_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<VotingMachineProposalState>;
  state_not?: InputMaybe<VotingMachineProposalState>;
  state_in?: InputMaybe<Array<VotingMachineProposalState>>;
  state_not_in?: InputMaybe<Array<VotingMachineProposalState>>;
  proposal?: InputMaybe<Scalars['String']>;
  proposal_not?: InputMaybe<Scalars['String']>;
  proposal_gt?: InputMaybe<Scalars['String']>;
  proposal_lt?: InputMaybe<Scalars['String']>;
  proposal_gte?: InputMaybe<Scalars['String']>;
  proposal_lte?: InputMaybe<Scalars['String']>;
  proposal_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_not_in?: InputMaybe<Array<Scalars['String']>>;
  proposal_contains?: InputMaybe<Scalars['String']>;
  proposal_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_contains?: InputMaybe<Scalars['String']>;
  proposal_not_contains_nocase?: InputMaybe<Scalars['String']>;
  proposal_starts_with?: InputMaybe<Scalars['String']>;
  proposal_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with?: InputMaybe<Scalars['String']>;
  proposal_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_ends_with?: InputMaybe<Scalars['String']>;
  proposal_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with?: InputMaybe<Scalars['String']>;
  proposal_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  proposal_?: InputMaybe<Proposal_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VotingMachineProposalStateLog_filter>>>;
  or?: InputMaybe<Array<InputMaybe<VotingMachineProposalStateLog_filter>>>;
};

export type VotingMachineProposalStateLog_orderBy =
  | 'id'
  | 'timestamp'
  | 'txId'
  | 'state'
  | 'proposal'
  | 'proposal__id'
  | 'proposal__totalOptions'
  | 'proposal__state'
  | 'proposal__title'
  | 'proposal__descriptionHash'
  | 'proposal__submittedTime'
  | 'proposal__snapshot'
  | 'proposal__schemeId'
  | 'proposal__callbacks'
  | 'proposal__votingMachineProposalState'
  | 'proposal__votingMachineExecutionState'
  | 'proposal__winningVote'
  | 'proposal__proposer'
  | 'proposal__currentBoostedVotePeriodLimit'
  | 'proposal__paramsHash'
  | 'proposal__daoBounty'
  | 'proposal__boostedPhaseTime'
  | 'proposal__preBoostedPhaseTime'
  | 'proposal__daoRedeemedWinnings';

export type VotingMachine_filter = {
  id?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  queuedVoteRequiredPercentage?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_not?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_gt?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_lt?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_gte?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_lte?: InputMaybe<Scalars['BigInt']>;
  queuedVoteRequiredPercentage_in?: InputMaybe<Array<Scalars['BigInt']>>;
  queuedVoteRequiredPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  queuedVotePeriodLimit?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_not?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_gt?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_lt?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_gte?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_lte?: InputMaybe<Scalars['BigInt']>;
  queuedVotePeriodLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  queuedVotePeriodLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedVotePeriodLimit?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_not?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_gt?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_lt?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_gte?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_lte?: InputMaybe<Scalars['BigInt']>;
  boostedVotePeriodLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedVotePeriodLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  preBoostedVotePeriodLimit?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_not?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_gt?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_lt?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_gte?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_lte?: InputMaybe<Scalars['BigInt']>;
  preBoostedVotePeriodLimit_in?: InputMaybe<Array<Scalars['BigInt']>>;
  preBoostedVotePeriodLimit_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  thresholdConst?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_not?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_gt?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_lt?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_gte?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_lte?: InputMaybe<Scalars['BigInt']>;
  thresholdConst_in?: InputMaybe<Array<Scalars['BigInt']>>;
  thresholdConst_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  limitExponentValue?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_not?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_gt?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_lt?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_gte?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_lte?: InputMaybe<Scalars['BigInt']>;
  limitExponentValue_in?: InputMaybe<Array<Scalars['BigInt']>>;
  limitExponentValue_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  quietEndingPeriod?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_not?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_gt?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_lt?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_gte?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_lte?: InputMaybe<Scalars['BigInt']>;
  quietEndingPeriod_in?: InputMaybe<Array<Scalars['BigInt']>>;
  quietEndingPeriod_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  daoBounty?: InputMaybe<Scalars['BigInt']>;
  daoBounty_not?: InputMaybe<Scalars['BigInt']>;
  daoBounty_gt?: InputMaybe<Scalars['BigInt']>;
  daoBounty_lt?: InputMaybe<Scalars['BigInt']>;
  daoBounty_gte?: InputMaybe<Scalars['BigInt']>;
  daoBounty_lte?: InputMaybe<Scalars['BigInt']>;
  daoBounty_in?: InputMaybe<Array<Scalars['BigInt']>>;
  daoBounty_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedVoteRequiredPercentage?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_not?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_gt?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_lt?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_gte?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_lte?: InputMaybe<Scalars['BigInt']>;
  boostedVoteRequiredPercentage_in?: InputMaybe<Array<Scalars['BigInt']>>;
  boostedVoteRequiredPercentage_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  schemes_?: InputMaybe<Scheme_filter>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<VotingMachine_filter>>>;
  or?: InputMaybe<Array<InputMaybe<VotingMachine_filter>>>;
};

export type VotingMachine_orderBy =
  | 'id'
  | 'queuedVoteRequiredPercentage'
  | 'queuedVotePeriodLimit'
  | 'boostedVotePeriodLimit'
  | 'preBoostedVotePeriodLimit'
  | 'thresholdConst'
  | 'limitExponentValue'
  | 'quietEndingPeriod'
  | 'daoBounty'
  | 'boostedVoteRequiredPercentage'
  | 'schemes';

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string | ((fieldNode: FieldNode) => SelectionSetNode);
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  Query: ResolverTypeWrapper<{}>;
  Subscription: ResolverTypeWrapper<{}>;
  Action: ResolverTypeWrapper<Action>;
  Action_filter: Action_filter;
  Action_orderBy: Action_orderBy;
  BigDecimal: ResolverTypeWrapper<Scalars['BigDecimal']>;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']>;
  BlockChangedFilter: BlockChangedFilter;
  Block_height: Block_height;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Bytes: ResolverTypeWrapper<Scalars['Bytes']>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Guild: ResolverTypeWrapper<Guild>;
  GuildPermission: ResolverTypeWrapper<GuildPermission>;
  GuildPermission_filter: GuildPermission_filter;
  GuildPermission_orderBy: GuildPermission_orderBy;
  GuildType: GuildType;
  Guild_filter: Guild_filter;
  Guild_orderBy: Guild_orderBy;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Member: ResolverTypeWrapper<Member>;
  Member_filter: Member_filter;
  Member_orderBy: Member_orderBy;
  Option: ResolverTypeWrapper<Option>;
  Option_filter: Option_filter;
  Option_orderBy: Option_orderBy;
  OrderDirection: OrderDirection;
  Proposal: ResolverTypeWrapper<Proposal>;
  ProposalStateLog: ResolverTypeWrapper<ProposalStateLog>;
  ProposalStateLog_filter: ProposalStateLog_filter;
  ProposalStateLog_orderBy: ProposalStateLog_orderBy;
  Proposal_filter: Proposal_filter;
  Proposal_orderBy: Proposal_orderBy;
  String: ResolverTypeWrapper<Scalars['String']>;
  Token: ResolverTypeWrapper<Token>;
  Token_filter: Token_filter;
  Token_orderBy: Token_orderBy;
  Vote: ResolverTypeWrapper<Vote>;
  Vote_filter: Vote_filter;
  Vote_orderBy: Vote_orderBy;
  _Block_: ResolverTypeWrapper<_Block_>;
  _Meta_: ResolverTypeWrapper<_Meta_>;
  _SubgraphErrorPolicy_: _SubgraphErrorPolicy_;
  DAO: ResolverTypeWrapper<DAO>;
  DAO_filter: DAO_filter;
  DAO_orderBy: DAO_orderBy;
  Permission: ResolverTypeWrapper<Permission>;
  Permission_filter: Permission_filter;
  Permission_orderBy: Permission_orderBy;
  ProposalState: ProposalState;
  Redeem: ResolverTypeWrapper<Redeem>;
  Redeem_filter: Redeem_filter;
  Redeem_orderBy: Redeem_orderBy;
  ReputationToken: ResolverTypeWrapper<ReputationToken>;
  ReputationToken_filter: ReputationToken_filter;
  ReputationToken_orderBy: ReputationToken_orderBy;
  Scheme: ResolverTypeWrapper<Scheme>;
  Scheme_filter: Scheme_filter;
  Scheme_orderBy: Scheme_orderBy;
  Snapshot: ResolverTypeWrapper<Snapshot>;
  Snapshot_filter: Snapshot_filter;
  Snapshot_orderBy: Snapshot_orderBy;
  Stake: ResolverTypeWrapper<Stake>;
  Stake_filter: Stake_filter;
  Stake_orderBy: Stake_orderBy;
  StateLog: ResolverTypeWrapper<StateLog>;
  StateLog_filter: StateLog_filter;
  StateLog_orderBy: StateLog_orderBy;
  VoteLog: ResolverTypeWrapper<VoteLog>;
  VoteLog_filter: VoteLog_filter;
  VoteLog_orderBy: VoteLog_orderBy;
  VoterSnapshot: ResolverTypeWrapper<VoterSnapshot>;
  VoterSnapshot_filter: VoterSnapshot_filter;
  VoterSnapshot_orderBy: VoterSnapshot_orderBy;
  VotingMachine: ResolverTypeWrapper<VotingMachine>;
  VotingMachineExecutionState: VotingMachineExecutionState;
  VotingMachineProposalState: VotingMachineProposalState;
  VotingMachineProposalStateLog: ResolverTypeWrapper<VotingMachineProposalStateLog>;
  VotingMachineProposalStateLog_filter: VotingMachineProposalStateLog_filter;
  VotingMachineProposalStateLog_orderBy: VotingMachineProposalStateLog_orderBy;
  VotingMachine_filter: VotingMachine_filter;
  VotingMachine_orderBy: VotingMachine_orderBy;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  Query: {};
  Subscription: {};
  Action: Action;
  Action_filter: Action_filter;
  BigDecimal: Scalars['BigDecimal'];
  BigInt: Scalars['BigInt'];
  BlockChangedFilter: BlockChangedFilter;
  Block_height: Block_height;
  Boolean: Scalars['Boolean'];
  Bytes: Scalars['Bytes'];
  Float: Scalars['Float'];
  Guild: Guild;
  GuildPermission: GuildPermission;
  GuildPermission_filter: GuildPermission_filter;
  Guild_filter: Guild_filter;
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  Member: Member;
  Member_filter: Member_filter;
  Option: Option;
  Option_filter: Option_filter;
  Proposal: Proposal;
  ProposalStateLog: ProposalStateLog;
  ProposalStateLog_filter: ProposalStateLog_filter;
  Proposal_filter: Proposal_filter;
  String: Scalars['String'];
  Token: Token;
  Token_filter: Token_filter;
  Vote: Vote;
  Vote_filter: Vote_filter;
  _Block_: _Block_;
  _Meta_: _Meta_;
  DAO: DAO;
  DAO_filter: DAO_filter;
  Permission: Permission;
  Permission_filter: Permission_filter;
  Redeem: Redeem;
  Redeem_filter: Redeem_filter;
  ReputationToken: ReputationToken;
  ReputationToken_filter: ReputationToken_filter;
  Scheme: Scheme;
  Scheme_filter: Scheme_filter;
  Snapshot: Snapshot;
  Snapshot_filter: Snapshot_filter;
  Stake: Stake;
  Stake_filter: Stake_filter;
  StateLog: StateLog;
  StateLog_filter: StateLog_filter;
  VoteLog: VoteLog;
  VoteLog_filter: VoteLog_filter;
  VoterSnapshot: VoterSnapshot;
  VoterSnapshot_filter: VoterSnapshot_filter;
  VotingMachine: VotingMachine;
  VotingMachineProposalStateLog: VotingMachineProposalStateLog;
  VotingMachineProposalStateLog_filter: VotingMachineProposalStateLog_filter;
  VotingMachine_filter: VotingMachine_filter;
}>;

export type entityDirectiveArgs = { };

export type entityDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = entityDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type subgraphIdDirectiveArgs = {
  id: Scalars['String'];
};

export type subgraphIdDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = subgraphIdDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type derivedFromDirectiveArgs = {
  field: Scalars['String'];
};

export type derivedFromDirectiveResolver<Result, Parent, ContextType = MeshContext, Args = derivedFromDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type QueryResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  proposal?: Resolver<Maybe<ResolversTypes['Proposal']>, ParentType, ContextType, RequireFields<QueryproposalArgs, 'id' | 'subgraphError'>>;
  proposals?: Resolver<Array<ResolversTypes['Proposal']>, ParentType, ContextType, RequireFields<QueryproposalsArgs, 'skip' | 'first' | 'subgraphError'>>;
  proposalStateLog?: Resolver<Maybe<ResolversTypes['ProposalStateLog']>, ParentType, ContextType, RequireFields<QueryproposalStateLogArgs, 'id' | 'subgraphError'>>;
  proposalStateLogs?: Resolver<Array<ResolversTypes['ProposalStateLog']>, ParentType, ContextType, RequireFields<QueryproposalStateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  option?: Resolver<Maybe<ResolversTypes['Option']>, ParentType, ContextType, RequireFields<QueryoptionArgs, 'id' | 'subgraphError'>>;
  options?: Resolver<Array<ResolversTypes['Option']>, ParentType, ContextType, RequireFields<QueryoptionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  action?: Resolver<Maybe<ResolversTypes['Action']>, ParentType, ContextType, RequireFields<QueryactionArgs, 'id' | 'subgraphError'>>;
  actions?: Resolver<Array<ResolversTypes['Action']>, ParentType, ContextType, RequireFields<QueryactionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  vote?: Resolver<Maybe<ResolversTypes['Vote']>, ParentType, ContextType, RequireFields<QueryvoteArgs, 'id' | 'subgraphError'>>;
  votes?: Resolver<Array<ResolversTypes['Vote']>, ParentType, ContextType, RequireFields<QueryvotesArgs, 'skip' | 'first' | 'subgraphError'>>;
  member?: Resolver<Maybe<ResolversTypes['Member']>, ParentType, ContextType, RequireFields<QuerymemberArgs, 'id' | 'subgraphError'>>;
  members?: Resolver<Array<ResolversTypes['Member']>, ParentType, ContextType, RequireFields<QuerymembersArgs, 'skip' | 'first' | 'subgraphError'>>;
  guild?: Resolver<Maybe<ResolversTypes['Guild']>, ParentType, ContextType, RequireFields<QueryguildArgs, 'id' | 'subgraphError'>>;
  guilds?: Resolver<Array<ResolversTypes['Guild']>, ParentType, ContextType, RequireFields<QueryguildsArgs, 'skip' | 'first' | 'subgraphError'>>;
  token?: Resolver<Maybe<ResolversTypes['Token']>, ParentType, ContextType, RequireFields<QuerytokenArgs, 'id' | 'subgraphError'>>;
  tokens?: Resolver<Array<ResolversTypes['Token']>, ParentType, ContextType, RequireFields<QuerytokensArgs, 'skip' | 'first' | 'subgraphError'>>;
  guildPermission?: Resolver<Maybe<ResolversTypes['GuildPermission']>, ParentType, ContextType, RequireFields<QueryguildPermissionArgs, 'id' | 'subgraphError'>>;
  guildPermissions?: Resolver<Array<ResolversTypes['GuildPermission']>, ParentType, ContextType, RequireFields<QueryguildPermissionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  _meta?: Resolver<Maybe<ResolversTypes['_Meta_']>, ParentType, ContextType, Partial<Query_metaArgs>>;
  dao?: Resolver<Maybe<ResolversTypes['DAO']>, ParentType, ContextType, RequireFields<QuerydaoArgs, 'id' | 'subgraphError'>>;
  daos?: Resolver<Array<ResolversTypes['DAO']>, ParentType, ContextType, RequireFields<QuerydaosArgs, 'skip' | 'first' | 'subgraphError'>>;
  scheme?: Resolver<Maybe<ResolversTypes['Scheme']>, ParentType, ContextType, RequireFields<QueryschemeArgs, 'id' | 'subgraphError'>>;
  schemes?: Resolver<Array<ResolversTypes['Scheme']>, ParentType, ContextType, RequireFields<QueryschemesArgs, 'skip' | 'first' | 'subgraphError'>>;
  votingMachine?: Resolver<Maybe<ResolversTypes['VotingMachine']>, ParentType, ContextType, RequireFields<QueryvotingMachineArgs, 'id' | 'subgraphError'>>;
  votingMachines?: Resolver<Array<ResolversTypes['VotingMachine']>, ParentType, ContextType, RequireFields<QueryvotingMachinesArgs, 'skip' | 'first' | 'subgraphError'>>;
  reputationToken?: Resolver<Maybe<ResolversTypes['ReputationToken']>, ParentType, ContextType, RequireFields<QueryreputationTokenArgs, 'id' | 'subgraphError'>>;
  reputationTokens?: Resolver<Array<ResolversTypes['ReputationToken']>, ParentType, ContextType, RequireFields<QueryreputationTokensArgs, 'skip' | 'first' | 'subgraphError'>>;
  snapshot?: Resolver<Maybe<ResolversTypes['Snapshot']>, ParentType, ContextType, RequireFields<QuerysnapshotArgs, 'id' | 'subgraphError'>>;
  snapshots?: Resolver<Array<ResolversTypes['Snapshot']>, ParentType, ContextType, RequireFields<QuerysnapshotsArgs, 'skip' | 'first' | 'subgraphError'>>;
  voterSnapshot?: Resolver<Maybe<ResolversTypes['VoterSnapshot']>, ParentType, ContextType, RequireFields<QueryvoterSnapshotArgs, 'id' | 'subgraphError'>>;
  voterSnapshots?: Resolver<Array<ResolversTypes['VoterSnapshot']>, ParentType, ContextType, RequireFields<QueryvoterSnapshotsArgs, 'skip' | 'first' | 'subgraphError'>>;
  permission?: Resolver<Maybe<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<QuerypermissionArgs, 'id' | 'subgraphError'>>;
  permissions?: Resolver<Array<ResolversTypes['Permission']>, ParentType, ContextType, RequireFields<QuerypermissionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  stateLog?: Resolver<Maybe<ResolversTypes['StateLog']>, ParentType, ContextType, RequireFields<QuerystateLogArgs, 'id' | 'subgraphError'>>;
  stateLogs?: Resolver<Array<ResolversTypes['StateLog']>, ParentType, ContextType, RequireFields<QuerystateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  votingMachineProposalStateLog?: Resolver<Maybe<ResolversTypes['VotingMachineProposalStateLog']>, ParentType, ContextType, RequireFields<QueryvotingMachineProposalStateLogArgs, 'id' | 'subgraphError'>>;
  votingMachineProposalStateLogs?: Resolver<Array<ResolversTypes['VotingMachineProposalStateLog']>, ParentType, ContextType, RequireFields<QueryvotingMachineProposalStateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  voteLog?: Resolver<Maybe<ResolversTypes['VoteLog']>, ParentType, ContextType, RequireFields<QueryvoteLogArgs, 'id' | 'subgraphError'>>;
  voteLogs?: Resolver<Array<ResolversTypes['VoteLog']>, ParentType, ContextType, RequireFields<QueryvoteLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  stake?: Resolver<Maybe<ResolversTypes['Stake']>, ParentType, ContextType, RequireFields<QuerystakeArgs, 'id' | 'subgraphError'>>;
  stakes?: Resolver<Array<ResolversTypes['Stake']>, ParentType, ContextType, RequireFields<QuerystakesArgs, 'skip' | 'first' | 'subgraphError'>>;
  redeem?: Resolver<Maybe<ResolversTypes['Redeem']>, ParentType, ContextType, RequireFields<QueryredeemArgs, 'id' | 'subgraphError'>>;
  redeems?: Resolver<Array<ResolversTypes['Redeem']>, ParentType, ContextType, RequireFields<QueryredeemsArgs, 'skip' | 'first' | 'subgraphError'>>;
}>;

export type SubscriptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  proposal?: SubscriptionResolver<Maybe<ResolversTypes['Proposal']>, "proposal", ParentType, ContextType, RequireFields<SubscriptionproposalArgs, 'id' | 'subgraphError'>>;
  proposals?: SubscriptionResolver<Array<ResolversTypes['Proposal']>, "proposals", ParentType, ContextType, RequireFields<SubscriptionproposalsArgs, 'skip' | 'first' | 'subgraphError'>>;
  proposalStateLog?: SubscriptionResolver<Maybe<ResolversTypes['ProposalStateLog']>, "proposalStateLog", ParentType, ContextType, RequireFields<SubscriptionproposalStateLogArgs, 'id' | 'subgraphError'>>;
  proposalStateLogs?: SubscriptionResolver<Array<ResolversTypes['ProposalStateLog']>, "proposalStateLogs", ParentType, ContextType, RequireFields<SubscriptionproposalStateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  option?: SubscriptionResolver<Maybe<ResolversTypes['Option']>, "option", ParentType, ContextType, RequireFields<SubscriptionoptionArgs, 'id' | 'subgraphError'>>;
  options?: SubscriptionResolver<Array<ResolversTypes['Option']>, "options", ParentType, ContextType, RequireFields<SubscriptionoptionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  action?: SubscriptionResolver<Maybe<ResolversTypes['Action']>, "action", ParentType, ContextType, RequireFields<SubscriptionactionArgs, 'id' | 'subgraphError'>>;
  actions?: SubscriptionResolver<Array<ResolversTypes['Action']>, "actions", ParentType, ContextType, RequireFields<SubscriptionactionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  vote?: SubscriptionResolver<Maybe<ResolversTypes['Vote']>, "vote", ParentType, ContextType, RequireFields<SubscriptionvoteArgs, 'id' | 'subgraphError'>>;
  votes?: SubscriptionResolver<Array<ResolversTypes['Vote']>, "votes", ParentType, ContextType, RequireFields<SubscriptionvotesArgs, 'skip' | 'first' | 'subgraphError'>>;
  member?: SubscriptionResolver<Maybe<ResolversTypes['Member']>, "member", ParentType, ContextType, RequireFields<SubscriptionmemberArgs, 'id' | 'subgraphError'>>;
  members?: SubscriptionResolver<Array<ResolversTypes['Member']>, "members", ParentType, ContextType, RequireFields<SubscriptionmembersArgs, 'skip' | 'first' | 'subgraphError'>>;
  guild?: SubscriptionResolver<Maybe<ResolversTypes['Guild']>, "guild", ParentType, ContextType, RequireFields<SubscriptionguildArgs, 'id' | 'subgraphError'>>;
  guilds?: SubscriptionResolver<Array<ResolversTypes['Guild']>, "guilds", ParentType, ContextType, RequireFields<SubscriptionguildsArgs, 'skip' | 'first' | 'subgraphError'>>;
  token?: SubscriptionResolver<Maybe<ResolversTypes['Token']>, "token", ParentType, ContextType, RequireFields<SubscriptiontokenArgs, 'id' | 'subgraphError'>>;
  tokens?: SubscriptionResolver<Array<ResolversTypes['Token']>, "tokens", ParentType, ContextType, RequireFields<SubscriptiontokensArgs, 'skip' | 'first' | 'subgraphError'>>;
  guildPermission?: SubscriptionResolver<Maybe<ResolversTypes['GuildPermission']>, "guildPermission", ParentType, ContextType, RequireFields<SubscriptionguildPermissionArgs, 'id' | 'subgraphError'>>;
  guildPermissions?: SubscriptionResolver<Array<ResolversTypes['GuildPermission']>, "guildPermissions", ParentType, ContextType, RequireFields<SubscriptionguildPermissionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  _meta?: SubscriptionResolver<Maybe<ResolversTypes['_Meta_']>, "_meta", ParentType, ContextType, Partial<Subscription_metaArgs>>;
  dao?: SubscriptionResolver<Maybe<ResolversTypes['DAO']>, "dao", ParentType, ContextType, RequireFields<SubscriptiondaoArgs, 'id' | 'subgraphError'>>;
  daos?: SubscriptionResolver<Array<ResolversTypes['DAO']>, "daos", ParentType, ContextType, RequireFields<SubscriptiondaosArgs, 'skip' | 'first' | 'subgraphError'>>;
  scheme?: SubscriptionResolver<Maybe<ResolversTypes['Scheme']>, "scheme", ParentType, ContextType, RequireFields<SubscriptionschemeArgs, 'id' | 'subgraphError'>>;
  schemes?: SubscriptionResolver<Array<ResolversTypes['Scheme']>, "schemes", ParentType, ContextType, RequireFields<SubscriptionschemesArgs, 'skip' | 'first' | 'subgraphError'>>;
  votingMachine?: SubscriptionResolver<Maybe<ResolversTypes['VotingMachine']>, "votingMachine", ParentType, ContextType, RequireFields<SubscriptionvotingMachineArgs, 'id' | 'subgraphError'>>;
  votingMachines?: SubscriptionResolver<Array<ResolversTypes['VotingMachine']>, "votingMachines", ParentType, ContextType, RequireFields<SubscriptionvotingMachinesArgs, 'skip' | 'first' | 'subgraphError'>>;
  reputationToken?: SubscriptionResolver<Maybe<ResolversTypes['ReputationToken']>, "reputationToken", ParentType, ContextType, RequireFields<SubscriptionreputationTokenArgs, 'id' | 'subgraphError'>>;
  reputationTokens?: SubscriptionResolver<Array<ResolversTypes['ReputationToken']>, "reputationTokens", ParentType, ContextType, RequireFields<SubscriptionreputationTokensArgs, 'skip' | 'first' | 'subgraphError'>>;
  snapshot?: SubscriptionResolver<Maybe<ResolversTypes['Snapshot']>, "snapshot", ParentType, ContextType, RequireFields<SubscriptionsnapshotArgs, 'id' | 'subgraphError'>>;
  snapshots?: SubscriptionResolver<Array<ResolversTypes['Snapshot']>, "snapshots", ParentType, ContextType, RequireFields<SubscriptionsnapshotsArgs, 'skip' | 'first' | 'subgraphError'>>;
  voterSnapshot?: SubscriptionResolver<Maybe<ResolversTypes['VoterSnapshot']>, "voterSnapshot", ParentType, ContextType, RequireFields<SubscriptionvoterSnapshotArgs, 'id' | 'subgraphError'>>;
  voterSnapshots?: SubscriptionResolver<Array<ResolversTypes['VoterSnapshot']>, "voterSnapshots", ParentType, ContextType, RequireFields<SubscriptionvoterSnapshotsArgs, 'skip' | 'first' | 'subgraphError'>>;
  permission?: SubscriptionResolver<Maybe<ResolversTypes['Permission']>, "permission", ParentType, ContextType, RequireFields<SubscriptionpermissionArgs, 'id' | 'subgraphError'>>;
  permissions?: SubscriptionResolver<Array<ResolversTypes['Permission']>, "permissions", ParentType, ContextType, RequireFields<SubscriptionpermissionsArgs, 'skip' | 'first' | 'subgraphError'>>;
  stateLog?: SubscriptionResolver<Maybe<ResolversTypes['StateLog']>, "stateLog", ParentType, ContextType, RequireFields<SubscriptionstateLogArgs, 'id' | 'subgraphError'>>;
  stateLogs?: SubscriptionResolver<Array<ResolversTypes['StateLog']>, "stateLogs", ParentType, ContextType, RequireFields<SubscriptionstateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  votingMachineProposalStateLog?: SubscriptionResolver<Maybe<ResolversTypes['VotingMachineProposalStateLog']>, "votingMachineProposalStateLog", ParentType, ContextType, RequireFields<SubscriptionvotingMachineProposalStateLogArgs, 'id' | 'subgraphError'>>;
  votingMachineProposalStateLogs?: SubscriptionResolver<Array<ResolversTypes['VotingMachineProposalStateLog']>, "votingMachineProposalStateLogs", ParentType, ContextType, RequireFields<SubscriptionvotingMachineProposalStateLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  voteLog?: SubscriptionResolver<Maybe<ResolversTypes['VoteLog']>, "voteLog", ParentType, ContextType, RequireFields<SubscriptionvoteLogArgs, 'id' | 'subgraphError'>>;
  voteLogs?: SubscriptionResolver<Array<ResolversTypes['VoteLog']>, "voteLogs", ParentType, ContextType, RequireFields<SubscriptionvoteLogsArgs, 'skip' | 'first' | 'subgraphError'>>;
  stake?: SubscriptionResolver<Maybe<ResolversTypes['Stake']>, "stake", ParentType, ContextType, RequireFields<SubscriptionstakeArgs, 'id' | 'subgraphError'>>;
  stakes?: SubscriptionResolver<Array<ResolversTypes['Stake']>, "stakes", ParentType, ContextType, RequireFields<SubscriptionstakesArgs, 'skip' | 'first' | 'subgraphError'>>;
  redeem?: SubscriptionResolver<Maybe<ResolversTypes['Redeem']>, "redeem", ParentType, ContextType, RequireFields<SubscriptionredeemArgs, 'id' | 'subgraphError'>>;
  redeems?: SubscriptionResolver<Array<ResolversTypes['Redeem']>, "redeems", ParentType, ContextType, RequireFields<SubscriptionredeemsArgs, 'skip' | 'first' | 'subgraphError'>>;
}>;

export type ActionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Action'] = ResolversParentTypes['Action']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['Option'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface BigDecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigDecimal'], any> {
  name: 'BigDecimal';
}

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export interface BytesScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Bytes'], any> {
  name: 'Bytes';
}

export type GuildResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Guild'] = ResolversParentTypes['Guild']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['Token']>, ParentType, ContextType>;
  permissionRegistry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proposalTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  lockTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  timeForExecution?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  votingPowerPercentageForProposalCreation?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  votingPowerPercentageForProposalExecution?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  votingPowerForProposalCreation?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  votingPowerForProposalExecution?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  voteGas?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxGasPrice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxActiveProposals?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  minimumMembersForProposalCreation?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  minimumTokensLockedForProposalCreation?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['GuildType']>, ParentType, ContextType>;
  permissions?: Resolver<Array<ResolversTypes['GuildPermission']>, ParentType, ContextType, RequireFields<GuildpermissionsArgs, 'skip' | 'first'>>;
  proposals?: Resolver<Maybe<Array<ResolversTypes['Proposal']>>, ParentType, ContextType, RequireFields<GuildproposalsArgs, 'skip' | 'first'>>;
  members?: Resolver<Maybe<Array<ResolversTypes['Member']>>, ParentType, ContextType, RequireFields<GuildmembersArgs, 'skip' | 'first'>>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bytecodeHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GuildPermissionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['GuildPermission'] = ResolversParentTypes['GuildPermission']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  functionSignature?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  isToken?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  valueAllowed?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  fromTime?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  allowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  guild?: Resolver<Maybe<ResolversTypes['Guild']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MemberResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Member'] = ResolversParentTypes['Member']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  guildId?: Resolver<ResolversTypes['Guild'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tokensLocked?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reputationToken?: Resolver<Maybe<ResolversTypes['ReputationToken']>, ParentType, ContextType>;
  reputationTokenAmount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  votes?: Resolver<Maybe<Array<ResolversTypes['Vote']>>, ParentType, ContextType, RequireFields<MembervotesArgs, 'skip' | 'first'>>;
  snapshots?: Resolver<Maybe<Array<ResolversTypes['VoterSnapshot']>>, ParentType, ContextType, RequireFields<MembersnapshotsArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OptionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Option'] = ResolversParentTypes['Option']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  proposalId?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  actions?: Resolver<Maybe<Array<ResolversTypes['Action']>>, ParentType, ContextType, RequireFields<OptionactionsArgs, 'skip' | 'first'>>;
  voteAmount?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  votes?: Resolver<Maybe<Array<ResolversTypes['Vote']>>, ParentType, ContextType, RequireFields<OptionvotesArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProposalResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Proposal'] = ResolversParentTypes['Proposal']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  creator?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  to?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  value?: Resolver<Maybe<Array<ResolversTypes['BigInt']>>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contractState?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  guildId?: Resolver<ResolversTypes['Guild'], ParentType, ContextType>;
  totalVotes?: Resolver<Maybe<Array<ResolversTypes['BigInt']>>, ParentType, ContextType>;
  votes?: Resolver<Maybe<Array<ResolversTypes['Vote']>>, ParentType, ContextType, RequireFields<ProposalvotesArgs, 'skip' | 'first'>>;
  options?: Resolver<Maybe<Array<ResolversTypes['Option']>>, ParentType, ContextType, RequireFields<ProposaloptionsArgs, 'skip' | 'first'>>;
  snapshotId?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  executionTransactionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statesLog?: Resolver<Maybe<Array<ResolversTypes['ProposalStateLog']>>, ParentType, ContextType, RequireFields<ProposalstatesLogArgs, 'skip' | 'first'>>;
  scheme?: Resolver<ResolversTypes['Scheme'], ParentType, ContextType>;
  callData?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  totalOptions?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ProposalState']>, ParentType, ContextType>;
  descriptionHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  submittedTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  snapshot?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schemeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callbacks?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  votingMachineProposalState?: Resolver<Maybe<ResolversTypes['VotingMachineProposalState']>, ParentType, ContextType>;
  votingMachineExecutionState?: Resolver<Maybe<ResolversTypes['VotingMachineExecutionState']>, ParentType, ContextType>;
  winningVote?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  proposer?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentBoostedVotePeriodLimit?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  paramsHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  daoBounty?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  boostedPhaseTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  preBoostedPhaseTime?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  daoRedeemedWinnings?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stakes?: Resolver<Maybe<Array<ResolversTypes['Stake']>>, ParentType, ContextType, RequireFields<ProposalstakesArgs, 'skip' | 'first'>>;
  stateLogs?: Resolver<Maybe<Array<ResolversTypes['StateLog']>>, ParentType, ContextType, RequireFields<ProposalstateLogsArgs, 'skip' | 'first'>>;
  votingMachineProposalStateLogs?: Resolver<Maybe<Array<ResolversTypes['VotingMachineProposalStateLog']>>, ParentType, ContextType, RequireFields<ProposalvotingMachineProposalStateLogsArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ProposalStateLogResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ProposalStateLog'] = ResolversParentTypes['ProposalStateLog']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proposalId?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Token'] = ResolversParentTypes['Token']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  guildAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VoteResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Vote'] = ResolversParentTypes['Vote']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proposalId?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  option?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  optionId?: Resolver<ResolversTypes['Option'], ParentType, ContextType>;
  optionLabel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voter?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  votingPower?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  proposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  voterAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  member?: Resolver<Maybe<ResolversTypes['Member']>, ParentType, ContextType>;
  reputation?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  voteLogs?: Resolver<Maybe<Array<ResolversTypes['VoteLog']>>, ParentType, ContextType, RequireFields<VotevoteLogsArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type _Block_Resolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['_Block_'] = ResolversParentTypes['_Block_']> = ResolversObject<{
  hash?: Resolver<Maybe<ResolversTypes['Bytes']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type _Meta_Resolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['_Meta_'] = ResolversParentTypes['_Meta_']> = ResolversObject<{
  block?: Resolver<ResolversTypes['_Block_'], ParentType, ContextType>;
  deployment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasIndexingErrors?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DAOResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['DAO'] = ResolversParentTypes['DAO']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reputationToken?: Resolver<ResolversTypes['ReputationToken'], ParentType, ContextType>;
  controllerAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  schemes?: Resolver<Maybe<Array<ResolversTypes['Scheme']>>, ParentType, ContextType, RequireFields<DAOschemesArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PermissionResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Permission'] = ResolversParentTypes['Permission']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  functionSignature?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isToken?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  valueAllowed?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  fromTime?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  allowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RedeemResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Redeem'] = ResolversParentTypes['Redeem']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  avatar?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  redeemer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  txId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ReputationTokenResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['ReputationToken'] = ResolversParentTypes['ReputationToken']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  members?: Resolver<Maybe<Array<ResolversTypes['Member']>>, ParentType, ContextType, RequireFields<ReputationTokenmembersArgs, 'skip' | 'first'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  controllerAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  snapshots?: Resolver<Maybe<Array<ResolversTypes['Snapshot']>>, ParentType, ContextType, RequireFields<ReputationTokensnapshotsArgs, 'skip' | 'first'>>;
  currentSnapshotId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SchemeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Scheme'] = ResolversParentTypes['Scheme']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  avatar?: Resolver<ResolversTypes['DAO'], ParentType, ContextType>;
  votingMachine?: Resolver<ResolversTypes['VotingMachine'], ParentType, ContextType>;
  controller?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permissionRegistry?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maxRepPercentageChange?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  paramsHash?: Resolver<Maybe<ResolversTypes['Bytes']>, ParentType, ContextType>;
  isRegistered?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canManageSchemes?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canMakeAvatarCalls?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canChangeReputation?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  stakingTokenBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  voteGasBalance?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  voteGas?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  maxGasPrice?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  averagesDownstakesOfBoosted?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  orgBoostedProposalsCnt?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  proposals?: Resolver<Maybe<Array<ResolversTypes['Proposal']>>, ParentType, ContextType, RequireFields<SchemeproposalsArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SnapshotResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Snapshot'] = ResolversParentTypes['Snapshot']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  snapshotId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  reputationTokenSnapshot?: Resolver<ResolversTypes['ReputationToken'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StakeResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['Stake'] = ResolversParentTypes['Stake']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  proposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  avatar?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  staker?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  option?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  txId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type StateLogResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['StateLog'] = ResolversParentTypes['StateLog']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  txId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ProposalState'], ParentType, ContextType>;
  proposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VoteLogResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VoteLog'] = ResolversParentTypes['VoteLog']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reputation?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  txId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vote?: Resolver<ResolversTypes['Vote'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VoterSnapshotResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VoterSnapshot'] = ResolversParentTypes['VoterSnapshot']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  snapshotId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  voter?: Resolver<ResolversTypes['Member'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VotingMachineResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VotingMachine'] = ResolversParentTypes['VotingMachine']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  queuedVoteRequiredPercentage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  queuedVotePeriodLimit?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  boostedVotePeriodLimit?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  preBoostedVotePeriodLimit?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  thresholdConst?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  limitExponentValue?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  quietEndingPeriod?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  daoBounty?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  boostedVoteRequiredPercentage?: Resolver<Maybe<ResolversTypes['BigInt']>, ParentType, ContextType>;
  schemes?: Resolver<Maybe<Array<ResolversTypes['Scheme']>>, ParentType, ContextType, RequireFields<VotingMachineschemesArgs, 'skip' | 'first'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VotingMachineProposalStateLogResolvers<ContextType = MeshContext, ParentType extends ResolversParentTypes['VotingMachineProposalStateLog'] = ResolversParentTypes['VotingMachineProposalStateLog']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  txId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['VotingMachineProposalState'], ParentType, ContextType>;
  proposal?: Resolver<ResolversTypes['Proposal'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = MeshContext> = ResolversObject<{
  Query?: QueryResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  Action?: ActionResolvers<ContextType>;
  BigDecimal?: GraphQLScalarType;
  BigInt?: GraphQLScalarType;
  Bytes?: GraphQLScalarType;
  Guild?: GuildResolvers<ContextType>;
  GuildPermission?: GuildPermissionResolvers<ContextType>;
  Member?: MemberResolvers<ContextType>;
  Option?: OptionResolvers<ContextType>;
  Proposal?: ProposalResolvers<ContextType>;
  ProposalStateLog?: ProposalStateLogResolvers<ContextType>;
  Token?: TokenResolvers<ContextType>;
  Vote?: VoteResolvers<ContextType>;
  _Block_?: _Block_Resolvers<ContextType>;
  _Meta_?: _Meta_Resolvers<ContextType>;
  DAO?: DAOResolvers<ContextType>;
  Permission?: PermissionResolvers<ContextType>;
  Redeem?: RedeemResolvers<ContextType>;
  ReputationToken?: ReputationTokenResolvers<ContextType>;
  Scheme?: SchemeResolvers<ContextType>;
  Snapshot?: SnapshotResolvers<ContextType>;
  Stake?: StakeResolvers<ContextType>;
  StateLog?: StateLogResolvers<ContextType>;
  VoteLog?: VoteLogResolvers<ContextType>;
  VoterSnapshot?: VoterSnapshotResolvers<ContextType>;
  VotingMachine?: VotingMachineResolvers<ContextType>;
  VotingMachineProposalStateLog?: VotingMachineProposalStateLogResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = MeshContext> = ResolversObject<{
  entity?: entityDirectiveResolver<any, any, ContextType>;
  subgraphId?: subgraphIdDirectiveResolver<any, any, ContextType>;
  derivedFrom?: derivedFromDirectiveResolver<any, any, ContextType>;
}>;

export type MeshContext = GuildSubgraphTypes.Context & DaoSubgraphTypes.Context & BaseMeshContext;


import { fileURLToPath } from '@graphql-mesh/utils';
const baseDir = pathModule.join(pathModule.dirname(fileURLToPath(import.meta.url)), '..');

const importFn: ImportFn = <T>(moduleId: string) => {
  const relativeModuleId = (pathModule.isAbsolute(moduleId) ? pathModule.relative(baseDir, moduleId) : moduleId).split('\\').join('/').replace(baseDir + '/', '');
  switch(relativeModuleId) {
    case ".graphclient/sources/guild-subgraph/introspectionSchema":
      return import("./sources/guild-subgraph/introspectionSchema") as T;
    
    case ".graphclient/sources/dao-subgraph/introspectionSchema":
      return import("./sources/dao-subgraph/introspectionSchema") as T;
    
    default:
      return Promise.reject(new Error(`Cannot find module '${relativeModuleId}'.`));
  }
};

const rootStore = new MeshStore('.graphclient', new FsStoreStorageAdapter({
  cwd: baseDir,
  importFn,
  fileType: "ts",
}), {
  readonly: true,
  validate: false
});

export const rawServeConfig: YamlConfig.Config['serve'] = undefined as any
export async function getMeshOptions(): Promise<GetMeshOptions> {
const pubsub = new PubSub();
const sourcesStore = rootStore.child('sources');
const logger = new DefaultLogger("GraphClient");
const cache = new (MeshCache as any)({
      ...({} as any),
      importFn,
      store: rootStore.child('cache'),
      pubsub,
      logger,
    } as any)

const sources: MeshResolvedSource[] = [];
const transforms: MeshTransform[] = [];
const additionalEnvelopPlugins: MeshPlugin<any>[] = [];
const guildSubgraphTransforms = [];
const daoSubgraphTransforms = [];
const additionalTypeDefs = [] as any[];
const guildSubgraphHandler = new GraphqlHandler({
              name: "guild-subgraph",
              config: {"endpoint":"https://api.thegraph.com/subgraphs/name/dxgovernance/guild-subgraph-gnosis"},
              baseDir,
              cache,
              pubsub,
              store: sourcesStore.child("guild-subgraph"),
              logger: logger.child("guild-subgraph"),
              importFn,
            });
const daoSubgraphHandler = new GraphqlHandler({
              name: "dao-subgraph",
              config: {"endpoint":"https://api.thegraph.com/subgraphs/name/mprasanjith/dxgov-dao-subgraph-gnosis"},
              baseDir,
              cache,
              pubsub,
              store: sourcesStore.child("dao-subgraph"),
              logger: logger.child("dao-subgraph"),
              importFn,
            });
sources[0] = {
          name: 'guild-subgraph',
          handler: guildSubgraphHandler,
          transforms: guildSubgraphTransforms
        }
sources[1] = {
          name: 'dao-subgraph',
          handler: daoSubgraphHandler,
          transforms: daoSubgraphTransforms
        }
const additionalResolvers = [] as any[]
const merger = new(StitchingMerger as any)({
        cache,
        pubsub,
        logger: logger.child('stitchingMerger'),
        store: rootStore.child('stitchingMerger')
      })

  return {
    sources,
    transforms,
    additionalTypeDefs,
    additionalResolvers,
    cache,
    pubsub,
    merger,
    logger,
    additionalEnvelopPlugins,
    get documents() {
      return [
      {
        document: GetAllDaoPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllDaoPermissionsDocument);
        },
        location: 'GetAllDaoPermissionsDocument.graphql'
      },{
        document: GetAllDaoTokenPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllDaoTokenPermissionsDocument);
        },
        location: 'GetAllDaoTokenPermissionsDocument.graphql'
      },{
        document: GetAllDaoFunctionCallPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllDaoFunctionCallPermissionsDocument);
        },
        location: 'GetAllDaoFunctionCallPermissionsDocument.graphql'
      },{
        document: GetMemberList1_5Document,
        get rawSDL() {
          return printWithCache(GetMemberList1_5Document);
        },
        location: 'GetMemberList1_5Document.graphql'
      },{
        document: GetDaoNumberOfActiveProposalsDocument,
        get rawSDL() {
          return printWithCache(GetDaoNumberOfActiveProposalsDocument);
        },
        location: 'GetDaoNumberOfActiveProposalsDocument.graphql'
      },{
        document: GetPermissionDocument,
        get rawSDL() {
          return printWithCache(GetPermissionDocument);
        },
        location: 'GetPermissionDocument.graphql'
      },{
        document: GetSchemesDocument,
        get rawSDL() {
          return printWithCache(GetSchemesDocument);
        },
        location: 'GetSchemesDocument.graphql'
      },{
        document: GetVotingMachineBySchemeDocument,
        get rawSDL() {
          return printWithCache(GetVotingMachineBySchemeDocument);
        },
        location: 'GetVotingMachineBySchemeDocument.graphql'
      },{
        document: GetGuildConfig1_5Document,
        get rawSDL() {
          return printWithCache(GetGuildConfig1_5Document);
        },
        location: 'GetGuildConfig1_5Document.graphql'
      },{
        document: GetDaoProposalIdsDocument,
        get rawSDL() {
          return printWithCache(GetDaoProposalIdsDocument);
        },
        location: 'GetDaoProposalIdsDocument.graphql'
      },{
        document: GetDaoProposalDocument,
        get rawSDL() {
          return printWithCache(GetDaoProposalDocument);
        },
        location: 'GetDaoProposalDocument.graphql'
      },{
        document: GetDaoVotesOfVoterDocument,
        get rawSDL() {
          return printWithCache(GetDaoVotesOfVoterDocument);
        },
        location: 'GetDaoVotesOfVoterDocument.graphql'
      },{
        document: GetProposalSnapshotIdDocument,
        get rawSDL() {
          return printWithCache(GetProposalSnapshotIdDocument);
        },
        location: 'GetProposalSnapshotIdDocument.graphql'
      },{
        document: GetTotalLockedDocument,
        get rawSDL() {
          return printWithCache(GetTotalLockedDocument);
        },
        location: 'GetTotalLockedDocument.graphql'
      },{
        document: GetVotingPowerOfDocument,
        get rawSDL() {
          return printWithCache(GetVotingPowerOfDocument);
        },
        location: 'GetVotingPowerOfDocument.graphql'
      },{
        document: GetVotingPowerOfAtDocument,
        get rawSDL() {
          return printWithCache(GetVotingPowerOfAtDocument);
        },
        location: 'GetVotingPowerOfAtDocument.graphql'
      },{
        document: GetAllPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllPermissionsDocument);
        },
        location: 'GetAllPermissionsDocument.graphql'
      },{
        document: GetAllTokenPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllTokenPermissionsDocument);
        },
        location: 'GetAllTokenPermissionsDocument.graphql'
      },{
        document: GetAllFunctionCallPermissionsDocument,
        get rawSDL() {
          return printWithCache(GetAllFunctionCallPermissionsDocument);
        },
        location: 'GetAllFunctionCallPermissionsDocument.graphql'
      },{
        document: GetMemberListDocument,
        get rawSDL() {
          return printWithCache(GetMemberListDocument);
        },
        location: 'GetMemberListDocument.graphql'
      },{
        document: GetNumberOfActiveProposalsDocument,
        get rawSDL() {
          return printWithCache(GetNumberOfActiveProposalsDocument);
        },
        location: 'GetNumberOfActiveProposalsDocument.graphql'
      },{
        document: GetVotesDocument,
        get rawSDL() {
          return printWithCache(GetVotesDocument);
        },
        location: 'GetVotesDocument.graphql'
      },{
        document: GetGuildConfigDocument,
        get rawSDL() {
          return printWithCache(GetGuildConfigDocument);
        },
        location: 'GetGuildConfigDocument.graphql'
      },{
        document: GetGuildProposalIdsDocument,
        get rawSDL() {
          return printWithCache(GetGuildProposalIdsDocument);
        },
        location: 'GetGuildProposalIdsDocument.graphql'
      },{
        document: GetProposalDocument,
        get rawSDL() {
          return printWithCache(GetProposalDocument);
        },
        location: 'GetProposalDocument.graphql'
      },{
        document: GetProposalVotesOfVoterDocument,
        get rawSDL() {
          return printWithCache(GetProposalVotesOfVoterDocument);
        },
        location: 'GetProposalVotesOfVoterDocument.graphql'
      }
    ];
    },
    fetchFn,
  };
}

export function createBuiltMeshHTTPHandler(): MeshHTTPHandler<MeshContext> {
  return createMeshHTTPHandler<MeshContext>({
    baseDir,
    getBuiltMesh: getBuiltGraphClient,
    rawServeConfig: undefined,
  })
}


let meshInstance$: Promise<MeshInstance> | undefined;

export function getBuiltGraphClient(): Promise<MeshInstance> {
  if (meshInstance$ == null) {
    meshInstance$ = getMeshOptions().then(meshOptions => getMesh(meshOptions)).then(mesh => {
      const id = mesh.pubsub.subscribe('destroy', () => {
        meshInstance$ = undefined;
        mesh.pubsub.unsubscribe(id);
      });
      return mesh;
    });
  }
  return meshInstance$;
}

export const execute: ExecuteMeshFn = (...args) => getBuiltGraphClient().then(({ execute }) => execute(...args));

export const subscribe: SubscribeMeshFn = (...args) => getBuiltGraphClient().then(({ subscribe }) => subscribe(...args));
export function getBuiltGraphSDK<TGlobalContext = any, TOperationContext = any>(globalContext?: TGlobalContext) {
  const sdkRequester$ = getBuiltGraphClient().then(({ sdkRequesterFactory }) => sdkRequesterFactory(globalContext));
  return getSdk<TOperationContext, TGlobalContext>((...args) => sdkRequester$.then(sdkRequester => sdkRequester(...args)));
}
export type getAllDaoPermissionsQueryVariables = Exact<{
  from: Scalars['String'];
}>;


export type getAllDaoPermissionsQuery = { permissions: Array<Pick<Permission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> };

export type getAllDaoTokenPermissionsQueryVariables = Exact<{
  from: Scalars['String'];
}>;


export type getAllDaoTokenPermissionsQuery = { permissions: Array<Pick<Permission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> };

export type getAllDaoFunctionCallPermissionsQueryVariables = Exact<{
  from: Scalars['String'];
}>;


export type getAllDaoFunctionCallPermissionsQuery = { permissions: Array<Pick<Permission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> };

export type getMemberList1_5QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getMemberList1_5Query = { dao?: Maybe<{ reputationToken: (
      Pick<ReputationToken, 'id'>
      & { members?: Maybe<Array<Pick<Member, 'id' | 'address' | 'reputationTokenAmount'>>> }
    ) }> };

export type getDaoNumberOfActiveProposalsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getDaoNumberOfActiveProposalsQuery = { dao?: Maybe<{ schemes?: Maybe<Array<{ proposals?: Maybe<Array<Pick<Proposal, 'id'>>> }>> }> };

export type getPermissionQueryVariables = Exact<{
  from: Scalars['String'];
  to: Scalars['String'];
  functionSignature: Scalars['String'];
}>;


export type getPermissionQuery = { permissions: Array<Pick<Permission, 'id' | 'valueAllowed' | 'fromTime'>> };

export type getSchemesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getSchemesQuery = { dao?: Maybe<{ schemes?: Maybe<Array<(
      Pick<Scheme, 'id' | 'name' | 'averagesDownstakesOfBoosted' | 'controller' | 'isRegistered' | 'orgBoostedProposalsCnt' | 'paramsHash' | 'permissionRegistry' | 'stakingTokenBalance' | 'canChangeReputation' | 'canMakeAvatarCalls' | 'canManageSchemes' | 'maxGasPrice' | 'maxRepPercentageChange' | 'type' | 'voteGas' | 'voteGasBalance'>
      & { votingMachine: Pick<VotingMachine, 'boostedVoteRequiredPercentage' | 'preBoostedVotePeriodLimit' | 'boostedVotePeriodLimit' | 'quietEndingPeriod'> }
    )>> }> };

export type getVotingMachineBySchemeQueryVariables = Exact<{
  schemeAddress: Scalars['ID'];
}>;


export type getVotingMachineBySchemeQuery = { scheme?: Maybe<{ votingMachine: Pick<VotingMachine, 'id'> }> };

export type getGuildConfig1_5QueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getGuildConfig1_5Query = { dao?: Maybe<(
    Pick<DAO, 'id'>
    & { reputationToken: Pick<ReputationToken, 'id' | 'address' | 'name'> }
  )> };

export type getDaoProposalIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getDaoProposalIdsQuery = { dao?: Maybe<{ schemes?: Maybe<Array<{ proposals?: Maybe<Array<Pick<Proposal, 'id'>>> }>> }> };

export type getDaoProposalQueryVariables = Exact<{
  id: Scalars['ID'];
  proposalId: Scalars['ID'];
}>;


export type getDaoProposalQuery = { dao?: Maybe<{ schemes?: Maybe<Array<{ proposals?: Maybe<Array<Pick<Proposal, 'boostedPhaseTime' | 'callData' | 'callbacks' | 'currentBoostedVotePeriodLimit' | 'daoBounty' | 'id' | 'paramsHash' | 'descriptionHash' | 'preBoostedPhaseTime' | 'proposer' | 'schemeId' | 'state' | 'submittedTime' | 'title' | 'to' | 'totalOptions' | 'value' | 'votingMachineExecutionState' | 'votingMachineProposalState' | 'winningVote' | 'totalVotes' | 'daoRedeemedWinnings'>>> }>> }> };

export type getDaoVotesOfVoterQueryVariables = Exact<{
  id: Scalars['ID'];
  proposalId: Scalars['ID'];
  userAddress: Scalars['String'];
}>;


export type getDaoVotesOfVoterQuery = { dao?: Maybe<{ schemes?: Maybe<Array<{ proposals?: Maybe<Array<(
        Pick<Proposal, 'id'>
        & { votes?: Maybe<Array<Pick<Vote, 'id' | 'option' | 'reputation' | 'voterAddress'>>> }
      )>> }>> }> };

export type getProposalSnapshotIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getProposalSnapshotIdQuery = { proposal?: Maybe<Pick<Proposal, 'id' | 'snapshot'>> };

export type getTotalLockedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getTotalLockedQuery = { dao?: Maybe<(
    Pick<DAO, 'id'>
    & { reputationToken: Pick<ReputationToken, 'id' | 'amount'> }
  )> };

export type getVotingPowerOfQueryVariables = Exact<{
  id: Scalars['ID'];
  userAddress: Scalars['String'];
}>;


export type getVotingPowerOfQuery = { dao?: Maybe<(
    Pick<DAO, 'id'>
    & { reputationToken: (
      Pick<ReputationToken, 'id' | 'currentSnapshotId'>
      & { members?: Maybe<Array<Pick<Member, 'reputationTokenAmount'>>> }
    ) }
  )> };

export type getVotingPowerOfAtQueryVariables = Exact<{
  id: Scalars['ID'];
  userAddress: Scalars['String'];
}>;


export type getVotingPowerOfAtQuery = { dao?: Maybe<(
    Pick<DAO, 'id'>
    & { reputationToken: (
      Pick<ReputationToken, 'id' | 'currentSnapshotId'>
      & { members?: Maybe<Array<(
        Pick<Member, 'reputationTokenAmount'>
        & { snapshots?: Maybe<Array<Pick<VoterSnapshot, 'id' | 'snapshotId' | 'value'>>> }
      )>> }
    ) }
  )> };

export type getAllPermissionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getAllPermissionsQuery = { guild?: Maybe<{ permissions: Array<Pick<GuildPermission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> }> };

export type getAllTokenPermissionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getAllTokenPermissionsQuery = { guild?: Maybe<{ permissions: Array<Pick<GuildPermission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> }> };

export type getAllFunctionCallPermissionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getAllFunctionCallPermissionsQuery = { guild?: Maybe<{ permissions: Array<Pick<GuildPermission, 'id' | 'isToken' | 'to' | 'valueAllowed' | 'from' | 'fromTime' | 'functionSignature' | 'allowed'>> }> };

export type getMemberListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getMemberListQuery = { guild?: Maybe<{ members?: Maybe<Array<Pick<Member, 'id' | 'address' | 'tokensLocked'>>> }> };

export type getNumberOfActiveProposalsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getNumberOfActiveProposalsQuery = { guild?: Maybe<(
    Pick<Guild, 'id' | 'name'>
    & { proposals?: Maybe<Array<Pick<Proposal, 'id'>>> }
  )>, _meta?: Maybe<{ block: Pick<_Block_, 'number'> }> };

export type getVotesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getVotesQuery = { proposal?: Maybe<{ votes?: Maybe<Array<Pick<Vote, 'voter' | 'votingPower' | 'optionLabel' | 'option'>>> }>, _meta?: Maybe<{ block: Pick<_Block_, 'number'> }> };

export type getGuildConfigQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getGuildConfigQuery = { guild?: Maybe<(
    Pick<Guild, 'id' | 'name' | 'permissionRegistry' | 'proposalTime' | 'timeForExecution' | 'maxActiveProposals' | 'votingPowerForProposalCreation' | 'votingPowerPercentageForProposalExecution' | 'votingPowerPercentageForProposalCreation' | 'lockTime' | 'voteGas' | 'maxGasPrice' | 'minimumMembersForProposalCreation' | 'minimumTokensLockedForProposalCreation'>
    & { token?: Maybe<Pick<Token, 'id'>> }
  )> };

export type getGuildProposalIdsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type getGuildProposalIdsQuery = { guild?: Maybe<{ proposals?: Maybe<Array<Pick<Proposal, 'id'>>> }> };

export type getProposalQueryVariables = Exact<{
  id: Scalars['ID'];
  proposalId: Scalars['ID'];
}>;


export type getProposalQuery = { guild?: Maybe<{ proposals?: Maybe<Array<(
      Pick<Proposal, 'contentHash' | 'contractState' | 'creator' | 'data' | 'description' | 'endTime' | 'executionTransactionHash' | 'id' | 'metadata' | 'startTime' | 'title' | 'to' | 'totalVotes' | 'value'>
      & { votes?: Maybe<Array<Pick<Vote, 'voter' | 'votingPower' | 'optionLabel' | 'option'>>> }
    )>> }>, _meta?: Maybe<{ block: Pick<_Block_, 'number'> }> };

export type getProposalVotesOfVoterQueryVariables = Exact<{
  proposalId: Scalars['ID'];
  userAddress: Scalars['String'];
}>;


export type getProposalVotesOfVoterQuery = { proposal?: Maybe<{ votes?: Maybe<Array<Pick<Vote, 'option' | 'votingPower'>>> }>, _meta?: Maybe<{ block: Pick<_Block_, 'number'> }> };


export const getAllDaoPermissionsDocument = gql`
    query getAllDaoPermissions($from: String!) {
  permissions(where: {from: $from}) {
    id
    isToken
    to
    valueAllowed
    from
    fromTime
    functionSignature
    allowed
  }
}
    ` as unknown as DocumentNode<getAllDaoPermissionsQuery, getAllDaoPermissionsQueryVariables>;
export const getAllDaoTokenPermissionsDocument = gql`
    query getAllDaoTokenPermissions($from: String!) {
  permissions(where: {isToken: true, from: $from}) {
    id
    isToken
    to
    valueAllowed
    from
    fromTime
    functionSignature
    allowed
  }
}
    ` as unknown as DocumentNode<getAllDaoTokenPermissionsQuery, getAllDaoTokenPermissionsQueryVariables>;
export const getAllDaoFunctionCallPermissionsDocument = gql`
    query getAllDaoFunctionCallPermissions($from: String!) {
  permissions(where: {isToken: false, from: $from}) {
    id
    isToken
    to
    valueAllowed
    from
    fromTime
    functionSignature
    allowed
  }
}
    ` as unknown as DocumentNode<getAllDaoFunctionCallPermissionsQuery, getAllDaoFunctionCallPermissionsQueryVariables>;
export const getMemberList1_5Document = gql`
    query getMemberList1_5($id: ID!) {
  dao(id: $id) {
    reputationToken {
      id
      members {
        id
        address
        reputationTokenAmount
      }
    }
  }
}
    ` as unknown as DocumentNode<getMemberList1_5Query, getMemberList1_5QueryVariables>;
export const getDaoNumberOfActiveProposalsDocument = gql`
    query getDaoNumberOfActiveProposals($id: ID!) {
  dao(id: $id) {
    schemes {
      proposals(where: {state: Submitted}) {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<getDaoNumberOfActiveProposalsQuery, getDaoNumberOfActiveProposalsQueryVariables>;
export const getPermissionDocument = gql`
    query getPermission($from: String!, $to: String!, $functionSignature: String!) {
  permissions(
    where: {from: $from, to: $to, functionSignature: $functionSignature}
  ) {
    id
    valueAllowed
    fromTime
  }
}
    ` as unknown as DocumentNode<getPermissionQuery, getPermissionQueryVariables>;
export const getSchemesDocument = gql`
    query getSchemes($id: ID!) {
  dao(id: $id) {
    schemes {
      id
      name
      averagesDownstakesOfBoosted
      controller
      isRegistered
      orgBoostedProposalsCnt
      paramsHash
      permissionRegistry
      stakingTokenBalance
      canChangeReputation
      canMakeAvatarCalls
      canManageSchemes
      maxGasPrice
      maxRepPercentageChange
      type
      voteGas
      voteGasBalance
      votingMachine {
        boostedVoteRequiredPercentage
        preBoostedVotePeriodLimit
        boostedVotePeriodLimit
        quietEndingPeriod
      }
    }
  }
}
    ` as unknown as DocumentNode<getSchemesQuery, getSchemesQueryVariables>;
export const getVotingMachineBySchemeDocument = gql`
    query getVotingMachineByScheme($schemeAddress: ID!) {
  scheme(id: $schemeAddress) {
    votingMachine {
      id
    }
  }
}
    ` as unknown as DocumentNode<getVotingMachineBySchemeQuery, getVotingMachineBySchemeQueryVariables>;
export const getGuildConfig1_5Document = gql`
    query getGuildConfig1_5($id: ID!) {
  dao(id: $id) {
    id
    reputationToken {
      id
      address
      name
    }
  }
}
    ` as unknown as DocumentNode<getGuildConfig1_5Query, getGuildConfig1_5QueryVariables>;
export const getDaoProposalIdsDocument = gql`
    query getDaoProposalIds($id: ID!) {
  dao(id: $id) {
    schemes {
      proposals {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<getDaoProposalIdsQuery, getDaoProposalIdsQueryVariables>;
export const getDaoProposalDocument = gql`
    query getDaoProposal($id: ID!, $proposalId: ID!) {
  dao(id: $id) {
    schemes {
      proposals(where: {id: $proposalId}) {
        boostedPhaseTime
        callData
        callbacks
        currentBoostedVotePeriodLimit
        daoBounty
        id
        paramsHash
        descriptionHash
        preBoostedPhaseTime
        proposer
        schemeId
        state
        submittedTime
        title
        to
        totalOptions
        value
        votingMachineExecutionState
        votingMachineProposalState
        winningVote
        totalVotes
        daoRedeemedWinnings
      }
    }
  }
}
    ` as unknown as DocumentNode<getDaoProposalQuery, getDaoProposalQueryVariables>;
export const getDaoVotesOfVoterDocument = gql`
    query getDaoVotesOfVoter($id: ID!, $proposalId: ID!, $userAddress: String!) {
  dao(id: $id) {
    schemes {
      proposals(where: {id: $proposalId}) {
        id
        votes(where: {voterAddress: $userAddress}) {
          id
          option
          reputation
          voterAddress
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<getDaoVotesOfVoterQuery, getDaoVotesOfVoterQueryVariables>;
export const getProposalSnapshotIdDocument = gql`
    query getProposalSnapshotId($id: ID!) {
  proposal(id: $id) {
    id
    snapshot
  }
}
    ` as unknown as DocumentNode<getProposalSnapshotIdQuery, getProposalSnapshotIdQueryVariables>;
export const getTotalLockedDocument = gql`
    query getTotalLocked($id: ID!) {
  dao(id: $id) {
    id
    reputationToken {
      id
      amount
    }
  }
}
    ` as unknown as DocumentNode<getTotalLockedQuery, getTotalLockedQueryVariables>;
export const getVotingPowerOfDocument = gql`
    query getVotingPowerOf($id: ID!, $userAddress: String!) {
  dao(id: $id) {
    id
    reputationToken {
      id
      currentSnapshotId
      members(where: {address: $userAddress}) {
        reputationTokenAmount
      }
    }
  }
}
    ` as unknown as DocumentNode<getVotingPowerOfQuery, getVotingPowerOfQueryVariables>;
export const getVotingPowerOfAtDocument = gql`
    query getVotingPowerOfAt($id: ID!, $userAddress: String!) {
  dao(id: $id) {
    id
    reputationToken {
      id
      currentSnapshotId
      members(where: {address: $userAddress}) {
        reputationTokenAmount
        snapshots {
          id
          snapshotId
          value
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<getVotingPowerOfAtQuery, getVotingPowerOfAtQueryVariables>;
export const getAllPermissionsDocument = gql`
    query getAllPermissions($id: ID!) {
  guild(id: $id) {
    permissions {
      id
      isToken
      to
      valueAllowed
      from
      fromTime
      functionSignature
      allowed
    }
  }
}
    ` as unknown as DocumentNode<getAllPermissionsQuery, getAllPermissionsQueryVariables>;
export const getAllTokenPermissionsDocument = gql`
    query getAllTokenPermissions($id: ID!) {
  guild(id: $id) {
    permissions(where: {isToken: true}) {
      id
      isToken
      to
      valueAllowed
      from
      fromTime
      functionSignature
      allowed
    }
  }
}
    ` as unknown as DocumentNode<getAllTokenPermissionsQuery, getAllTokenPermissionsQueryVariables>;
export const getAllFunctionCallPermissionsDocument = gql`
    query getAllFunctionCallPermissions($id: ID!) {
  guild(id: $id) {
    permissions(where: {isToken: false}) {
      id
      isToken
      to
      valueAllowed
      from
      fromTime
      functionSignature
      allowed
    }
  }
}
    ` as unknown as DocumentNode<getAllFunctionCallPermissionsQuery, getAllFunctionCallPermissionsQueryVariables>;
export const getMemberListDocument = gql`
    query getMemberList($id: ID!) {
  guild(id: $id) {
    members(where: {tokensLocked_gt: "0"}) {
      id
      address
      tokensLocked
    }
  }
}
    ` as unknown as DocumentNode<getMemberListQuery, getMemberListQueryVariables>;
export const getNumberOfActiveProposalsDocument = gql`
    query getNumberOfActiveProposals($id: ID!) {
  guild(id: $id) {
    id
    name
    proposals(where: {contractState: 1}) {
      id
    }
  }
  _meta {
    block {
      number
    }
  }
}
    ` as unknown as DocumentNode<getNumberOfActiveProposalsQuery, getNumberOfActiveProposalsQueryVariables>;
export const getVotesDocument = gql`
    query getVotes($id: ID!) {
  proposal(id: $id) {
    votes {
      voter
      votingPower
      optionLabel
      option
    }
  }
  _meta {
    block {
      number
    }
  }
}
    ` as unknown as DocumentNode<getVotesQuery, getVotesQueryVariables>;
export const getGuildConfigDocument = gql`
    query getGuildConfig($id: ID!) {
  guild(id: $id) {
    id
    name
    token {
      id
    }
    permissionRegistry
    proposalTime
    timeForExecution
    maxActiveProposals
    votingPowerForProposalCreation
    votingPowerPercentageForProposalExecution
    votingPowerPercentageForProposalCreation
    lockTime
    voteGas
    maxGasPrice
    minimumMembersForProposalCreation
    minimumTokensLockedForProposalCreation
  }
}
    ` as unknown as DocumentNode<getGuildConfigQuery, getGuildConfigQueryVariables>;
export const getGuildProposalIdsDocument = gql`
    query getGuildProposalIds($id: ID!) {
  guild(id: $id) {
    proposals(orderBy: startTime, orderDirection: asc) {
      id
    }
  }
}
    ` as unknown as DocumentNode<getGuildProposalIdsQuery, getGuildProposalIdsQueryVariables>;
export const getProposalDocument = gql`
    query getProposal($id: ID!, $proposalId: ID!) {
  guild(id: $id) {
    proposals(where: {id: $proposalId}) {
      contentHash
      contractState
      creator
      data
      description
      endTime
      executionTransactionHash
      id
      metadata
      startTime
      title
      to
      totalVotes
      value
      votes {
        voter
        votingPower
        optionLabel
        option
      }
    }
  }
  _meta {
    block {
      number
    }
  }
}
    ` as unknown as DocumentNode<getProposalQuery, getProposalQueryVariables>;
export const getProposalVotesOfVoterDocument = gql`
    query getProposalVotesOfVoter($proposalId: ID!, $userAddress: String!) {
  proposal(id: $proposalId) {
    votes(where: {voter: $userAddress}) {
      option
      votingPower
    }
  }
  _meta {
    block {
      number
    }
  }
}
    ` as unknown as DocumentNode<getProposalVotesOfVoterQuery, getProposalVotesOfVoterQueryVariables>;



























export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    getAllDaoPermissions(variables: getAllDaoPermissionsQueryVariables, options?: C): Promise<getAllDaoPermissionsQuery> {
      return requester<getAllDaoPermissionsQuery, getAllDaoPermissionsQueryVariables>(getAllDaoPermissionsDocument, variables, options) as Promise<getAllDaoPermissionsQuery>;
    },
    getAllDaoTokenPermissions(variables: getAllDaoTokenPermissionsQueryVariables, options?: C): Promise<getAllDaoTokenPermissionsQuery> {
      return requester<getAllDaoTokenPermissionsQuery, getAllDaoTokenPermissionsQueryVariables>(getAllDaoTokenPermissionsDocument, variables, options) as Promise<getAllDaoTokenPermissionsQuery>;
    },
    getAllDaoFunctionCallPermissions(variables: getAllDaoFunctionCallPermissionsQueryVariables, options?: C): Promise<getAllDaoFunctionCallPermissionsQuery> {
      return requester<getAllDaoFunctionCallPermissionsQuery, getAllDaoFunctionCallPermissionsQueryVariables>(getAllDaoFunctionCallPermissionsDocument, variables, options) as Promise<getAllDaoFunctionCallPermissionsQuery>;
    },
    getMemberList1_5(variables: getMemberList1_5QueryVariables, options?: C): Promise<getMemberList1_5Query> {
      return requester<getMemberList1_5Query, getMemberList1_5QueryVariables>(getMemberList1_5Document, variables, options) as Promise<getMemberList1_5Query>;
    },
    getDaoNumberOfActiveProposals(variables: getDaoNumberOfActiveProposalsQueryVariables, options?: C): Promise<getDaoNumberOfActiveProposalsQuery> {
      return requester<getDaoNumberOfActiveProposalsQuery, getDaoNumberOfActiveProposalsQueryVariables>(getDaoNumberOfActiveProposalsDocument, variables, options) as Promise<getDaoNumberOfActiveProposalsQuery>;
    },
    getPermission(variables: getPermissionQueryVariables, options?: C): Promise<getPermissionQuery> {
      return requester<getPermissionQuery, getPermissionQueryVariables>(getPermissionDocument, variables, options) as Promise<getPermissionQuery>;
    },
    getSchemes(variables: getSchemesQueryVariables, options?: C): Promise<getSchemesQuery> {
      return requester<getSchemesQuery, getSchemesQueryVariables>(getSchemesDocument, variables, options) as Promise<getSchemesQuery>;
    },
    getVotingMachineByScheme(variables: getVotingMachineBySchemeQueryVariables, options?: C): Promise<getVotingMachineBySchemeQuery> {
      return requester<getVotingMachineBySchemeQuery, getVotingMachineBySchemeQueryVariables>(getVotingMachineBySchemeDocument, variables, options) as Promise<getVotingMachineBySchemeQuery>;
    },
    getGuildConfig1_5(variables: getGuildConfig1_5QueryVariables, options?: C): Promise<getGuildConfig1_5Query> {
      return requester<getGuildConfig1_5Query, getGuildConfig1_5QueryVariables>(getGuildConfig1_5Document, variables, options) as Promise<getGuildConfig1_5Query>;
    },
    getDaoProposalIds(variables: getDaoProposalIdsQueryVariables, options?: C): Promise<getDaoProposalIdsQuery> {
      return requester<getDaoProposalIdsQuery, getDaoProposalIdsQueryVariables>(getDaoProposalIdsDocument, variables, options) as Promise<getDaoProposalIdsQuery>;
    },
    getDaoProposal(variables: getDaoProposalQueryVariables, options?: C): Promise<getDaoProposalQuery> {
      return requester<getDaoProposalQuery, getDaoProposalQueryVariables>(getDaoProposalDocument, variables, options) as Promise<getDaoProposalQuery>;
    },
    getDaoVotesOfVoter(variables: getDaoVotesOfVoterQueryVariables, options?: C): Promise<getDaoVotesOfVoterQuery> {
      return requester<getDaoVotesOfVoterQuery, getDaoVotesOfVoterQueryVariables>(getDaoVotesOfVoterDocument, variables, options) as Promise<getDaoVotesOfVoterQuery>;
    },
    getProposalSnapshotId(variables: getProposalSnapshotIdQueryVariables, options?: C): Promise<getProposalSnapshotIdQuery> {
      return requester<getProposalSnapshotIdQuery, getProposalSnapshotIdQueryVariables>(getProposalSnapshotIdDocument, variables, options) as Promise<getProposalSnapshotIdQuery>;
    },
    getTotalLocked(variables: getTotalLockedQueryVariables, options?: C): Promise<getTotalLockedQuery> {
      return requester<getTotalLockedQuery, getTotalLockedQueryVariables>(getTotalLockedDocument, variables, options) as Promise<getTotalLockedQuery>;
    },
    getVotingPowerOf(variables: getVotingPowerOfQueryVariables, options?: C): Promise<getVotingPowerOfQuery> {
      return requester<getVotingPowerOfQuery, getVotingPowerOfQueryVariables>(getVotingPowerOfDocument, variables, options) as Promise<getVotingPowerOfQuery>;
    },
    getVotingPowerOfAt(variables: getVotingPowerOfAtQueryVariables, options?: C): Promise<getVotingPowerOfAtQuery> {
      return requester<getVotingPowerOfAtQuery, getVotingPowerOfAtQueryVariables>(getVotingPowerOfAtDocument, variables, options) as Promise<getVotingPowerOfAtQuery>;
    },
    getAllPermissions(variables: getAllPermissionsQueryVariables, options?: C): Promise<getAllPermissionsQuery> {
      return requester<getAllPermissionsQuery, getAllPermissionsQueryVariables>(getAllPermissionsDocument, variables, options) as Promise<getAllPermissionsQuery>;
    },
    getAllTokenPermissions(variables: getAllTokenPermissionsQueryVariables, options?: C): Promise<getAllTokenPermissionsQuery> {
      return requester<getAllTokenPermissionsQuery, getAllTokenPermissionsQueryVariables>(getAllTokenPermissionsDocument, variables, options) as Promise<getAllTokenPermissionsQuery>;
    },
    getAllFunctionCallPermissions(variables: getAllFunctionCallPermissionsQueryVariables, options?: C): Promise<getAllFunctionCallPermissionsQuery> {
      return requester<getAllFunctionCallPermissionsQuery, getAllFunctionCallPermissionsQueryVariables>(getAllFunctionCallPermissionsDocument, variables, options) as Promise<getAllFunctionCallPermissionsQuery>;
    },
    getMemberList(variables: getMemberListQueryVariables, options?: C): Promise<getMemberListQuery> {
      return requester<getMemberListQuery, getMemberListQueryVariables>(getMemberListDocument, variables, options) as Promise<getMemberListQuery>;
    },
    getNumberOfActiveProposals(variables: getNumberOfActiveProposalsQueryVariables, options?: C): Promise<getNumberOfActiveProposalsQuery> {
      return requester<getNumberOfActiveProposalsQuery, getNumberOfActiveProposalsQueryVariables>(getNumberOfActiveProposalsDocument, variables, options) as Promise<getNumberOfActiveProposalsQuery>;
    },
    getVotes(variables: getVotesQueryVariables, options?: C): Promise<getVotesQuery> {
      return requester<getVotesQuery, getVotesQueryVariables>(getVotesDocument, variables, options) as Promise<getVotesQuery>;
    },
    getGuildConfig(variables: getGuildConfigQueryVariables, options?: C): Promise<getGuildConfigQuery> {
      return requester<getGuildConfigQuery, getGuildConfigQueryVariables>(getGuildConfigDocument, variables, options) as Promise<getGuildConfigQuery>;
    },
    getGuildProposalIds(variables: getGuildProposalIdsQueryVariables, options?: C): Promise<getGuildProposalIdsQuery> {
      return requester<getGuildProposalIdsQuery, getGuildProposalIdsQueryVariables>(getGuildProposalIdsDocument, variables, options) as Promise<getGuildProposalIdsQuery>;
    },
    getProposal(variables: getProposalQueryVariables, options?: C): Promise<getProposalQuery> {
      return requester<getProposalQuery, getProposalQueryVariables>(getProposalDocument, variables, options) as Promise<getProposalQuery>;
    },
    getProposalVotesOfVoter(variables: getProposalVotesOfVoterQueryVariables, options?: C): Promise<getProposalVotesOfVoterQuery> {
      return requester<getProposalVotesOfVoterQuery, getProposalVotesOfVoterQueryVariables>(getProposalVotesOfVoterDocument, variables, options) as Promise<getProposalVotesOfVoterQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;